
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1ff2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1ff2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
'use strict';
parcelRequire("4yvvI");

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$g = 60103;
$0014624a040e5105$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0014624a040e5105$var$h = Symbol.for;
    $0014624a040e5105$var$g = $0014624a040e5105$var$h("react.element");
    $0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$h("react.fragment");
}
var $0014624a040e5105$var$m = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$n = Object.prototype.hasOwnProperty, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0014624a040e5105$var$n.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0014624a040e5105$var$m.current
    };
}
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("4yvvI", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $3512c7c00a4083d8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3512c7c00a4083d8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $3512c7c00a4083d8$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $3512c7c00a4083d8$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $3512c7c00a4083d8$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $3512c7c00a4083d8$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $3512c7c00a4083d8$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($3512c7c00a4083d8$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($3512c7c00a4083d8$var$getOwnPropertySymbols) {
            symbols = $3512c7c00a4083d8$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($3512c7c00a4083d8$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("bh6RR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$83d89fbfd8236492;
'use strict';

var $4yvvI = parcelRequire("4yvvI");
var $92f4fea5bc247620$var$n = 60103, $92f4fea5bc247620$var$p = 60106;
$92f4fea5bc247620$export$ffb0004e005737fa = 60107;
$92f4fea5bc247620$export$5f8d39834fd61797 = 60108;
$92f4fea5bc247620$export$e2c29f18771995cb = 60114;
var $92f4fea5bc247620$var$q = 60109, $92f4fea5bc247620$var$r = 60110, $92f4fea5bc247620$var$t = 60112;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = 60113;
var $92f4fea5bc247620$var$u = 60115, $92f4fea5bc247620$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $92f4fea5bc247620$var$w = Symbol.for;
    $92f4fea5bc247620$var$n = $92f4fea5bc247620$var$w("react.element");
    $92f4fea5bc247620$var$p = $92f4fea5bc247620$var$w("react.portal");
    $92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$w("react.fragment");
    $92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$w("react.strict_mode");
    $92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$w("react.profiler");
    $92f4fea5bc247620$var$q = $92f4fea5bc247620$var$w("react.provider");
    $92f4fea5bc247620$var$r = $92f4fea5bc247620$var$w("react.context");
    $92f4fea5bc247620$var$t = $92f4fea5bc247620$var$w("react.forward_ref");
    $92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w("react.suspense");
    $92f4fea5bc247620$var$u = $92f4fea5bc247620$var$w("react.memo");
    $92f4fea5bc247620$var$v = $92f4fea5bc247620$var$w("react.lazy");
}
var $92f4fea5bc247620$var$x = "function" === typeof Symbol && Symbol.iterator;
function $92f4fea5bc247620$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$x && a[$92f4fea5bc247620$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $92f4fea5bc247620$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $92f4fea5bc247620$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$B = {};
function $92f4fea5bc247620$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$B;
    this.updater = c || $92f4fea5bc247620$var$A;
}
$92f4fea5bc247620$var$C.prototype.isReactComponent = {};
$92f4fea5bc247620$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($92f4fea5bc247620$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$D() {}
$92f4fea5bc247620$var$D.prototype = $92f4fea5bc247620$var$C.prototype;
function $92f4fea5bc247620$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$B;
    this.updater = c || $92f4fea5bc247620$var$A;
}
var $92f4fea5bc247620$var$F = $92f4fea5bc247620$var$E.prototype = new $92f4fea5bc247620$var$D;
$92f4fea5bc247620$var$F.constructor = $92f4fea5bc247620$var$E;
$4yvvI($92f4fea5bc247620$var$F, $92f4fea5bc247620$var$C.prototype);
$92f4fea5bc247620$var$F.isPureReactComponent = !0;
var $92f4fea5bc247620$var$G = {
    current: null
}, $92f4fea5bc247620$var$H = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$H.call(b, e) && !$92f4fea5bc247620$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $92f4fea5bc247620$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $92f4fea5bc247620$var$G.current
    };
}
function $92f4fea5bc247620$var$K(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$n;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$M = /\/+/g;
function $92f4fea5bc247620$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$n:
                case $92f4fea5bc247620$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $92f4fea5bc247620$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($92f4fea5bc247620$var$M, "$&/") + "/"), $92f4fea5bc247620$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($92f4fea5bc247620$var$L(d) && (d = $92f4fea5bc247620$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($92f4fea5bc247620$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $92f4fea5bc247620$var$N(k, g);
        h += $92f4fea5bc247620$var$O(k, b, c, f, d);
    }
    else if (f = $92f4fea5bc247620$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $92f4fea5bc247620$var$N(k, g++), h += $92f4fea5bc247620$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($92f4fea5bc247620$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $92f4fea5bc247620$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $92f4fea5bc247620$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $92f4fea5bc247620$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $92f4fea5bc247620$var$R = {
    current: null
};
function $92f4fea5bc247620$var$S() {
    var a = $92f4fea5bc247620$var$R.current;
    if (null === a) throw Error($92f4fea5bc247620$var$z(321));
    return a;
}
var $92f4fea5bc247620$var$T = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $92f4fea5bc247620$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $4yvvI
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$P,
    forEach: function(a, b, c) {
        $92f4fea5bc247620$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$L(a)) throw Error($92f4fea5bc247620$var$z(143));
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$C;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$T;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($92f4fea5bc247620$var$z(267, a));
    var e = $4yvvI({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$H.call(b, f) && !$92f4fea5bc247620$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $92f4fea5bc247620$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$J;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$J.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$t,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$L;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$Q
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$S().useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a, b) {
    return $92f4fea5bc247620$var$S().useContext(a, b);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$S().useEffect(a, b);
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, c) {
    return $92f4fea5bc247620$var$S().useImperativeHandle(a, b, c);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$S().useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$S().useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, c) {
    return $92f4fea5bc247620$var$S().useReducer(a, b, c);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$S().useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$S().useState(a);
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("foRq4", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $bh6RR = parcelRequire("bh6RR");

var $4yvvI = parcelRequire("4yvvI");

var $4LCdk = parcelRequire("4LCdk");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$bh6RR) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $4yvvI({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $bh6RR.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $4yvvI({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $4yvvI({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $4yvvI({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $4LCdk.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $4LCdk.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $4LCdk.unstable_UserBlockingPriority, ed = $4LCdk.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $4yvvI(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $4yvvI({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $4yvvI({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $4yvvI({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $4yvvI({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $4yvvI({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $4yvvI({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $4yvvI({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $4yvvI({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $4yvvI({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $4yvvI({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $4yvvI({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $4yvvI({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $4yvvI({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $4LCdk.unstable_runWithPriority, Of = $4LCdk.unstable_scheduleCallback, Pf = $4LCdk.unstable_cancelCallback, Qf = $4LCdk.unstable_shouldYield, Rf = $4LCdk.unstable_requestPaint, Sf = $4LCdk.unstable_now, Tf = $4LCdk.unstable_getCurrentPriorityLevel, Uf = $4LCdk.unstable_ImmediatePriority, Vf = $4LCdk.unstable_UserBlockingPriority, Wf = $4LCdk.unstable_NormalPriority, Xf = $4LCdk.unstable_LowPriority, Yf = $4LCdk.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $4yvvI({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $4yvvI({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $bh6RR.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4yvvI({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $4yvvI({}, e, {
                    value: void 0
                });
                d = $4yvvI({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $4yvvI({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("4LCdk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
'use strict';
var $6445fa7f31ec0ca5$var$f, $6445fa7f31ec0ca5$var$g, $6445fa7f31ec0ca5$var$h, $6445fa7f31ec0ca5$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$t = null, $6445fa7f31ec0ca5$var$u = null, $6445fa7f31ec0ca5$var$w = function() {
        if (null !== $6445fa7f31ec0ca5$var$t) try {
            var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
            $6445fa7f31ec0ca5$var$t(!0, a);
            $6445fa7f31ec0ca5$var$t = null;
        } catch (b) {
            throw setTimeout($6445fa7f31ec0ca5$var$w, 0), b;
        }
    };
    $6445fa7f31ec0ca5$var$f = function(a) {
        null !== $6445fa7f31ec0ca5$var$t ? setTimeout($6445fa7f31ec0ca5$var$f, 0, a) : ($6445fa7f31ec0ca5$var$t = a, setTimeout($6445fa7f31ec0ca5$var$w, 0));
    };
    $6445fa7f31ec0ca5$var$g = function(a, b) {
        $6445fa7f31ec0ca5$var$u = setTimeout(a, b);
    };
    $6445fa7f31ec0ca5$var$h = function() {
        clearTimeout($6445fa7f31ec0ca5$var$u);
    };
    $6445fa7f31ec0ca5$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $6445fa7f31ec0ca5$var$k = $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function() {};
} else {
    var $6445fa7f31ec0ca5$var$x = window.setTimeout, $6445fa7f31ec0ca5$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $6445fa7f31ec0ca5$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $6445fa7f31ec0ca5$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = null, $6445fa7f31ec0ca5$var$C = -1, $6445fa7f31ec0ca5$var$D = 5, $6445fa7f31ec0ca5$var$E = 0;
    $6445fa7f31ec0ca5$export$b5836b71941fa3ed = function() {
        return $6445fa7f31ec0ca5$export$c4744153514ff05d() >= $6445fa7f31ec0ca5$var$E;
    };
    $6445fa7f31ec0ca5$var$k = function() {};
    $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $6445fa7f31ec0ca5$var$F = new MessageChannel, $6445fa7f31ec0ca5$var$G = $6445fa7f31ec0ca5$var$F.port2;
    $6445fa7f31ec0ca5$var$F.port1.onmessage = function() {
        if (null !== $6445fa7f31ec0ca5$var$B) {
            var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
            $6445fa7f31ec0ca5$var$E = a + $6445fa7f31ec0ca5$var$D;
            try {
                $6445fa7f31ec0ca5$var$B(!0, a) ? $6445fa7f31ec0ca5$var$G.postMessage(null) : ($6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = null);
            } catch (b) {
                throw $6445fa7f31ec0ca5$var$G.postMessage(null), b;
            }
        } else $6445fa7f31ec0ca5$var$A = !1;
    };
    $6445fa7f31ec0ca5$var$f = function(a) {
        $6445fa7f31ec0ca5$var$B = a;
        $6445fa7f31ec0ca5$var$A || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$G.postMessage(null));
    };
    $6445fa7f31ec0ca5$var$g = function(a, b) {
        $6445fa7f31ec0ca5$var$C = $6445fa7f31ec0ca5$var$x(function() {
            a($6445fa7f31ec0ca5$export$c4744153514ff05d());
        }, b);
    };
    $6445fa7f31ec0ca5$var$h = function() {
        $6445fa7f31ec0ca5$var$y($6445fa7f31ec0ca5$var$C);
        $6445fa7f31ec0ca5$var$C = -1;
    };
}
function $6445fa7f31ec0ca5$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $6445fa7f31ec0ca5$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $6445fa7f31ec0ca5$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $6445fa7f31ec0ca5$var$I(n, c)) void 0 !== r && 0 > $6445fa7f31ec0ca5$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $6445fa7f31ec0ca5$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $6445fa7f31ec0ca5$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $6445fa7f31ec0ca5$var$L = [], $6445fa7f31ec0ca5$var$M = [], $6445fa7f31ec0ca5$var$N = 1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$P = 3, $6445fa7f31ec0ca5$var$Q = !1, $6445fa7f31ec0ca5$var$R = !1, $6445fa7f31ec0ca5$var$S = !1;
function $6445fa7f31ec0ca5$var$T(a) {
    for(var b = $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$M); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$M);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$M), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$H($6445fa7f31ec0ca5$var$L, b);
        else break;
        b = $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$M);
    }
}
function $6445fa7f31ec0ca5$var$U(a) {
    $6445fa7f31ec0ca5$var$S = !1;
    $6445fa7f31ec0ca5$var$T(a);
    if (!$6445fa7f31ec0ca5$var$R) {
        if (null !== $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$L)) $6445fa7f31ec0ca5$var$R = !0, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$V);
        else {
            var b = $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$M);
            null !== b && $6445fa7f31ec0ca5$var$g($6445fa7f31ec0ca5$var$U, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$V(a, b) {
    $6445fa7f31ec0ca5$var$R = !1;
    $6445fa7f31ec0ca5$var$S && ($6445fa7f31ec0ca5$var$S = !1, $6445fa7f31ec0ca5$var$h());
    $6445fa7f31ec0ca5$var$Q = !0;
    var c = $6445fa7f31ec0ca5$var$P;
    try {
        $6445fa7f31ec0ca5$var$T(b);
        for($6445fa7f31ec0ca5$var$O = $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$L); null !== $6445fa7f31ec0ca5$var$O && (!($6445fa7f31ec0ca5$var$O.expirationTime > b) || a && !$6445fa7f31ec0ca5$export$b5836b71941fa3ed());){
            var d = $6445fa7f31ec0ca5$var$O.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$O.callback = null;
                $6445fa7f31ec0ca5$var$P = $6445fa7f31ec0ca5$var$O.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$O.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$O.callback = e : $6445fa7f31ec0ca5$var$O === $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$L) && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$L);
                $6445fa7f31ec0ca5$var$T(b);
            } else $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$L);
            $6445fa7f31ec0ca5$var$O = $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$L);
        }
        if (null !== $6445fa7f31ec0ca5$var$O) var m = !0;
        else {
            var n = $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$M);
            null !== n && $6445fa7f31ec0ca5$var$g($6445fa7f31ec0ca5$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$P = c, $6445fa7f31ec0ca5$var$Q = !1;
    }
}
var $6445fa7f31ec0ca5$var$W = $6445fa7f31ec0ca5$var$k;
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$R || $6445fa7f31ec0ca5$var$Q || ($6445fa7f31ec0ca5$var$R = !0, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$V));
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$P;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$L);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$P;
    }
    var c = $6445fa7f31ec0ca5$var$P;
    $6445fa7f31ec0ca5$var$P = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$P = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = $6445fa7f31ec0ca5$var$W;
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$P;
    $6445fa7f31ec0ca5$var$P = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$P = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$H($6445fa7f31ec0ca5$var$M, a), null === $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$L) && a === $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$M) && ($6445fa7f31ec0ca5$var$S ? $6445fa7f31ec0ca5$var$h() : $6445fa7f31ec0ca5$var$S = !0, $6445fa7f31ec0ca5$var$g($6445fa7f31ec0ca5$var$U, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$H($6445fa7f31ec0ca5$var$L, a), $6445fa7f31ec0ca5$var$R || $6445fa7f31ec0ca5$var$Q || ($6445fa7f31ec0ca5$var$R = !0, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$V)));
    return a;
};
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$P;
    return function() {
        var c = $6445fa7f31ec0ca5$var$P;
        $6445fa7f31ec0ca5$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$P = c;
        }
    };
};

});



var $9678aa7eb9fdf1e9$exports = {};
$parcel$extendImportMap({
    "EaZhy": "GitHub-Mark-Light-64px.aab06852.png"
});

var $d4dab640dcbe486c$exports = {};
'use strict';

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


var $47cfd4084854a574$exports = {};
'use strict';
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));






var $536c647c8b2ccf6a$exports = {};

$parcel$export($536c647c8b2ccf6a$exports, "target1", function () { return $ebff7c70545921f3$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target2", function () { return $d0027dbb6c33322e$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target3", function () { return $eccadb5e7ff7dbc8$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target4", function () { return $143c2f111df85b45$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target5", function () { return $3ab487f2614997a6$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target6", function () { return $dedce8a847b1116d$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target7", function () { return $7680feccb01da276$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target8", function () { return $00d51f843bab6438$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target9", function () { return $08fdf2388e1bf37d$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target10", function () { return $106ce207d2345f6b$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target11", function () { return $694b2ec2262d3ebb$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target12", function () { return $fa1715b3a15630f5$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target13", function () { return $386a1659b8abc397$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target14", function () { return $baeea59357f8abd8$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target15", function () { return $3d8ace3eb98a5924$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target16", function () { return $389556f63e7c259c$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target17", function () { return $80505d8d3e92919c$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target18", function () { return $6ae434e8f4ed4a14$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target19", function () { return $5ada87cb58bdbd2f$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target20", function () { return $79f49a0e91420484$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target21", function () { return $ee8cd6a8e4fe17a1$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target22", function () { return $61366ceb95398f9c$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target23", function () { return $d498ac284c45742f$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target24", function () { return $8263fac59ed75a56$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target25", function () { return $07c9c8c1df6cef94$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target26", function () { return $cd1ea7fa34c30413$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target27", function () { return $770cc1f459262ca6$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target28", function () { return $6a0139b76a974fa7$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target29", function () { return $83bce771cdb74731$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target30", function () { return $b1a2244990e03866$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target31", function () { return $bc980467b74fe6be$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target32", function () { return $02da536b1f51634a$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target33", function () { return $bd9328bb4e010f8a$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target34", function () { return $19c9bd4b1ea2bc3b$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target35", function () { return $9a5bc37a0a8a1ccb$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target36", function () { return $5acec2df3ac4c499$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target37", function () { return $c04b29ba95ca8a02$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target38", function () { return $5c31e20f55e78e94$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target39", function () { return $814c3b882705cedd$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target40", function () { return $975dbe01abc17389$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target41", function () { return $328d08889e5cc6b2$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target42", function () { return $be13e36363d8150f$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target43", function () { return $6f62f353db5b4425$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target44", function () { return $f7f4a87d5b76a381$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target45", function () { return $de8f091cc69519a1$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target46", function () { return $5c2dcdbfd2b3d08f$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target47", function () { return $fad8374eaf3e943b$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target48", function () { return $258d80173122ded1$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target49", function () { return $9e6a2d92e399b6fd$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target50", function () { return $bf46977e72d00678$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target51", function () { return $a964e57aa3b67ef2$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target52", function () { return $9a7b2616edc4fe48$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target53", function () { return $af42f43dfd111935$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target54", function () { return $a53da99399038333$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target55", function () { return $4e9ea0fa44bed4c1$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target56", function () { return $ad0527a250ccd524$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target57", function () { return $533abca5988864f5$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target58", function () { return $299546ac639948ee$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target59", function () { return $3e4b249b34fc0a6d$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target60", function () { return $d12177b7a26eba23$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target61", function () { return $f0318dca40920167$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target62", function () { return $0ab8853310f59a94$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target63", function () { return $0f72b30e42185a4c$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target64", function () { return $3a7d33f9a9e09596$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target65", function () { return $8159a2eeb3d82d8c$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target66", function () { return $057f230b1f595ae0$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target67", function () { return $b05751d5dd2ea361$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target68", function () { return $83117b27b3369a84$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target69", function () { return $9e3e44d9b20bc553$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target70", function () { return $375ef5de06beee9e$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target71", function () { return $d26f639d461a800e$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target72", function () { return $8d83558627f70040$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target73", function () { return $a4055db590251f81$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target74", function () { return $b0407a8a5ba27791$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target75", function () { return $b4752a9d9dee5345$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target76", function () { return $1c8d389641500538$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target77", function () { return $280633883e07a8a3$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target78", function () { return $1481cab2bd09646a$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target79", function () { return $2816f2137a58bca2$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target80", function () { return $e24da197a614ae19$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target81", function () { return $5a58708507cde3a0$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target82", function () { return $ab5d1e7bf2980ccf$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target83", function () { return $f3077202f95d9126$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target84", function () { return $1591251682b483a4$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target85", function () { return $a4d60876cec0e377$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target86", function () { return $1daaaea21aca6686$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target87", function () { return $6f85e077950dc09b$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target88", function () { return $663f8e968959e303$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target89", function () { return $1fab69339dd752da$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target90", function () { return $a840aa8b2b7ea209$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target91", function () { return $d2349776102656fd$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target92", function () { return $a229c3ee3d3de33b$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target93", function () { return $17512fdc91130640$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target94", function () { return $309cc72593f33a17$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target95", function () { return $1b3d92d6583564a6$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target96", function () { return $8024792ebbdd53e5$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target97", function () { return $d7475d4727836134$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target98", function () { return $eafe54ee030ab440$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target99", function () { return $d9166ed7a64082f7$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target100", function () { return $7014930755311802$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target101", function () { return $42ae1da4a10e2982$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target102", function () { return $2864823820915414$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target103", function () { return $73adb96f41a2dc9f$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target104", function () { return $513fe17e961d750e$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target105", function () { return $61585453e44a7291$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target106", function () { return $ed5b174d0d360492$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target107", function () { return $361638324c310cf9$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target108", function () { return $110175f69c698ddb$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target109", function () { return $09384f77bd71c295$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target110", function () { return $d4ee21a526e1cf41$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target111", function () { return $283599f7f7314128$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target112", function () { return $7b2805f95a5f40fe$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target113", function () { return $1746c53cbb116cc1$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target114", function () { return $938d1602aa229625$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target115", function () { return $b87cbbd559489f8c$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target116", function () { return $b0a70e3131f0d854$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target117", function () { return $28248c39f71b5d50$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target118", function () { return $db4299f043d8c809$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target119", function () { return $1ab1f19518897e29$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target120", function () { return $7ebe2f40e1524229$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target121", function () { return $18257b2a794e6c0a$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target122", function () { return $f9064627bc0416a1$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target123", function () { return $5512cfc93de1cc16$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target124", function () { return $1019d5efdceb0708$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target125", function () { return $b165cdc09e249213$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target126", function () { return $e2658aab4bb0bea4$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target127", function () { return $e7aa6bb446378cfc$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target128", function () { return $479517ea6e335dec$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target129", function () { return $530fde5599d8df2b$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target130", function () { return $79d4f5efed9f7b91$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target131", function () { return $ee85d93c20918f57$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target132", function () { return $dabb2f35d9e476d3$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target133", function () { return $4e685de629842055$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target134", function () { return $847567ef09f84a44$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target135", function () { return $e22d58ea0f881d0d$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target136", function () { return $b3bfdd2524c06d9f$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target137", function () { return $ec1f527e16b32519$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target138", function () { return $85d764d383c097c0$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target139", function () { return $d0e230bc75706715$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target140", function () { return $5c3155525e3bbc88$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target141", function () { return $4fbe083367d697e4$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target142", function () { return $fd13d16c4560b70b$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target143", function () { return $ae3ef18b875a9ab7$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target144", function () { return $52ad3bb9b3605bbf$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target145", function () { return $3e7ade0b3c8aec71$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target146", function () { return $299d91496150c62a$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target147", function () { return $a082e653b7154ec0$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target148", function () { return $5dc330f7ef69f4e0$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target149", function () { return $d79c8210db88431f$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target150", function () { return $f0851f93e8d3cd58$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target151", function () { return $6429775ebbeafed2$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target152", function () { return $9e7b2380e9b540e6$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target153", function () { return $3c6b9dc835c21b10$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target154", function () { return $7c2d1c76233802c8$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target155", function () { return $eb4079e3dbc4e09c$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target156", function () { return $c1972aa5ccc774a2$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target157", function () { return $1e596b517914fe00$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target158", function () { return $f72973b79deb5eb6$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target159", function () { return $ce85e919b74a0064$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target160", function () { return $18edf20df1a39225$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target161", function () { return $aaaec5d58e4c9980$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target162", function () { return $b2cd7e9d53073707$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target163", function () { return $c4901678d3ca6d5e$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target164", function () { return $164e4a3bd875e843$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target165", function () { return $2fdc809d65a34b31$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target166", function () { return $ca8d6b0556e0566f$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target167", function () { return $fbbb326daf1f80e6$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target168", function () { return $846f0ae480e45a21$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target169", function () { return $6068d8ceda78a082$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target170", function () { return $c131d8c413a34ecf$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target171", function () { return $b65594bfd8dc0928$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target172", function () { return $433047f43b444a8f$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target173", function () { return $99086f1cbfdfc972$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target174", function () { return $fb57ba791655987c$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target175", function () { return $8b1a6e14ba9ad959$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target176", function () { return $269c11942d3cc119$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target177", function () { return $4bacbb525af51794$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target178", function () { return $3e68f336fd9436cf$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target179", function () { return $413ed4d3ff102644$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target180", function () { return $4a3ab2516cc23c16$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target181", function () { return $23fc49ed1be6850a$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target182", function () { return $698d227aa95d1651$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target183", function () { return $eccbd8a84cb1c276$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target184", function () { return $0d8a6a1750fec6c6$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target185", function () { return $c80f50ab103fdba2$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target186", function () { return $06d3adebd5d5da31$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target187", function () { return $fca830256d53d5b6$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target188", function () { return $7e5d707a3740ca27$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target189", function () { return $5bb3c35c43b2cf29$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target190", function () { return $9c969fd01ee39b8c$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target191", function () { return $f870d37d4c454247$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target192", function () { return $86c2e00fe3af24e1$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target193", function () { return $f383086fc7048d0f$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target194", function () { return $ddebf578efbf3211$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target195", function () { return $2f84f0960f052c79$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target196", function () { return $671e86e7e5665971$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target197", function () { return $703ee68348d3be4c$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target198", function () { return $6e81a4df968d73fb$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target199", function () { return $eb639480f012b360$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target200", function () { return $e5da7e205df371c7$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target201", function () { return $42b9e63f305d9f3b$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target202", function () { return $99ef2155665875a8$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target203", function () { return $ad993ca8056cc135$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target204", function () { return $504762108b07115c$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target205", function () { return $aabda9a625943d7b$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target206", function () { return $9cd723941f608a26$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target207", function () { return $5b0af3636d0bfa15$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target208", function () { return $753f76661fe7c4a6$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target209", function () { return $380826846cf48741$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target210", function () { return $84e9982175dd587e$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target211", function () { return $26591b71ce6a5b5f$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target212", function () { return $b2df373578174661$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target213", function () { return $3efa1846a95eed0e$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target214", function () { return $9e90884f9cece9e6$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target215", function () { return $cabf4c242754e61b$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target216", function () { return $565a48653b472fff$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target217", function () { return $ce4bf4280fb9addc$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target218", function () { return $cb0fc7a6eac0c819$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target219", function () { return $de4f504d6e62318a$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target220", function () { return $157b344b05187943$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target221", function () { return $4a665702ddb755f9$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target222", function () { return $b7404b667bb17956$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target223", function () { return $2f24063fe5a12e9a$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target224", function () { return $ed1ad0de500e40c4$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target225", function () { return $ec3e394e4e92ada8$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target226", function () { return $a95f11ea06ec3048$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target227", function () { return $6239fa311e6cbbbe$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target228", function () { return $31d298f5011f8f70$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target229", function () { return $d547ed23806cc09a$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target230", function () { return $e84399b4283d7d48$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target231", function () { return $7fa632d3b5214ce5$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target232", function () { return $39df9f288d011004$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target233", function () { return $bbf53a091326e47b$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target234", function () { return $5783c2242e5eac50$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target235", function () { return $b4abd0f070c73bad$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target236", function () { return $a09c243810cf5642$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target237", function () { return $56843b95b64b1059$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target238", function () { return $78c6758b9fefdf2b$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target239", function () { return $38babaa061e9a146$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target240", function () { return $d39f99611d992d5c$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target241", function () { return $db0062d9e0d8767d$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target242", function () { return $5b56f642c39bd6d4$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target243", function () { return $4ab14c23ccf4a8f3$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target244", function () { return $0b1abd89e6a0e6d8$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target245", function () { return $dec53c49a769d318$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target246", function () { return $debd2de40b5edd7d$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target247", function () { return $b5feda156c1f50e0$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target248", function () { return $7eb8e77c19ee61aa$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target249", function () { return $f66fcfe05d781e46$export$2e2bcd8739ae039; });
$parcel$export($536c647c8b2ccf6a$exports, "target250", function () { return $a1a79770c99be72a$export$2e2bcd8739ae039; });
var $ebff7c70545921f3$export$2e2bcd8739ae039 = {
    id: 1,
    title: 'Target #1 - Simply Square',
    url: 'https://cssbattle.dev/play/1',
    colors: [
        '#5d3a3a',
        '#b5e0ba'
    ],
    solution: '<p><style>body{background:#5d3a3a;margin:0}p{width:200;height:200;background:#b5e0ba}</style>'
};


var $d0027dbb6c33322e$export$2e2bcd8739ae039 = {
    id: 2,
    title: 'Target #2 - Carrom',
    url: 'https://cssbattle.dev/play/2',
    colors: [
        '#62374e',
        '#fdc57b'
    ],
    solution: '<p><style>body{margin:0;background:#62374e}p{background:#fdc57b;width:50;height:50;margin:50 0 0 50;box-shadow:0 150px #fdc57b,250px 150px #fdc57b,250px 0 #fdc57b}</style>'
};


var $eccadb5e7ff7dbc8$export$2e2bcd8739ae039 = {
    id: 3,
    title: 'Target #3 - Push Button',
    url: 'https://cssbattle.dev/play/3',
    colors: [
        '#6592CF',
        '#243D83',
        '#EEB850'
    ],
    solution: '<p a><p b><p c><style>body{background:#6592CF}p{margin:0;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}p[a]{width:300;height:150;background:#243D83}p[b]{width:150;height:150;border-radius:50%;background:#243D83;border:50px solid #6592CF}p[c]{width:50;height:50;border-radius:50%;background:#EEB850}</style>'
};


var $143c2f111df85b45$export$2e2bcd8739ae039 = {
    id: 4,
    title: 'Target #4 - Ups n Downs',
    url: 'https://cssbattle.dev/play/4',
    colors: [
        '#62306D',
        '#F7EC7D'
    ],
    solution: '<a a><a b><a c><style>body{background:#62306D}a{position:fixed;background:#F7EC7D;width:100;height:100;border-radius:0 0 50% 50%}a[a]{top:50%;left:50}a[b]{top:50;left:150;transform:rotate(180deg)}a[c]{top:50%;right:50}</style>'
};


var $3ab487f2614997a6$export$2e2bcd8739ae039 = {
    id: 5,
    title: 'Target #5 - Acid Rain',
    url: 'https://cssbattle.dev/play/5',
    colors: [
        '#0B2429',
        '#F3AC3C',
        '#998235'
    ],
    solution: '<a a><a b><style>body{background:#0B2429}a{position:fixed;width:120;height:120;background:#F3AC3C;border-radius:50%}a[a]{top:30;right:80}a[b]{bottom:30;left:80;box-shadow:60px -60px #998235;border-top-right-radius:0}</style>'
};


var $dedce8a847b1116d$export$2e2bcd8739ae039 = {
    id: 6,
    title: 'Target #6 - Missing Slice',
    url: 'https://cssbattle.dev/play/6',
    colors: [
        '#E3516E',
        '#F7F3D7',
        '#51B5A9',
        '#FADE8B'
    ],
    solution: '<a a><a b><a c><style>body{background:#E3516E}a{position:fixed;width:100;height:100;bottom:50%;left:100;border-top-left-radius:100%}a[a]{background:#51B5A9}a[b]{background:#FADE8B;transform:rotate(90deg)}a[c]{background:#F7F3D7;transform:rotate(-90deg)}a[b],a[c]{transform-origin:bottom right}</style>'
};


var $7680feccb01da276$export$2e2bcd8739ae039 = {
    id: 7,
    title: 'Target #7 - Leafy Trail',
    url: 'https://cssbattle.dev/play/7',
    colors: [
        '#0B2429',
        '#F3AC3C',
        '#998235',
        '#1A4341'
    ],
    solution: '<a><style>body{background:#0B2429}a{position:fixed;top:75;right:75;width:150;height:150;background:#F3AC3C;border-radius:100px 0;box-shadow:-50px 0 #998235,-100px 0 #1A4341}</style>'
};


var $00d51f843bab6438$export$2e2bcd8739ae039 = {
    id: 8,
    title: 'Target #8 - Forking Crazy',
    url: 'https://cssbattle.dev/play/8',
    colors: [
        '#6592CF',
        '#060F55'
    ],
    solution: '<a a><a b><a c><style>body{background:#6592CF}a{position:fixed;background:#060F55}a[a],a[b]{left:50%;transform:translate(-50%)}a[a]{bottom:0;width:20;height:60}a[b]{bottom:50;width:140;height:140;border-radius:0 0 50% 50%}a[c]{top:50;left:130;width:20;height:110;border-radius:10px;box-shadow:20px 0 #6592CF,40px 0 #060F55,60px 0 #6592CF,80px 0 #060F55,100px 0 #6592CF,120px 0 #060F55}</style>'
};


var $08fdf2388e1bf37d$export$2e2bcd8739ae039 = {
    id: 9,
    title: 'Target #9 - Tesseract',
    url: 'https://cssbattle.dev/play/9',
    colors: [
        '#222730',
        '#4CAAB3',
        '#393E46'
    ],
    solution: '<p a><p b><p c><style>body{background:#222730}p{margin:0;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}p[a]{width:400;height:150;background:#4CAAB3}p[b]{width:150;height:150;transform:translate(-50%,-50%)rotate(45deg);background:#4CAAB3;border:50px solid #222730;border-radius:0.1px}p[c]{width:50;height:50;border-radius:50%;background:#393E46}</style>'
};


var $106ce207d2345f6b$export$2e2bcd8739ae039 = {
    id: 10,
    title: 'Target #10 - Cloaked Spirits',
    url: 'https://cssbattle.dev/play/10',
    colors: [
        '#62306D',
        '#F7EC7D',
        '#AA445F',
        '#E38F66'
    ],
    solution: '<a a><a b><a c><style>body{background:#62306D}a{position:fixed;top:200;left:50;width:100;height:200;background:#F7EC7D;}a::after{content:"";position:absolute;top:-50;width:60;height:60;background:#E38F66;border-radius:50%;border:20px solid #AA445F}a[b]{top:100;left:150}a[b]::after{background:#AA445F;border-color:#E38F66}a[c]{left:250}</style>'
};


var $694b2ec2262d3ebb$export$2e2bcd8739ae039 = {
    id: 11,
    title: 'Target #11 - Eye of Sauron',
    url: 'https://cssbattle.dev/play/11',
    colors: [
        '#191210',
        '#ECA03D',
        '#84271C'
    ],
    solution: '<a a><a b><a c><style>body{background:#191210}a{position:fixed;border-radius:50%;border:20px solid #ECA03D}a[a],a[b]{width:60;height:60;border-top-color:transparent;border-left-color:transparent;transform:rotate(45deg)}a[a]{top:100;left:50}a[b]{transform:rotate(225deg);top:100;right:50}a[c]{width:100;height:100;top:80;left:130  }a[c]::after{content:"";position:fixed;top:125;left:175;width:50;height:50;border-radius:50%;background:#84271C}</style>'
};


var $fa1715b3a15630f5$export$2e2bcd8739ae039 = {
    id: 12,
    title: 'Target #12 - Wiggly Moustache',
    url: 'https://cssbattle.dev/play/12',
    colors: [
        '#F5D6B4',
        '#D86F45'
    ],
    solution: '<a a><a b><a c><a d><style>body{background:#f5d6b4}a{position:fixed;border-radius:50%}a[a],a[b],a[c]{top:100;width:60;height:60;border:20px solid #d86f45;clip:rect(50px,auto,auto,auto)}a[a]{left:70}a[b]{left:150;transform:rotate(180deg)}a[c]{right:70}a[d]{top:140;left:70;width:20;height:20;background:#d86f45;box-shadow:240px 0 #d86f45}</style>'
};


var $386a1659b8abc397$export$2e2bcd8739ae039 = {
    id: 13,
    title: 'Target #13 - Totally Triangle',
    url: 'https://cssbattle.dev/play/13',
    colors: [
        '#0B2429',
        '#F3AC3C'
    ],
    solution: '<a><style>body{background:#0B2429}a{position:fixed;top:0;left:0;border:70px solid #F3AC3C;border-bottom-color:transparent;border-right-color:transparent}</style>'
};


var $baeea59357f8abd8$export$2e2bcd8739ae039 = {
    id: 14,
    title: 'Target #14 - Web Maker Logo',
    url: 'https://cssbattle.dev/play/14',
    colors: [
        '#F2F2B6',
        '#FF6D00',
        '#FD4602'
    ],
    solution: '<a a><a b><a c><a d><style>body{background:#f2f2b6}a{position:fixed;border:75px solid transparent}a[a],a[b]{top:85;border-top-width:130}a[c],a[d]{bottom:85;border-bottom-width:130}a[a]{border-top-color:#fd4602;left:80}a[b]{border-top-color:#ff6d00;left:60}a[c]{right:60;border-bottom-color:#ff6d00}a[d]{border-bottom-color:#fd4602;right:80}</style>'
};


var $3d8ace3eb98a5924$export$2e2bcd8739ae039 = {
    id: 15,
    title: 'Target #15 - Overlap',
    url: 'https://cssbattle.dev/play/15',
    colors: [
        '#09042A',
        '#7B3F61',
        '#E78481'
    ],
    solution: '<a a><a b><a c><style>body,a[c]{background:#09042A}a{position:fixed;width:150;height:150;border-radius:50%;top:75}a[a]{background:#E78481;right:75}a[b],a[c]{left:75}a[b]{background:#7B3F61}a[c]{clip-path:circle(75px at 175px center)}</style>'
};


var $389556f63e7c259c$export$2e2bcd8739ae039 = {
    id: 16,
    title: 'Target #16 - Eye of the Tiger',
    url: 'https://cssbattle.dev/play/16',
    colors: [
        '#0B2429',
        '#998235',
        '#F3AC3C'
    ],
    solution: '<a a><a b><a c><style>body,a[c]{background:#0B2429 }a{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%) }a[a]{background:#998235;width:200;height:200;transform:translate(-50%,-50%)rotate(45deg);border-radius: 100px 0;}a[b],a[c]{border-radius:50%;}a[b]{background:#F3AC3C;border:20px solid #0B2429;width:140;height:140;}a[c]{width:50;height:50;}</style>'
};


var $80505d8d3e92919c$export$2e2bcd8739ae039 = {
    id: 17,
    title: 'Target #17 - Fidget Spinner',
    url: 'https://cssbattle.dev/play/17',
    colors: [
        '#09042A',
        '#E78481',
        '#F5BB9C'
    ],
    solution: '<p><a a><a b><a c><a d><style>body{background:#09042a}a,p{position:fixed}a{width:60;height:60;border-radius:50%;border:10px solid}p{top:110;left:170;width:60;height:50;background:#e78481}a[a],a[b]{top:110;border-color:#e78481}a[a]{left:100}a[b]{right:100}a[c],a[d]{left:160;border-color:#09042a;background:#f5bb9c}a[c]{top:57}a[d]{bottom:57}</style>'
};


var $6ae434e8f4ed4a14$export$2e2bcd8739ae039 = {
    id: 18,
    title: 'Target #18 - Matrix',
    url: 'https://cssbattle.dev/play/18',
    colors: [
        '#5C434C',
        '#F09462',
        '#F5D6B4'
    ],
    solution: '<a><style>body{background:#5c434c}a{position:fixed;top:10;left:10;width:80;height:80;background:#f09462;border-radius:100% 0 0;box-shadow:100px 0 #f5d6b4,200px 0 #f09462,300px 0 #f5d6b4,0 100px #f5d6b4,100px 100px #f09462,200px 100px #f5d6b4,300px 100px #f09462,0 200px #f09462,100px 200px #f5d6b4,200px 200px #f09462,300px 200px #f5d6b4}</style>'
};


var $5ada87cb58bdbd2f$export$2e2bcd8739ae039 = {
    id: 19,
    title: 'Target #19 - Cube',
    url: 'https://cssbattle.dev/play/19',
    colors: [
        '#0B2429',
        '#F3AC3C',
        '#998235',
        '#1A4341'
    ],
    solution: '<a a><a b><a c><style>body{background:#0b2429}a{position:fixed}a[a],a[b]{top:80;width:70;height:70}a[a]{left:130;background:#998235;transform:skewY(-45deg)}a[b]{left:200;background:#1a4341;transform:skewY(45deg)}a[c]{top:135;left:150;background:#f3ac3c;width:100;height:100;transform:rotate(45deg)}</style>'
};


var $79f49a0e91420484$export$2e2bcd8739ae039 = {
    id: 20,
    title: 'Target #20 - Ticket',
    url: 'https://cssbattle.dev/play/20',
    colors: [
        '#62306D',
        '#F7EC7D',
        '#E38F66'
    ],
    solution: '<a a><a b><a c><style>body{background:#62306d}a{position:fixed}a[a]{top:100;left:100;width:200;height:100;background:linear-gradient(90deg,#f7ec7d 70%,#e38f66 70%)}a[b],a[c]{border-radius:50%;background:#62306d}a[b]{top:80;left:80;width:40;height:40;box-shadow:200px 0 #62306d,0 100px #62306d,200px 100px #62306d}a[c]{top:90;left:230;width:20;height:20;box-shadow:0 100px #62306d}</style>'
};


var $ee8cd6a8e4fe17a1$export$2e2bcd8739ae039 = {
    id: 21,
    title: 'Target #21 - SitePoint Logo',
    url: 'https://cssbattle.dev/play/21',
    colors: [
        '#222',
        '#F2994A',
        '#2D9CDB'
    ],
    solution: '<a a><a b><a c><a d><style>body{background:#222}a{position:fixed}a[a],a[b]{background:#f2994a}a[a]{width:100;height:30;top:93;left:120;transform:rotate(-45deg);border-top-left-radius:10px}a[b]{width:60;height:30;top:143;left:140;transform:rotate(45deg);border-top-right-radius:5px}a[c],a[d]{background:#2d9cdb}a[c]{width:100;height:30;top:177;left:178;transform:rotate(135deg);border-top-left-radius:10px}a[d]{width:60;height:30;top:127;left:198;transform:rotate(-135deg);border-top-right-radius:5px}</style>'
};


var $61366ceb95398f9c$export$2e2bcd8739ae039 = {
    id: 22,
    title: 'Target #22 - Cloud',
    url: 'https://cssbattle.dev/play/22',
    colors: [
        '#F5D6B4',
        '#D86F45'
    ],
    solution: '<a a><a b><style>body{background:#f5d6b4}a{position:fixed;background:#d86f45}a[a]{width:100;height:100;border-radius:50%;top:115;left:100;box-shadow:80px -30px #d86f45}a[b]{width:150;height:50;border-radius:0 25px 25px 0;top:165;right:100}</style>'
};


var $d498ac284c45742f$export$2e2bcd8739ae039 = {
    id: 23,
    title: 'Target #23 - Boxception',
    url: 'https://cssbattle.dev/play/23',
    colors: [
        '#F3AC3C',
        '#1A4341',
        '#998235'
    ],
    solution: '<a a><a b><a c><style>body{background:#f3ac3c}a{position:fixed}a[a]{top:50;left:100;background:#1a4341;width:200;height:200}a[b]{top:150;left:100;background:#998235;width:100;height:100}a[c]{top:200;left:150;background:#f3ac3c;width:50;height:50}</style>'
};


var $8263fac59ed75a56$export$2e2bcd8739ae039 = {
    id: 24,
    title: 'Target #24 - Switches',
    url: 'https://cssbattle.dev/play/24',
    colors: [
        '#62306D',
        '#F7EC7D',
        '#AA445F',
        '#E38F66'
    ],
    solution: '<a a><a b><a c><a d><style>body{background:#62306d}a{position:fixed;width:100}a[a]{background:#aa445f;top:50}a[b]{background:#e38f66;right:80}a[a],a[b]{height:150;border-radius:50px}a[a],a[c]{left:80}a[b],a[c],a[d]{top:100}a[b],a[d]{right:80}a[c],a[d]{height:100;background:#f7ec7d;border-radius:50%}</style>'
};


var $07c9c8c1df6cef94$export$2e2bcd8739ae039 = {
    id: 25,
    title: 'Target #25 - Blossom',
    url: 'https://cssbattle.dev/play/25',
    colors: [
        '#998235',
        '#1A4341',
        '#F3AC3C'
    ],
    solution: '<a a><a b><a c><a d><style>body{background:#998235}a{position:fixed;width:80}a[a],a[b]{background:#1a4341;height:100}[c],a[a]{left:110;border-radius:0 50px}[d],a[a]{top:60}[c],a[b]{bottom:60}[d],a[b]{right:110;border-radius:50px 0}a[c],a[d]{background:#f3ac3c;height:60}</style>'
};


var $cd1ea7fa34c30413$export$2e2bcd8739ae039 = {
    id: 26,
    title: 'Target #26 - Smiley',
    url: 'https://cssbattle.dev/play/26',
    colors: [
        '#6592CF',
        '#060F55'
    ],
    solution: '<a a><a b><a c><style>body{background:#6592cf}a{position:fixed;border:20px solid #060f55;width:80;height:80;border-radius:50%;clip:rect(auto,auto,60,auto)}a[a],a[b]{top:40}a[a]{left:40}a[b]{right:40}a[c]{bottom:40;left:140;transform:rotate(180deg)}</style>'
};


var $770cc1f459262ca6$export$2e2bcd8739ae039 = {
    id: 27,
    title: 'Target #27 - Lock Up',
    url: 'https://cssbattle.dev/play/27',
    colors: [
        '#E38F66',
        '#AA445F',
        '#F7EC7D'
    ],
    solution: '<a a><a b><style>body{background:#e38f66}a{position:fixed;border-radius:50%}a[a]{background:#aa445f;width:200;height:200;top:50;left:100}a[b]{border:30px solid #f7ec7d;border-left-color:transparent;border-right-color:transparent;width:80;height:80;top:80;left:130;transform:rotate(45deg)}</style>'
};


var $6a0139b76a974fa7$export$2e2bcd8739ae039 = {
    id: 28,
    title: 'Target #28 - Cups & Balls',
    url: 'https://cssbattle.dev/play/28',
    colors: [
        '#1A4341',
        '#998235',
        '#F3AC3C'
    ],
    solution: '<a a><a b><a c><style>body{background:#1a4341}a{position:fixed;width:50;height:50}a[a]{background:#998235;border-radius:50%;box-shadow:210px 0 #f3ac3c,70px 70px #998235,140px 70px #f3ac3c}a[a],a[b]{left:70}a[b],a[c]{background:#f3ac3c}a[a],a[c]{top:90}a[b]{border-radius:0 0 25px 25px;box-shadow:210px 0 #998235;top:160}a[c]{border-radius:25px 25px 0 0;box-shadow:70px 0 #998235;left:140}</style>'
};


var $83bce771cdb74731$export$2e2bcd8739ae039 = {
    id: 29,
    title: 'Target #29 - Suffocate',
    url: 'https://cssbattle.dev/play/29',
    colors: [
        '#F3AC3C',
        '#1A4341'
    ],
    solution: '<a a><a b><a c><a d><style>body{background:#1a4341}a{position:fixed;width:200;height:150;background:#f3ac3c}a[a],a[b]{top:0}a[a],a[c]{left:0}a[b],a[d]{left:200}a[c],a[d]{top:150}a[a]{border-radius:0 0 100px 0}a[b]{border-radius:0 0 0 100px}a[c]{border-radius:0 100px 0 0}a[d]{border-radius:100px 0 0 0}</style>'
};


var $b1a2244990e03866$export$2e2bcd8739ae039 = {
    id: 30,
    title: 'Target #30 - Horizon',
    url: 'https://cssbattle.dev/play/30',
    colors: [
        '#F7EC7D',
        '#E38F66',
        '#AA445F',
        '#62306D'
    ],
    solution: '<style>body{background:linear-gradient(#f7ec7d 50px,#e38f66 50px,#e38f66 100px,#aa445f 100px,#aa445f 200px,#62306d 200px,#62306d 300px)}</style>'
};


var $bc980467b74fe6be$export$2e2bcd8739ae039 = {
    id: 31,
    title: 'Target #31 - Equals',
    url: 'https://cssbattle.dev/play/31',
    colors: [
        '#AA445F',
        '#F7EC7D',
        '#E38F66'
    ],
    solution: '<a a><a b><style>body{background:#aa445f}a{position:fixed;top:50;width:100;height:200}a[a]{left:75;background:#f7ec7d;border-radius:100px 0 0 100px}a[b]{right:75;background:#e38f66;border-radius:0 100px 100px 0}</style>'
};


var $02da536b1f51634a$export$2e2bcd8739ae039 = {
    id: 32,
    title: 'Target #32 - Band-aid',
    url: 'https://cssbattle.dev/play/32',
    colors: [
        '#FFFFFF',
        '#F3AC3C',
        '#A3A368',
        '#FBE18C'
    ],
    solution: '<a a><a b><style>a{position:fixed;top:50;left:175;width:50;height:200}a[a]{background:#f3ac3c;transform:rotate(-45deg)}a[b]{background:#a3a368;transform:rotate(45deg);mix-blend-mode:screen}</style>'
};


var $bd9328bb4e010f8a$export$2e2bcd8739ae039 = {
    id: 33,
    title: 'Target #33 - Birdie',
    url: 'https://cssbattle.dev/play/33',
    colors: [
        '#1A4341',
        '#998235',
        '#F3AC3C',
        '#0B2429'
    ],
    solution: '<a a><a b><a c><style>body{background:#1a4341}a{position:fixed}a[a]{width:75;height:150;top:75;left:125;background:#998235;border-radius:75px 0 0 75px}a[b]{width:100;height:100;top:50;left:200;background:#f3ac3c;border-radius:0 100px 0 0}a[c]{width:30;height:30;top:105;left:155;background:#0b2429;border-radius:50%}</style>'
};


var $19c9bd4b1ea2bc3b$export$2e2bcd8739ae039 = {
    id: 34,
    title: 'Target #34 - Christmas Tree',
    url: 'https://cssbattle.dev/play/34',
    colors: [
        '#007065',
        '#FFEECF',
        '#F5C181',
        '#00A79D'
    ],
    solution: '<a a><a b><a c><style>body{background:#007065}a{position:fixed;left:75;width:250;height:100;clip-path:polygon(50% 0,0 100%,100% 100%)}a[a]{top:150;background:#00a79d}a[b]{top:100;background:#f5c181}a[c]{top:50;background:#ffeecf}</style>'
};


var $9a5bc37a0a8a1ccb$export$2e2bcd8739ae039 = {
    id: 35,
    title: 'Target #35 - Ice Cream',
    url: 'https://cssbattle.dev/play/35',
    colors: [
        '#293462',
        '#FFF1C1',
        '#FE5F55',
        '#A64942'
    ],
    solution: '<a a><a b><style>body{background:#293462}a{position:fixed}a[a]{top:50;left:150;background:#FFF1C1;width:100px;height:150px;border-radius:50px 50px 20px 20px}a[b]{bottom:50;left:185;background:linear-gradient(to bottom,#A64942 10px,#FE5F55 10px);width:30px;height:50px;border-radius:0 0 10px 10px}</style>'
};


var $5acec2df3ac4c499$export$2e2bcd8739ae039 = {
    id: 36,
    title: 'Target #36 - Interleaved',
    url: 'https://cssbattle.dev/play/36',
    colors: [
        '#1A4341',
        '#F3AC3C',
        '#998235'
    ],
    solution: '<a a><a b><style>body{background:#1A4341}a{position:fixed;width:50;height:200}a[a]{top:0;left:100;border-radius:0 0 25px 25px;background:#998235;box-shadow:150px 0 #998235}a[b]{bottom:0;left:25;border-radius:25px 25px 0 0;background:#F3AC3C;box-shadow:150px 0 #F3AC3C,300px 0 #F3AC3C}</style>'
};


var $c04b29ba95ca8a02$export$2e2bcd8739ae039 = {
    id: 37,
    title: 'Target #37 - Tunnel',
    url: 'https://cssbattle.dev/play/37',
    colors: [
        '#6592CF',
        '#243D83'
    ],
    solution: '<a a><a b><a c><style>body,a[b]{background:#6592CF}a{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%)}a[a],a[c]{background:#243D83}a[a]{width:250;height:250}a[b]{width:150;height:150;transform:translate(-50%,-50%) rotate(15deg)}a[c]{width:75;height:75;transform:translate(-50%,-50%) rotate(30deg)}</style>'
};


var $5c31e20f55e78e94$export$2e2bcd8739ae039 = {
    id: 38,
    title: 'Target #38 - Not Simply Square',
    url: 'https://cssbattle.dev/play/38',
    colors: [
        '#293462',
        '#FFF1C1',
        '#FE5F55',
        '#A64942'
    ],
    solution: '<a a><a b><style>body{background:linear-gradient(90deg,#FFF1C1 50%,#293462 50%)}a[a],a[b]{position:fixed;top:0;left:200;width:100;height:200;background:linear-gradient(#FE5F55 75%,#A64942 75%)}a[b]{transform:rotate(-90deg) translate(-150px,-150px)}</style>'
};


var $814c3b882705cedd$export$2e2bcd8739ae039 = {
    id: 39,
    title: 'Target #39 - Sunset',
    url: 'https://cssbattle.dev/play/39',
    colors: [
        '#1A4341',
        '#F3AC3C',
        '#998235'
    ],
    solution: '<a a><a b><a c><style>body{background:#1A4341}a{position:fixed}a[a],a[b]{border-radius:50%}a[a]{background:#998235;width:200;height:200;top:50;left:100}a[b]{background:#F3AC3C;width:250;height:250;top:25;left:75;clip:rect(75,250,175,0)}a[c]{background:#1A4341;width:385;height:20;top:80;box-shadow:0 40px #1A4341,0 80px #1A4341,0 120px #1A4341}</style>'
};


var $975dbe01abc17389$export$2e2bcd8739ae039 = {
    id: 40,
    title: 'Target #40 - Letter B',
    url: 'https://cssbattle.dev/play/40',
    colors: [
        '#6592CF',
        '#243D83'
    ],
    solution: '<a a><a b><style>body{background:#6592CF}a{position:fixed}a[a],a[b]{top:50;left:100}a[a]{width:100;height:100;border:50px solid #243D83;border-radius:50%}a[b]{background:#243D83;width:50;height:100;box-shadow:50px 0 #6592CF}</style>'
};


var $328d08889e5cc6b2$export$2e2bcd8739ae039 = {
    id: 41,
    title: 'Target #41 - Fox Head',
    url: 'https://cssbattle.dev/play/41',
    colors: [
        '#293462',
        '#FE5F55'
    ],
    solution: '<a a><a b><a c><style>body{background:#293462}a{position:fixed}a[a],a[b]{top:180;width:50;height:200;box-shadow:0 -100px #FE5F55}a[a]{left:150;border-radius:0 40px 0 0}a[b]{left:200;border-radius:40px 0 0 0}a[c]{top:140;left:165;background:#293462;width:30;height:30;border-radius:50%;box-shadow:40px 0 #293462}</style>'
};


var $be13e36363d8150f$export$2e2bcd8739ae039 = {
    id: 42,
    title: 'Target #42 - Baby',
    url: 'https://cssbattle.dev/play/42',
    colors: [
        '#293462',
        '#FE5F55',
        '#FFF1C1'
    ],
    solution: '<a a><a b><a c><a d><a e><style>body{background:#293462}a{position:fixed}a[a]{top:50;left:100;background:#FE5F55;width:200;height:200;border-radius:100px 100px 50px 50px}a[b],a[c],a[d],a[e]{background:#FFF1C1}a[b],a[c],a[d]{border-radius:50%}a[b],a[c]{top:0;width:100;height:100}a[b]{left:100;clip-path:circle(100px at right 150px)}a[c]{left:200;clip-path:circle(100px at left 150px)}a[d]{width:60;height:60;top:140;left:120;box-shadow:100px 0 #FFF1C1}a[e]{top:220;left:180;width:40;height:10;border-radius:5px}</style>'
};


var $6f62f353db5b4425$export$2e2bcd8739ae039 = {
    id: 43,
    title: 'Target #43 - Wrench',
    url: 'https://cssbattle.dev/play/43',
    colors: [
        '#6592CF',
        '#243D83'
    ],
    solution: '<a a><a b><style>body{background:#6592CF}a{position:fixed;width:40;height:182;border:30px solid #243D83}a[a],a[b]{top:30}a[a]{left:145;border-left:none;border-radius:0 100px 100px 0}a[b]{right:145;border-right:none;border-radius:100px 0 0 100px}</style>'
};


var $f7f4a87d5b76a381$export$2e2bcd8739ae039 = {
    id: 44,
    title: 'Target #44 - Stripes',
    url: 'https://cssbattle.dev/play/44',
    colors: [
        '#1A4341',
        '#F3AC3C'
    ],
    solution: '<a a><a b><a c><style>body,a{background:#1A4341}a{position:fixed}a[a]{top:60;left:120;width:160;height:180;background:#F3AC3C}a[b]{top:0;left:-150;width:300;height:300;border-radius:50%;box-shadow:400px 0 #1A4341}a[c]{background:#1A4341;top:80;width:385;height:20;box-shadow:0 40px #1A4341,0 80px #1A4341,0 120px #1A4341}</style>'
};


var $de8f091cc69519a1$export$2e2bcd8739ae039 = {
    id: 45,
    title: 'Target #45 - Magical Tree',
    url: 'https://cssbattle.dev/play/45',
    colors: [
        '#1A4341',
        '#F3AC3C',
        '#998235'
    ],
    solution: '<a a><a b><a c><a d><style>body{background:#1A4341}a{position:fixed}a[a]{top:-30;left:125;width:90;height:120;border:30px solid #998235}a[b],a[c]{left:65}a[b]{top:240;width:270;height:30;background:#998235}a[c]{top:-30;width:210;height:180;border:30px solid #F3AC3C}a[d]{top:0;left:185;width:30;height:300;background:#F3AC3C}</style>'
};


var $5c2dcdbfd2b3d08f$export$2e2bcd8739ae039 = {
    id: 46,
    title: 'Target #46 - Mountains',
    url: 'https://cssbattle.dev/play/46',
    colors: [
        '#293462',
        '#FFF1C1',
        '#FE5F55'
    ],
    solution: '<a a><a b><style>body{background:#FFF1C1}a{position:fixed}a[a]{top:140;left:167;background:#FE5F55;width:150;height:150;transform:rotate(45deg);box-shadow:-30px 129px #FE5F55}a[b]{top:0;left:0;width:400;height:300;background:#293462;-webkit-mask-image:radial-gradient(circle at center,transparent 40%,black 40.3%)}</style>'
};


var $fad8374eaf3e943b$export$2e2bcd8739ae039 = {
    id: 47,
    title: 'Target #47 - Corona Virus',
    url: 'https://cssbattle.dev/play/47',
    colors: [
        '#1A4341',
        '#F3AC3C',
        '#998235'
    ],
    solution: '<a a><a b><a c><a d><a e><style>body{background:#1A4341}a{position:fixed;background:#F3AC3C}a[a],a[b],a[c]{width:10;height:180;border-radius:5px}a[a]{top:50;left:195}a[b]{top:55;right:186;transform:rotate(60deg)}a[c]{top:65;right:186;transform:rotate(-60deg)}a[d],a[e]{border-radius:50%}a[d]{top:100;left:150;width:100;height:100}a[e]{top:120;left:170;width:30;height:30;background:#998235;box-shadow:40px -10px 0 -10px #998235,15px 40px 0 -5px #998235}</style>'
};


var $258d80173122ded1$export$2e2bcd8739ae039 = {
    id: 48,
    title: 'Target #48 - Wash Your Hands',
    url: 'https://cssbattle.dev/play/48',
    colors: [
        '#293462',
        '#FE5F55',
        '#A64942'
    ],
    solution: '<a a><a b><style>body{background:#293462}a{position:fixed}a[a]{top:90;left:100;width:200;height:100;background:#FE5F55;border-radius:20px;box-shadow:0 20px #A64942}a[b]{top:120;left:130;width:140;height:40;background:#A64942;border-radius:40px}</style>'
};


var $9e6a2d92e399b6fd$export$2e2bcd8739ae039 = {
    id: 49,
    title: 'Target #49 - Stay at Home',
    url: 'https://cssbattle.dev/play/49',
    colors: [
        '#6592CF',
        '#243D83',
        '#EEB850'
    ],
    solution: '<a a><a b><a c><a d><style>body{background:#6592CF}a{position:fixed}a[c],a[d]{background:#EEB850}a[a]{bottom:150;left:100;border:100px solid transparent;border-bottom:100px solid #243D83}a[b]{top:150;left:125;width:150;height:100;background:#243D83;border-radius:0 0 10px 10px}a[c]{top:145;left:150;width:100;height:10;border-radius:5px}a[d]{bottom:50;left:175;width:50;height:50;border-radius:10px 10px 0 0}</style>'
};


var $bf46977e72d00678$export$2e2bcd8739ae039 = {
    id: 50,
    title: 'Target #50 - Use Hand Sanitizer',
    url: 'https://cssbattle.dev/play/50',
    colors: [
        '#1A4341',
        '#F3AC3C',
        '#998235'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><style>body{background:#1A4341}a{position:fixed}a[a],a[b],a[c]{background:#F3AC3C}a[a],a[b]{border-radius:10px}a[a]{top:50;left:150;width:150;height:20}a[b]{top:60;left:190;width:20;height:40;box-shadow:90px -10px #F3AC3C}a[c]{top:90;left:175;width:50;height:20;border-radius:10px 10px 0 0}a[d]{top:110;left:150;width:100;height:140;border-radius:20px;background:linear-gradient(#F3AC3C 55px,#998235 55px)}a[e],a[f]{background:#998235;border-radius:50%}a[e]{top:140;left:150;width:50;height:50;box-shadow:50px 0 #F3AC3C}a[f]{top:100;left:280;width:20;height:20;box-shadow:0 30px #998235}</style>'
};


var $a964e57aa3b67ef2$export$2e2bcd8739ae039 = {
    id: 51,
    title: 'Target #51 - Wear a Mask',
    url: 'https://cssbattle.dev/play/51',
    colors: [
        '#293462',
        '#FFF1C1',
        '#FE5F55'
    ],
    solution: '<a a><a b><a c><a d><style>body{background:#293462}a{position:fixed}a[a]{top:100;left:65;border:10px solid #FFF1C1;width:250;height:40;border-radius:50px}a[b]{top:110;left:125;width:150;height:90;border-radius:0 0 50px 50px;background:#FFF1C1}a[c],a[d]{background:#FE5F55;width:40}a[c]{top:120;left:145;height:10;border-radius:5px;box-shadow:0 20px #FE5F55}a[d]{top:140;left:215;height:40;border-radius:50%}</style>'
};


var $9a7b2616edc4fe48$export$2e2bcd8739ae039 = {
    id: 52,
    title: 'Target #52 - Break the Chain',
    url: 'https://cssbattle.dev/play/52',
    colors: [
        '#6592CF',
        '#243D83',
        '#EEB850'
    ],
    solution: '<a a><a b><style>body{background:#6592CF}a{position:fixed}a[a]{background:#EEB850;top:120;left:30;width:40;height:40;border-radius:50%;box-shadow:45px -10px 0 10px #EEB850,90px 0 #EEB850}a[b],a[b]:after{position:fixed;background:#243D83;box-shadow:45px 0 #243D83,90px 0 #243D83,165px 0 #243D83,210px 0 #243D83,255px 0 #243D83,300px 0 #243D83}a[b]{top:140;left:45;width:10;height:50}a[b]:after{content:"";top:130;left:40;width:20;height:20;border-radius:50%}</style>'
};


var $af42f43dfd111935$export$2e2bcd8739ae039 = {
    id: 53,
    title: 'Target #53 - Pastel Logo',
    url: 'https://cssbattle.dev/play/53',
    colors: [
        '#19191A',
        '#4F77FF',
        '#9AD5FF',
        '#F9E492'
    ],
    solution: '<a a><a b><a c><style>body{background:#19191A}a{position:fixed}a[a],a[b],a[c]{left:125}a[b],a[c]{top:125;width:75}a[a]{top:50;width:150;height:150;background:#4F77FF;border-radius:50%}a[b]{height:125;background:#F9E492}a[c]{height:75;border-radius:0 0 0 75px;background:#9AD5FF}</style>'
};


var $a53da99399038333$export$2e2bcd8739ae039 = {
    id: 54,
    title: 'Target #54 - Black Lives Matter',
    url: 'https://cssbattle.dev/play/54',
    colors: [
        '#191919',
        '#F9E492'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><a g><style>body{background:#F9E492}a{position:fixed;background:#191919}a[a],a[b],a[c],a[d],a[g]{width:20;border-radius:25px;bottom:167}a[a],a[c]{height:45}a[a]{left:155}a[b]{left:180;height:55}a[c]{left:205}a[d]{left:230;height:35}a[e],a[f]{border-radius:0 0 10px 10px}a[e]{top:138;left:150;width:100;height:40}a[f]{top:178;left:175;width:50;height:45}a[g]{bottom:121;left:152;height:65;transform:rotate(60deg);border:5px solid #F9E492}</style>'
};


var $4e9ea0fa44bed4c1$export$2e2bcd8739ae039 = {
    id: 55,
    title: 'Target #55 - Windmill',
    url: 'https://cssbattle.dev/play/55',
    colors: [
        '#191919',
        '#F9E492',
        '#4F77FF'
    ],
    solution: '<a a><a b><a c><a d><style>body{background:#191919}a{position:fixed;top:100;left:100;width:100;height:50;background:#F9E492;border-radius:50px 50px 0 0;transform-origin:100px 50px}a[b],a[d]{background:#4F77FF}a[b]{transform:rotate(90deg)}a[c]{transform:rotate(180deg)}a[d]{transform:rotate(270deg)}</style>'
};


var $ad0527a250ccd524$export$2e2bcd8739ae039 = {
    id: 56,
    title: 'Target #56 - Skull',
    url: 'https://cssbattle.dev/play/56',
    colors: [
        '#191919',
        '#4F77FF'
    ],
    solution: '<a a><a b><a c><a d><style>body{background:#191919}a{position:fixed;background:#4F77FF}a[a]{top:85;left:140;width:120;height:100;border-radius:60px 60px 10px 10px}a[b]{top:175;left:160;width:80;height:40;border-radius:0 0 20px 20px}a[c],a[d]{background:#191919}a[c]{top:176;left:190;width:20;height:20;border-radius:50%;box-shadow:-25px -28px 0 10px #191919,25px -28px 0 10px #191919}a[d]{top:205;left:180;width:10;height:15;border-radius:10px;box-shadow:15px 0 #191919,30px 0 #191919}</style>'
};


var $533abca5988864f5$export$2e2bcd8739ae039 = {
    id: 57,
    title: 'Target #57 - Pillars',
    url: 'https://cssbattle.dev/play/57',
    colors: [
        '#191919',
        '#4F77FF',
        '#F9E492'
    ],
    solution: '<a a><a b><style>body{background:#191919}a{position:fixed}a[a]{top:95;left:145;width:110;height:110;background:#4F77FF}a[b]{top:75;left:125;width:30;height:30;background:#4F77FF;border-radius:50%;box-shadow:120px 0 #4F77FF,120px 120px #4F77FF,0 120px #4F77FF,7.5px 7.5px 0 7.5px #F9E492,112.5px 7.5px 0 7.5px #F9E492,112.5px 112.5px 0 7.5px #F9E492,7.5px 112.5px 0 7.5px #F9E492,15px 15px 0 15px #191919,105px 15px 0 15px #191919,105px 105px 0 15px #191919,15px 105px 0 15px #191919}</style>'
};


var $299546ac639948ee$export$2e2bcd8739ae039 = {
    id: 58,
    title: 'Target #58 - Rose',
    url: 'https://cssbattle.dev/play/58',
    colors: [
        '#191919',
        '#4F77FF',
        '#F9E492'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><style>body{background:#191919}a{position:fixed;background:#4F77FF}a[a],a[b]{background:#F9E492}a[b],a[c],a[f]{border-radius:50%}a[d],a[e],a[f]{border:10px solid #191919}a[a]{top:155;left:190;width:20;height:100;border-radius:25px}a[b]{top:145;left:180;width:40;height:40}a[c]{top:65;left:150;width:100;height:100}a[d]{top:75;left:120;border-radius:20px 20px 50px 50px;width:140;height:30}a[e]{top:55;left:140;border-radius:20px 20px 50px 50px;width:100;height:30}a[f]{top:35;left:175;width:30;height:30}</style>'
};


var $3e4b249b34fc0a6d$export$2e2bcd8739ae039 = {
    id: 59,
    title: 'Target #59 - Earth',
    url: 'https://cssbattle.dev/play/59',
    colors: [
        '#191919',
        '#4F77FF'
    ],
    solution: '<a a><a b><a c><a d><style>body,a[b],a[c]{background:#191919}a{position:fixed}a[a]{top:75;left:125;width:150;height:150;background:#4F77FF;border-radius:50%}a[b],a[c]{top:70;left:195;width:10;height:160}a[c]{transform:rotate(90deg);box-shadow:-40px 0 #191919,40px 0 #191919}a[d]{top:87.5;left:137.5;width:105;height:105;border:10px solid #191919;border-radius:0 105px;transform:rotate(45deg)}</style>'
};


var $d12177b7a26eba23$export$2e2bcd8739ae039 = {
    id: 60,
    title: 'Target #60 - Evil Triangles',
    url: 'https://cssbattle.dev/play/60',
    colors: [
        '#191919',
        '#4F77FF'
    ],
    solution: '<a a><a b><a c><style>body,a{background:#191919}a{position:fixed}a[a]{top:75;left:100;width:200;height:100;background:#4F77FF}a[b],a[c]{top:100;background:#191919;width:50;height:50}a[b]{left:100;transform:skewY(45deg);box-shadow:0 50px #4F77FF,100px -100px #191919,100px -50px #4F77FF}a[c]{left:150;transform:skewY(-45deg);box-shadow:0 50px #4F77FF,100px 100px #191919,100px 150px #4F77FF}</style>'
};


var $f0318dca40920167$export$2e2bcd8739ae039 = {
    id: 61,
    title: 'Target #61 - ImprovMX',
    url: 'https://cssbattle.dev/play/61',
    colors: [
        '#191919',
        '#5DBCF9'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><a g><style>body{background:#191919}a{position:fixed}a[a],a[b],a[c],a[d]{border:10px solid #5DBCF9}a[a]{top:66;left:175;width:30;height:20}a[b]{top:96;left:150;width:80;height:55;border-bottom:0}a[c],a[d]{top:146;border-bottom:0;width:80;height:30}a[c]{left:126;border-right:0;transform:rotate(-30deg)}a[d]{right:126;border-left:0;;transform:rotate(30deg)}a[e],a[f],a[g]{background:#5DBCF9}a[e]{top:130;left:195;width:10;height:75}a[f],a[g]{height:10}a[f]{top:204;left:100;width:200;box-shadow:0 -10px #191919}a[g]{top:224;left:145;width:110}</style>'
};


var $0ab8853310f59a94$export$2e2bcd8739ae039 = {
    id: 62,
    title: 'Target #62 - Sunset',
    url: 'https://cssbattle.dev/play/62',
    colors: [
        '#191919',
        '#F2AD43',
        '#E08027',
        '#824B20',
        '#FFF58F'
    ],
    solution: '<a a><a b><a c><a d><style>body{background:#191919}a{position:fixed}a[a]{top:50;left:125;width:150;height:185;background:#F2AD43;border-radius:75px}a[b]{top:140;left:170;width:60;height:60;background:#FFF58F;border-radius:50%}a[c],a[d]{top:150;width:100;height:100}a[c]{left:125;background:#E08027;border-radius:0 100px 0 20px}a[d]{right:125;background:#824B20;border-radius:100px 0 20px 0}</style>'
};


var $0f72b30e42185a4c$export$2e2bcd8739ae039 = {
    id: 63,
    title: 'Target #63 - Command Key',
    url: 'https://cssbattle.dev/play/63',
    colors: [
        '#191919',
        '#5DBCF9'
    ],
    solution: '<a a><a b><a c><a d><a e><style>body{background:#191919}a{position:fixed;border:10px solid #5dbcf9;width:50;height:50}a[a]{top:114;left:166}a[b],a[c]{top:54}a[d],a[e]{bottom:56}a[b],a[e]{left:106}a[c],a[d]{right:104}a[b]{border-radius:50px 50px 0 50px}a[c]{border-radius:50px 50px 50px 0}a[d]{border-radius:0 50px 50px 50px}a[e]{border-radius:50px 0 50px 50px}</style>'
};


var $3a7d33f9a9e09596$export$2e2bcd8739ae039 = {
    id: 64,
    title: 'Target #64 - Door Knob',
    url: 'https://cssbattle.dev/play/64',
    colors: [
        '#191919',
        '#E08027',
        '#824B20',
        '#FFF58F'
    ],
    solution: '<a a><a b><a c><style>body{background:#191919}a{position:fixed;border-radius:50%}a[a]{top:70;left:120;width:100;height:100;background:#e08027;border:30px solid #824b20}a[b]{top:90;left:140;width:80;height:80;border:20px solid #fff58f;clip-path:inset(60px 0 0 0)}a[c]{top:140;left:140;width:20;height:20;background:#fff58f;box-shadow:100px 0 #fff58f}</style>'
};


var $8159a2eeb3d82d8c$export$2e2bcd8739ae039 = {
    id: 65,
    title: 'Target #65 - Max Volume',
    url: 'https://cssbattle.dev/play/65',
    colors: [
        '#191919',
        '#5DBCF9'
    ],
    solution: '<a a><a b><a c><style>body{background:#191919}a{position:fixed}a[a]{top:125;left:75;width:75;height:50;background:#5DBCF9;border-radius:10px}a[b]{top:50;left:50;height:50;border:75px solid transparent;border-right-color:#5DBCF9}a[c]{top:100;left:175;width:80;height:80;border:10px solid #5DBCF9;border-radius:50%;box-shadow:0 0 0 15px #191919,0 0 0 25px #5DBCF9,0 0 0 40px #191919,0 0 0 50px #5DBCF9;clip-path:inset(-50px -50px -50px 50px)}</style>'
};


var $057f230b1f595ae0$export$2e2bcd8739ae039 = {
    id: 66,
    title: 'Target #66 - Batmicky',
    url: 'https://cssbattle.dev/play/66',
    colors: [
        '#191919',
        '#F2AD43'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><style>body{background:#191919}a{position:fixed}a[a],a[e],a[f]{background:#F2AD43}a[b],a[c],a[d]{background:#191919}a[c],a[d],a[f]{border-radius:50%}a[a]{top:100;left:80;width:240;height:80}a[b]{top:70;left:160;width:80;height:60;border-radius:10px}a[c]{top:100;left:25;width:100;height:100;box-shadow:250px 0 #191919}a[d]{top:160;left:40;width:200;height:200;box-shadow:120px 0 #191919}a[e]{top:110;left:190;width:20;height:20}a[f]{top:105;left:185;width:10;height:10;box-shadow:20px 0 #F2AD43}</style>'
};


var $b05751d5dd2ea361$export$2e2bcd8739ae039 = {
    id: 67,
    title: 'Target #67 - Video Reel',
    url: 'https://cssbattle.dev/play/67',
    colors: [
        '#191919',
        '#5DBCF9'
    ],
    solution: '<a a><a b><style>body{background:#191919}a{position:fixed;background:#5dbcf9}a[a]{top:0;left:45;width:10;height:300;box-shadow:150px 0 #5dbcf9,300px 0 #5dbcf9}a[b]{top:30;left:50;width:150;height:40;box-shadow:-150px 50px #5dbcf9,-150px 200px #5dbcf9,0 150px #5dbcf9,150px 50px #5dbcf9,150px 200px #5dbcf9,300px 0 #5dbcf9,300px 150px #5dbcf9}</style>'
};


var $83117b27b3369a84$export$2e2bcd8739ae039 = {
    id: 68,
    title: 'Target #68 - Bell',
    url: 'https://cssbattle.dev/play/68',
    colors: [
        '#191919',
        '#E08027',
        '#F2AD43',
        '#824B20'
    ],
    solution: '<a a><a b><style>body{background:#191919}a{position:fixed}a[a]{top:66;left:175;width:50;height:50;border-radius:50%;background:#f2ad43;box-shadow:0 120px #824b20}a[b]{top:90;left:140;width:120;height:120;border-radius:60px 60px 10px 10px;background:#e08027}</style>'
};


var $9e3e44d9b20bc553$export$2e2bcd8739ae039 = {
    id: 69,
    title: 'Target #69 - PushOwl',
    url: 'https://cssbattle.dev/play/69',
    colors: [
        '#191919',
        '#E08027'
    ],
    solution: '<a a><a b><a c><a d><a e><style>body{background:#191919}a{position:fixed}a[a]{top:132;left:162;width:75;height:75;background:#E08027;transform:rotate(45deg)}a[b],a[c]{top:77;width:114;height:114;background:radial-gradient(#191919 44.5px,#E08027 45.5px)}a[b]{left:89;border-radius:0 50% 50% 50%}a[c]{right:89;border-radius:50% 0 50% 50%;box-shadow:0 0 0 10px #191919}a[d],a[e]{top:125;width:11.5;height:11.5;border:9px solid #E08027;border-radius:50%;clip-path:inset(0 0 15px 0)}a[d]{left:131}a[e]{left:239}</style>'
};


var $375ef5de06beee9e$export$2e2bcd8739ae039 = {
    id: 70,
    title: 'Target #70 - Froggy',
    url: 'https://cssbattle.dev/play/70',
    colors: [
        '#293462',
        '#FE5F55',
        '#A64942',
        '#FFF1C1'
    ],
    solution: '<a a><a b><a c><a d><style>[d],body{background:#293462}[b],[c],[d]{border-radius:50%}a{position:fixed}[a]{top:110;left:125;width:150;height:100;background:radial-gradient(ellipse 90% 77% at top,#fe5f55 90%,#a64942 91%);border-radius:60px}[b],[c]{width:50;height:50;background:#fff1c1;box-shadow:inset 0 0 0 10px #fe5f55}[b]{top:85;left:140}[c]{top:85;left:210}[d]{top:105;left:160;width:10;height:10;box-shadow:70px 0 #293462,25px 55px #293462,45px 55px #293462}</style>'
};


var $d26f639d461a800e$export$2e2bcd8739ae039 = {
    id: 71,
    title: 'Target #71 - Elephant',
    url: 'https://cssbattle.dev/play/71',
    colors: [
        '#998235',
        '#1A4341',
        '#0B2429',
        '#FFFFFF'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><a g><style>body{background:#998235}a{position:fixed}a[a],a[b],a[c],a[d],a[e],a[f]{border-radius:50%}a[a],a[b]{top:60;width:80;height:180}a[a]{left:50;background:radial-gradient(ellipse 50% 57% at 50px,#0B2429 33.5px,#1A4341 34.5px)}a[b]{right:50;background:radial-gradient(ellipse 50% 57% at 30px,#0B2429 33.5px,#1A4341 34.5px)}a[c]{top:60;left:110;width:180;height:180;background:#1A4341}a[d],a[e]{background:#0B2429;top:130;width:20;height:20;border:10px solid #998235;clip-path:inset(50% 0 0 0)}a[d]{left:150}a[e]{right:150}a[f]{top:190;left:140;width:80;height:80;border:20px solid #fff;clip-path:inset(0 0 50% 0)}a[g]{top:180;left:180;width:40;height:150;background:#0B2429;border-radius:50px}</style>'
};


var $8d83558627f70040$export$2e2bcd8739ae039 = {
    id: 72,
    title: 'Target #72 - Sheep',
    url: 'https://cssbattle.dev/play/72',
    colors: [
        '#243D83',
        '#6592CF'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><style>body{background:#243D83}a{position:fixed}a[a]{width:60;height:95;top:80;left:170;border-radius:50px;box-shadow:0 10px 0 15px #6592CF}a[b]{top:130;left:185;width:10;height:10;background:#6592CF;border-radius:50%;box-shadow:20px 0 #6592CF}a[c],a[d],a[e],a[f]{background:#6592CF;border-radius:50%}a[c]{width:60;height:50;top:65;left:170;box-shadow:0 120px #6592CF}a[d]{width:50;height:60;top:120;left:115;box-shadow:120px 0 #6592CF}a[e]{width:55;height:55;top:83;left:132;border-radius:60% 40% 60% 40%;box-shadow:80px 80px #6592CF}a[f]{width:55;height:55;top:83;right:132;border-radius:40% 60% 40% 60%;box-shadow:-80px 80px #6592CF}</style>'
};


var $a4055db590251f81$export$2e2bcd8739ae039 = {
    id: 73,
    title: 'Target #73 - Happy Tiger',
    url: 'https://cssbattle.dev/play/73',
    colors: [
        '#F3AC3C',
        '#998235',
        '#1A4341',
        '#FFFFFF'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><a g><a h><style>body{background:#F3AC3C}a{position:fixed}a[a]{top:65;left:115;width:40;height:40;background:#1A4341;border-radius:50%;border:10px solid #998235;box-shadow:110px 0 0 -10px #1A4341,110px 0 #998235}a[b]{top:75;left:125;width:150;height:150;background:#998235;border-radius:50% 50% 40% 40%}a[c]{top:75;left:175;border:25px solid transparent;border-top-color:#1A4341;border-radius:50% / 15%}a[d]{top:135;left:150;width:20;height:20;border-radius:50%;background:#1A4341;box-shadow:80px 0 #1A4341}a[e]{top:170;left:150;width:100;height:40;border-radius:12px 12px 30px 30px;background:#fff}a[f],a[g]{top:180;width:20;height:10;border:10px solid #1A4341;border-top:none;border-radius:0 0 30px 30px}a[f]{left:165}a[g]{left:195}a[h]{top:160;left:195;width:10;height:20;background:#1A4341}</style>'
};


var $b0407a8a5ba27791$export$2e2bcd8739ae039 = {
    id: 74,
    title: 'Target #74 - Danger Noodle',
    url: 'https://cssbattle.dev/play/74',
    colors: [
        '#191919',
        '#E08027'
    ],
    solution: '<p a><p b><p c><p d><p e><p f><p g><p h><style>body,p{background:#191919}[b],[d]{top:24px}[c],[e]{top:44px}p{width:70px;height:200px;position:absolute;box-shadow:inset 0 0 0 5px #e08027,inset 0 0 0 15px #191919,inset 0 0 0 20px #e08027;border-radius:35px}[a]{left:-35px;top:-56px;clip:rect(110px,auto,auto,auto)}[b]{left:15px;clip:rect(auto,auto,80px,auto)}[c]{left:65px;clip:rect(35px,auto,auto,auto)}[d]{left:115px;clip:rect(auto,auto,165px,auto)}[e]{left:165px;clip:rect(120px,auto,auto,auto)}[f]{width:99px;border-top-right-radius:0;left:215px;top:124px;clip:rect(auto,55px,80px,auto)}[g]{box-shadow:none;background:#e08027;width:50px;height:30px;top:119px;left:265px;border-radius:14px 20px 20px 14px}[h]{width:10px;height:10px;top:121px;left:295px;box-shadow:0 16px #191919}</style>'
};


var $b4752a9d9dee5345$export$2e2bcd8739ae039 = {
    id: 75,
    title: 'Target #75 - Hippo',
    url: 'https://cssbattle.dev/play/75',
    colors: [
        '#191919',
        '#A64942',
        '#FE5F55',
        '#000000'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><a g><style>[a],[b]{box-shadow:inset 0 0 0 5px #fe5f55;top:75}[a],[b],[c]{top:75}[a],[f]{left:145}[b],[f]{transform:rotate(-45deg)}[f],[g]{top:170}[b],[g]{left:225}[a],[g]{width:30;height:20;background:#000;border-radius:100%;transform:rotate(45deg)}body{background:#191919}a{position:fixed}[b]{width:30;height:20;background:#000;border-radius:100%}[c]{left:135;width:130;height:160;background:#fe5f55;border-radius:60px}[d]{top:145;left:125;width:150;height:100;background:#a64942;border-radius:55px 55px 45px 45px}[e]{top:125;left:160;width:10;height:10;background:#000;border-radius:9in;box-shadow:70px 0}[f]{width:30;height:20;background:#000;border-radius:100%}</style>'
};


var $1c8d389641500538$export$2e2bcd8739ae039 = {
    id: 76,
    title: 'Target #76 - Beeee',
    url: 'https://cssbattle.dev/play/76',
    colors: [
        '#998235',
        '#FFFFFF',
        '#EFF33C',
        '#191919'
    ],
    solution: '<a a><a b><style>[a],[b]{left:125;height:75}body{background:#998235}a{position:fixed;border-radius:9in}[a]{top:75;width:75;background:#fff;box-shadow:75px 0 #fff,35px 35px #fff}[b]{background:linear-gradient(to right,#191919,#191919 25px,#eff33c 25px,#eff33c 35px,#191919 35px,#191919 60px,#eff33c 60px,#eff33c 70px,#191919 70px,#191919 95px,transparent 95px),radial-gradient(circle at 122.5px 27.5px,#191919 0,#191919 7.5px,#eff33c 7.5px);top:150;width:150}</style>'
};


var $280633883e07a8a3$export$2e2bcd8739ae039 = {
    id: 77,
    title: 'Target #77 - Notes',
    url: 'https://cssbattle.dev/play/77',
    colors: [
        '#191919',
        '#FE5F55',
        '#A64942'
    ],
    solution: '<a a><a b><a c><style>[a],[b]{box-shadow:70px 0 #fe5f55,140px 0 #a64942,210px 0 #fe5f55}[b],[c]{top:90;background:#fe5f55}[a],[b],[c]{background:#fe5f55}body{background:#191919}a{position:fixed}[a]{top:170;left:55;width:50;height:40;border-radius:100%}[b]{left:95;width:10;height:100}[c]{left:105;width:30;height:10;box-shadow:30px 0 #fe5f55,140px 0 #a64942,210px 0 #fe5f55,210px 20px #fe5f55}</style>'
};


var $1481cab2bd09646a$export$2e2bcd8739ae039 = {
    id: 78,
    title: 'Target #78 - Ukulele',
    url: 'https://cssbattle.dev/play/78',
    colors: [
        '#F3AC3C',
        '#998235',
        '#1A4341'
    ],
    solution: '<a a><a b><a c><a d><a e><style>[c],[d],[e]{border-radius:9in}[a],[c],[e]{background:#1a4341}body{background:#f3ac3c}a{position:fixed}[a]{top:140;left:200;width:120;height:20}[b]{top:135;right:45;width:40;height:30;border-radius:10px;background:#998235}[c]{top:143;right:55;width:20;height:4;box-shadow:0 10px #1a4341}[d]{top:100;left:115;width:100;height:100;box-shadow:inset 0 0 0 25px #998235,inset 0 0 0 30px #f3ac3c,inset 0 0 0 50px #1a4341,-60px 0 0 10px #998235}[e]{top:130;left:85;width:10;height:40}</style>'
};


var $2816f2137a58bca2$export$2e2bcd8739ae039 = {
    id: 79,
    title: 'Target #79 - Tambourine',
    url: 'https://cssbattle.dev/play/79',
    colors: [
        '#243D83',
        '#6592CF'
    ],
    solution: '<a a><a b><a c><style>[a],[b]{border-radius:9in}[b],body{background:#6592cf}a{position:fixed}[a]{top:75;left:115;width:150;height:150;border:10px solid #243d83}[b]{top:200;left:140;width:100;height:100;border:10px solid #243d83;clip-path:circle(80px at center -34px)}[c]{top:95;left:105;width:50;height:50;border-radius:9in;box-shadow:inset 0 0 0 10px #243d83,inset 0 0 0 20px #6592cf,inset 0 0 0 30px #243d83,0 70px 0 -20px #243d83,70px -40px 0 -20px #243d83,140px 0 0 -20px #243d83,140px 70px 0 -20px #243d83,0 70px 0 -10px #6592cf,70px -40px 0 -10px #6592cf,140px 0 0 -10px #6592cf,140px 70px 0 -10px #6592cf,0 70px 0 0 #243d83,70px -40px 0 0 #243d83,140px 0 0 0 #243d83,140px 70px 0 0 #243d83}</style>'
};


var $e24da197a614ae19$export$2e2bcd8739ae039 = {
    id: 80,
    title: 'Target #80 - Piano',
    url: 'https://cssbattle.dev/play/80',
    colors: [
        '#998235',
        '#191919',
        '#FFFFFF'
    ],
    solution: '<a a><a b><a c><style>[b],[c]{top:125}[a],[c]{background:#191919}body{background:#998235}a{position:fixed}[a]{top:100;left:110;width:180;height:100;border-radius:10px}[b]{left:115;width:20;height:70;background:#fff;border-radius:5px;box-shadow:25px 0 #fff,50px 0 #fff,75px 0 #fff,100px 0 #fff,125px 0 #fff,150px 0 #fff}[c]{left:130;width:15;height:35;box-shadow:25px 0 #191919,75px 0 #191919,100px 0 #191919,125px 0 #191919}</style>'
};


var $5a58708507cde3a0$export$2e2bcd8739ae039 = {
    id: 81,
    title: 'Target #81 - Odoo',
    url: 'https://cssbattle.dev/play/81',
    colors: [
        '#191919',
        '#714B67',
        '#8F8F8F'
    ],
    solution: '<p a><p b><p c><p d><p e><style>body{background:#191919}p{position:fixed;top:106;width:40;height:40;border:20px solid #8f8f8f;border-radius:1in}[a]{border-color:#714b67;left:37}[b]{left:119}[c]{left:201}[d]{left:283}[e]{width:20;height:70;border:none;background:#8f8f8f;top:86;left:179}</style>'
};


var $ab5d1e7bf2980ccf$export$2e2bcd8739ae039 = {
    id: 82,
    title: 'Target #82 - Diamond Cut',
    url: 'https://cssbattle.dev/play/82',
    colors: [
        '#F3AC3C',
        '#998235',
        '#1A4341'
    ],
    solution: '<a><style>body{background:#f3ac3c}a{position:fixed;top:135;left:183;width:30;height:30;background:#1a4341;transform:rotate(45deg);box-shadow:0 -65px #f3ac3c,-65px 0 #f3ac3c,0 0 0 35px #f3ac3c,0 0 0 65px #998235}</style>'
};


var $f3077202f95d9126$export$2e2bcd8739ae039 = {
    id: 83,
    title: 'Target #83 - Supernova',
    url: 'https://cssbattle.dev/play/83',
    colors: [
        '#243D83',
        '#6592CF',
        '#EEB850'
    ],
    solution: '<a a><a b><a c><style>[b],body{background:#243d83}[a],[c]{border-radius:9in}a{position:fixed}[a]{top:58;left:108;width:100;height:100;background:#6592cf;box-shadow:85px 0 #6592cf,0 85px #6592cf,85px 85px #6592cf}[b]{top:90;left:140;width:120;height:120;transform:rotate(45deg)}[c]{top:120;left:170;width:60;height:60;background:#eeb850}</style>'
};


var $1591251682b483a4$export$2e2bcd8739ae039 = {
    id: 84,
    title: 'Target #84 - Junction',
    url: 'https://cssbattle.dev/play/84',
    colors: [
        '#191919',
        '#A64942',
        '#FE5F55'
    ],
    solution: '<p a><p b><p c><p d><style>body{background:#191919}p{position:fixed;width:180;height:40;top:114;left:0;border-radius:0 20px 20px 0;transform-origin:200px 50%}[a],[c]{background:#a64942}[b],[d]{background:#fe5f55}[b]{transform:rotate(90deg)}[c]{transform:rotate(180deg)}[d]{transform:rotate(-90deg)}</style>'
};


var $a4d60876cec0e377$export$2e2bcd8739ae039 = {
    id: 85,
    title: 'Target #85 - Pythagoras',
    url: 'https://cssbattle.dev/play/85',
    colors: [
        '#D25B70',
        '#F7F3DA',
        '#F6DF96',
        '#6CB3A9'
    ],
    solution: '<a a><a b><a c><style>[a],[b]{left:150}[b],[c]{bottom:150;transform-origin:bottom left}body{background:#d25b70}a{position:fixed}[a]{width:100;height:100;top:150;background:#f7f3da}[b]{width:60;height:60;background:#6cb3a9;transform:rotate(-53deg)}[c]{width:80;height:80;left:250;background:#f6df96;transform:rotate(-53deg)}</style>'
};


var $1daaaea21aca6686$export$2e2bcd8739ae039 = {
    id: 86,
    title: 'Target #86 - Stairway',
    url: 'https://cssbattle.dev/play/86',
    colors: [
        '#191919',
        '#4F77FF'
    ],
    solution: '<a a><a b><style>[a],[b]{width:100}[b],body{background:#191919}a{position:fixed}[a]{top:75;left:150;height:150;background:#4f77ff;border-radius:9in 9in 0 0}[b]{top:205;left:170;height:20;box-shadow:20px -24px #191919,40px -48px #191919,60px -72px #191919}</style>'
};


var $6f85e077950dc09b$export$2e2bcd8739ae039 = {
    id: 87,
    title: 'Target #87 - Building Blocks',
    url: 'https://cssbattle.dev/play/87',
    colors: [
        '#F3AC3C',
        '#1A4341'
    ],
    solution: '<a a><a b><a c><a d><style>[b],[c]{height:50;background:#1a4341}[a],[b],[c]{background:#1a4341}[b],[d]{width:70;border-radius:10px}[d],body{background:#f3ac3c}[a],[b],[d]{border-radius:10px}a{position:fixed}[a]{top:65;left:65;width:100;height:100;box-shadow:170px 70px #1a4341}[b]{top:65;left:145;box-shadow:40px 120px #1a4341}[c]{top:100;left:150;width:50;box-shadow:50px 50px #1a4341}[d]{top:115;left:165;height:70}</style>'
};


var $663f8e968959e303$export$2e2bcd8739ae039 = {
    id: 88,
    title: 'Target #88 - Tight Corner',
    url: 'https://cssbattle.dev/play/88',
    colors: [
        '#F7F3DA',
        '#D25B70'
    ],
    solution: '<a a><a b><style>[a],[b]{width:200;height:150}[b],body{background:#f7f3da}a{position:fixed;left:0}[a]{bottom:40;border-radius:0 10px;background:#d25b70;box-shadow:200px -70px #d25b70}[b]{bottom:0;border-radius:0 20px;box-shadow:200px -150px #f7f3da}</style>'
};


var $1fab69339dd752da$export$2e2bcd8739ae039 = {
    id: 89,
    title: 'Target #89 - Summit',
    url: 'https://cssbattle.dev/play/89',
    colors: [
        '#191919',
        '#F9E492',
        '#4F77FF'
    ],
    solution: '<a a><a b><style>body{background:#191919}a{position:fixed}[a]{top:50;left:100;width:200;height:200;border-radius:9in;background:#f9e492}[b]{bottom:0;left:59;width:282;height:141;background:radial-gradient(circle at 50% -10px,#191919,#191919 101px,#4f77ff 101px);clip-path:polygon(0 100%,100% 100%,50% 0)}</style>'
};


var $a840aa8b2b7ea209$export$2e2bcd8739ae039 = {
    id: 90,
    title: 'Target #90 - Eclipse',
    url: 'https://cssbattle.dev/play/90',
    colors: [
        '#998235',
        '#F3AC3C',
        '#1A4341'
    ],
    solution: '<a><style>body{background:#f3ac3c}a{position:fixed;top:150;left:0;width:400;height:400;background:#998235;border-radius:9in;box-shadow:0 -200px 0 -100px #1a4341,0 -202px 0 -76px #f3ac3c,0 -400px #998235}</style>'
};


var $d2349776102656fd$export$2e2bcd8739ae039 = {
    id: 91,
    title: 'Target #91 - Reflection',
    url: 'https://cssbattle.dev/play/91',
    colors: [
        '#6CB3A9',
        '#D25B70',
        '#F6DF96'
    ],
    solution: '<a a><a b><a c><style>[a],[c]{width:400}[c],body{background:#6cb3a9}body{margin:0}a{position:fixed}[a]{height:150;background:#d25b70}[b]{top:50;left:100;width:200;height:200;border-radius:9in;background:#f6df96}[c]{top:150;height:15;box-shadow:0 25px #6cb3a9,0 50px #6cb3a9,0 75px #6cb3a9}</style>'
};


var $a229c3ee3d3de33b$export$2e2bcd8739ae039 = {
    id: 92,
    title: 'Target #92 - Squeeze',
    url: 'https://cssbattle.dev/play/92',
    colors: [
        '#6592CF',
        '#243D83'
    ],
    solution: '<a a><a b><a c><style>[a],[b]{background:#243d83}[c],body{background:#6592cf}[a],[c]{border-radius:9in}a{position:fixed}[a]{width:200;height:200;top:50;left:100;box-shadow:-226px 0 #243d83,226px 0 #243d83}[b]{width:400;height:40;top:130}[c]{width:32;height:32;top:108;left:71;box-shadow:0 52px #6592cf,226px 0 #6592cf,226px 52px #6592cf}</style>'
};


var $17512fdc91130640$export$2e2bcd8739ae039 = {
    id: 93,
    title: 'Target #93 - Great Wall',
    url: 'https://cssbattle.dev/play/93',
    colors: [
        '#4F77FF',
        '#191919',
        '#F9E492',
        '#D6B73F'
    ],
    solution: '<a a><a b><a c><a d><style>[a],[b]{background:#f9e492}[b],[c]{height:16}body{background:#191919}a{position:fixed}[a]{top:90;left:140;width:40;height:40;border-radius:9in}[b]{top:172;left:0;width:200;box-shadow:0 26px #f9e492,0 52px #f9e492,220px -13px #f9e492,220px 13px #f9e492,220px 39px #f9e492}[c]{top:165;left:200;width:20;background:#d6b73f;transform:skewY(-33deg);box-shadow:0 26px #d6b73f,0 52px #d6b73f}[d]{top:0;left:0;width:400;height:300;background:radial-gradient(circle,transparent,transparent 100px,#4f77ff 100px)}</style>'
};


var $309cc72593f33a17$export$2e2bcd8739ae039 = {
    id: 94,
    title: 'Target #94 - Ripples',
    url: 'https://cssbattle.dev/play/94',
    colors: [
        '#0E2E2C',
        '#F3AC3C',
        '#998235'
    ],
    solution: '<p><style>body{background:#0e2e2c}p{position:fixed;width:200;height:200;border-radius:50%;top:34;left:100;box-shadow:inset 0 0 0 6px #f3ac3c,inset 0 0 0 20px #0e2e2c,inset 0 0 0 28px #f3ac3c,inset 0 0 0 40px #0e2e2c,inset 0 0 0 50px #998235,inset 0 0 0 60px #0e2e2c,inset 0 0 0 72px #f3ac3c,inset 0 0 0 80px #0e2e2c,inset 0 0 0 100px #f3ac3c}</style>'
};


var $1b3d92d6583564a6$export$2e2bcd8739ae039 = {
    id: 95,
    title: 'Target #95 - Pokeball',
    url: 'https://cssbattle.dev/play/95',
    colors: [
        '#6CB3A9',
        '#D25B70',
        '#FFFFFF',
        '#781728',
        '#F6DF96'
    ],
    solution: '<a a><a b><a c><style>[b],[c]{border-radius:9in}body{background:#6cb3a9}a{position:fixed}[a]{background:#781728;top:140;left:110;width:180;height:20}[b]{top:50;left:100;width:200;height:200;background:linear-gradient(to bottom,#d25b70,#d25b70 90px,transparent 90px,transparent 110px,#fff 110px)}[c]{top:115;left:165;width:50;height:50;background:#f6df96;border:10px solid #781728}</style>'
};


var $8024792ebbdd53e5$export$2e2bcd8739ae039 = {
    id: 96,
    title: 'Target #96 - Mandala',
    url: 'https://cssbattle.dev/play/96',
    colors: [
        '#6592CF',
        '#243D83'
    ],
    solution: '<a><p a><p b><p c><p d><style>a,p{border-radius:9in}[a],[d]{left:115}body{background:#243d83}a,p{position:fixed}a{background:#6592cf;top:50;left:100;width:200;height:200}p{width:130;height:130;border:20px solid #243d83}[a]{bottom:124}[b]{top:49;left:40}[c]{top:49;right:40}[d]{top:124}</style>'
};


var $d7475d4727836134$export$2e2bcd8739ae039 = {
    id: 97,
    title: 'Target #97 - Snowman',
    url: 'https://cssbattle.dev/play/97',
    colors: [
        '#AC474B',
        '#FFFFFF',
        '#0E1F2B',
        '#FFA63F'
    ],
    solution: '<a a><a b><a c><style>[a],[c]{left:170;width:60}[a],[b],[c]{width:60}body{background:#ac474b}a{position:fixed}[a]{top:95;height:60;background:radial-gradient(circle at 20px 23px,#0e1f2b 5px,transparent 5px),radial-gradient(circle at 40px 23px,#0e1f2b 5px,#fff 5px);border-radius:9in;box-shadow:0 70px 0 20px #fff}[b]{top:139;left:166;height:10;background:#ffa63f;border:4px solid #ac474b;border-radius:9in;box-shadow:-10px 0 #ac474b,10px 0 #ac474b}[c]{top:55;height:45;clip-path:polygon(10px 0,50px 0,50px 40px,60px 40px,60px 45px,0 45px,0 40px,10px 40px);background:linear-gradient(to bottom,#0e1f2b 15px,#fff 15px 25px,#0e1f2b 25px)}</style>'
};


var $eafe54ee030ab440$export$2e2bcd8739ae039 = {
    id: 98,
    title: 'Target #98 - Candle',
    url: 'https://cssbattle.dev/play/98',
    colors: [
        '#14313E',
        '#BA3E46',
        '#F3695A',
        '#F3AC3C'
    ],
    solution: '<a a><a b><a c><style>[a],[b]{left:160;width:80}body{background:#14313e}a{position:fixed}[a]{top:125;height:115;background:#ba3e46;border-radius:0 0 50px 50px/0 0 18px 18px}[b]{top:110;height:30;background:radial-gradient(30px 15px at 50% 5px,#14313e 35px,#f3695a 35px);border-radius:100%}[c]{top:60;left:200;width:30;height:50;background:#f3ac3c;border-radius:9in 0}</style>'
};


var $d9166ed7a64082f7$export$2e2bcd8739ae039 = {
    id: 99,
    title: 'Target #99 - Gift Box',
    url: 'https://cssbattle.dev/play/99',
    colors: [
        '#AC474B',
        '#FFFFFF'
    ],
    solution: '<a a><a b><a c><style>[b],[c]{top:50;width:20;height:20}body{background:#ac474b}a{position:fixed}[a]{top:110;left:130;width:60;height:60;background:#fff;box-shadow:80px 0 #fff,0 80px #fff,80px 80px #fff}[b]{left:165;border:10px solid #fff;border-radius:9in 9in 0}[c]{left:195;border:10px solid #fff;border-radius:9in 9in 9in 0}</style>'
};


var $7014930755311802$export$2e2bcd8739ae039 = {
    id: 100,
    title: 'Target #100 - CSSBattle',
    url: 'https://cssbattle.dev/play/100',
    colors: [
        '#14313E',
        '#FFDF00'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><a g><a h><a i><style>[c],body{background:#14313e}[d],[e]{top:109;width:150;height:30;clip-path:polygon(15px 0,150px 0,150px 30px,15px 30px,0 15px)}[f],[g]{top:174;width:80}[e],[f],[h]{transform:rotate(45deg)}[d],[g],[i]{transform:rotate(135deg)}[h],[i]{top:189;width:60;height:20;background:#ffdf00;border-radius:8px}a{position:fixed}[a]{top:130;left:53;width:294;height:40;background:#ffdf00;border-radius:5px}[b]{top:75;left:63;width:274;height:150;background:linear-gradient(to right,#ffdf00 40px,#14313e 40px 234px,#ffdf00 234px);border-radius:20px}[c]{top:100;left:88;width:224;height:100;border-radius:10px}[d]{left:145;background:#ffdf00;background:linear-gradient(to right,#ffdf00 78px,#14313e 79px 128px,#ffdf00 129px)}[e]{left:105;background:#ffdf00}[f]{left:120;height:20;background:#ffdf00}[g]{left:200;height:20;background:#ffdf00}[h]{left:224}[i]{left:116}</style>'
};


var $42ae1da4a10e2982$export$2e2bcd8739ae039 = {
    id: 101,
    title: 'Target #101 - Sharingan',
    url: 'https://cssbattle.dev/play/101',
    colors: [
        '#161616',
        '#A22015',
        '#000000',
        '#E96A23'
    ],
    solution: '<a a><a b><style>body{background:#a22015}a{position:fixed}[a]{top:185;left:150;width:100;height:100;border-radius:9in;box-shadow:inset 0 0 0 15px,74px -128px 0 -15px #a22015,74px -128px,-74px -128px 0 -15px #a22015,-74px -128px,0 -85px 0 -25px,0 -85px 0 -15px #e96a23,0 -85px}[b]{top:0;left:0;width:400;height:300;background:radial-gradient(circle,transparent 95px,#000 95px 100px,#161616 100px)}</style>'
};


var $2864823820915414$export$2e2bcd8739ae039 = {
    id: 102,
    title: 'Target #102 - One Piece',
    url: 'https://cssbattle.dev/play/102',
    colors: [
        '#000000',
        '#FFFFFF'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><style>[b],[c]{height:20}[a],[d]{border-radius:9in;background:#fff}[a],[b],[c],[d]{background:#fff}[e],[f]{top:140;width:50;height:40;background:#000;border-radius:100%}body{background:#000}a{position:fixed}[a]{top:95;left:94.5;width:25;height:25;box-shadow:10.5px -10.5px #fff,175.5px -10.5px #fff,185.5px 0 #fff,0 105px #fff,10.5px 115px #fff,175.5px 115.5px #fff,185.5px 105px #fff}[b]{top:103;left:113;width:20;transform:rotate(45deg);box-shadow:108.5px -108.5px #fff,66px 66px #fff,175px -42px #fff}[c]{top:220;left:173;width:15;box-shadow:20px 0 #fff,40px 0 #fff}[d]{top:110;left:125;width:150;height:100}[e]{left:145;transform:rotate(-30deg)}[f]{left:205;transform:rotate(30deg)}</style>'
};


var $73adb96f41a2dc9f$export$2e2bcd8739ae039 = {
    id: 103,
    title: 'Target #103 - Super Saiyan',
    url: 'https://cssbattle.dev/play/103',
    colors: [
        '#161616',
        '#EBAE11',
        '#FFFFFF',
        '#FFDEB9'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><a g><style>[a],[b]{top:130}[d],[e]{top:112}[a],[b],[d],[e]{background:linear-gradient(transparent 50%,#ebae11 50%);border-radius:9in}[a],[b],[d],[e],[f]{width:60;height:60}[a],[b],[d],[e],[g]{border-radius:9in}body{background:#161616}a{position:fixed}[a]{left:141;transform:rotate(15deg)}[b]{left:199;transform:rotate(-15deg)}[c]{top:150;left:160;width:80;height:66;background:linear-gradient(90deg,#fff 50%,#ffdeb9 50%);border-radius:0 0 9in 9in}[d]{left:155;transform:rotate(60deg)}[e]{left:185;transform:rotate(-60deg)}[f]{top:96;left:170;background:#ebae11;border-radius:100% 0;transform:rotate(-45deg)}[g]{top:186;left:190;width:20;height:20;background:linear-gradient(transparent 50%,#161616 50%)}</style>'
};


var $513fe17e961d750e$export$2e2bcd8739ae039 = {
    id: 104,
    title: 'Target #104 - Amegakure',
    url: 'https://cssbattle.dev/play/104',
    colors: [
        '#000000',
        '#37385A',
        '#9897AE',
        '#C0C3DB'
    ],
    solution: '<a a><a b><a c><a d><style>[c],[d]{top:125;width:10;background:#000;border-radius:9in}body{background:#000}a{position:fixed}[a]{top:90;left:80;width:240;height:120;background:#37385a;border-radius:20px}[b]{top:110;left:100;width:200;height:80;background:linear-gradient(-75deg,#9897ae 0 38%,#c0c3db 38% 62%,#9897ae 62%);border-radius:10px}[c]{left:165;height:50;box-shadow:20px 0,40px 0,60px 0}[d]{left:115;height:10;box-shadow:0 20px,0 40px,160px 0,160px 20px,160px 40px}</style>'
};


var $61585453e44a7291$export$2e2bcd8739ae039 = {
    id: 105,
    title: 'Target #105 - Ryuk',
    url: 'https://cssbattle.dev/play/105',
    colors: [
        '#BAC7CE',
        '#475862',
        '#000000',
        '#868A64',
        '#5A6042',
        '#4E2B24'
    ],
    solution: '<a a><a b><a c><a d><a e><style>[b],[d]{top:130;width:120;height:120;background:#000;border-radius:0 60px}[c],[e]{top:140;width:100;height:100;border-radius:9in;box-shadow:inset 0 15px #5a6042,inset 0 0 0 30px #868a64,inset 0 0 0 35px #000,inset 0 0 0 50px #4e2b24}body{background:#bac7ce}a{position:fixed}[a]{top:0;left:108;width:184;height:92;background:#475862;clip-path:polygon(0 0,100% 0,50% 100%)}[b]{left:30;transform:rotate(-15deg)}[c]{left:40}[d]{left:250;transform:rotate(105deg)}[e]{left:260}</style>'
};


var $ed5b174d0d360492$export$2e2bcd8739ae039 = {
    id: 106,
    title: "Target #106 - Ryuk's Apple",
    url: 'https://cssbattle.dev/play/106',
    colors: [
        '#000000',
        '#D4392D'
    ],
    solution: '<a a><a b><a c><a d><style>[a],[b]{top:90;width:100;height:120;background:#d4392d}[c],body{background:#000}[a],[c]{border-radius:100%;transform:rotate(30deg)}[a],[b],[d]{background:#d4392d}a{position:fixed}[a]{left:180}[b]{left:120;border-radius:100%;transform:rotate(-30deg)}[c]{top:100;left:100;width:50;height:60;box-shadow:20px 35px}[d]{top:70;left:195;width:10;height:50}</style>'
};


var $361638324c310cf9$export$2e2bcd8739ae039 = {
    id: 107,
    title: 'Target #107 - Sealing Wand',
    url: 'https://cssbattle.dev/play/107',
    colors: [
        '#161616',
        '#E96A23',
        '#FFFFFF',
        '#A22015'
    ],
    solution: '<a a><a b><a c><a d><a e><style>[a],[b]{background:#e96a23}body{background:#161616}a{position:fixed}[a]{bottom:0;left:190;width:20;height:120}[b]{top:129;right:120;width:70;height:40;border-radius:0 40px 5px 0}[c]{bottom:97;left:185;width:30;height:50;background:#a22015;border-radius:10px}[d]{top:120;left:170;width:60;height:60;background:radial-gradient(circle,#161616 10px,#a22015 10px 15px,#fff 15px 25px,#a22015 25px);border-radius:9in}[e]{top:132;left:130;width:53;height:12;background:#fff;border-radius:0 0 0 9in;box-shadow:15px 12px #fff,30px 24px #fff;clip-path:inset(0 0 -24px 0)}</style>'
};


var $110175f69c698ddb$export$2e2bcd8739ae039 = {
    id: 108,
    title: 'Target #108 - Clow Card',
    url: 'https://cssbattle.dev/play/108',
    colors: [
        '#000000',
        '#E96A23',
        '#EBAE11'
    ],
    solution: '<a a><a b><a c><a d><a e><style>[b],body{background:#000}a{position:fixed}[a]{top:75;left:50;width:300;height:150;background:linear-gradient(-75deg,#e96a23 36.3%,#ebae11 36.3% 43.9%,#e96a23 43.9% 48.1%,#ebae11 48.1% 63.4%,#e96a23 63.4%)}[b]{top:90;left:80;width:240;height:90;border-radius:12px;box-shadow:-15px 15px,15px 15px,0 30px}[c]{top:125;left:175;width:50;height:50;background:#ebae11;border-radius:9in}[d]{top:115;left:135;width:120;height:60;border:5px solid #ebae11;border-radius:100%}[e]{top:105;left:95;width:200;height:80;border:5px solid #ebae11;border-radius:100%}</style>'
};


var $09384f77bd71c295$export$2e2bcd8739ae039 = {
    id: 109,
    title: 'Target #109 - Curtain',
    url: 'https://cssbattle.dev/play/109',
    colors: [
        '#191919',
        '#F6E59C'
    ],
    solution: '<p><style>body{background:#191919}p{width:40;height:40;border-radius:50%;background:#f6e59c;position:fixed;top:4;left:20;box-shadow:60px 0 #f6e59c,120px 0 #f6e59c,180px 0 #f6e59c,0 60px #f6e59c,60px 60px #f6e59c,120px 60px #f6e59c,0 120px #f6e59c,60px 120px #f6e59c,0 180px #f6e59c}</style>'
};


var $d4ee21a526e1cf41$export$2e2bcd8739ae039 = {
    id: 110,
    title: 'Target #110 - Sunrays',
    url: 'https://cssbattle.dev/play/110',
    colors: [
        '#D25B70',
        '#F2E09F'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><a g><style>body{background:#d25b70}a{top:195;left:80;width:100;height:10;position:fixed;background:#f2e09f;border-radius:9in;transform-origin:120px}[a]{transform:rotate(0)}[b]{transform:rotate(30deg)}[c]{transform:rotate(60deg)}[d]{transform:rotate(90deg)}[e]{transform:rotate(120deg)}[f]{transform:rotate(150deg)}[g]{transform:rotate(180deg)}</style>'
};


var $283599f7f7314128$export$2e2bcd8739ae039 = {
    id: 111,
    title: 'Target #111 - Rain Drops',
    url: 'https://cssbattle.dev/play/111',
    colors: [
        '#F3AC3C',
        '#254241'
    ],
    solution: '<a a><a b><style>[a],[b]{background:#254241}body{background:#f3ac3c}a{position:fixed}[a]{top:110;left:80;width:80;height:80;border-radius:9in;box-shadow:80px -70px #254241,80px 70px #254241}[b]{top:130;left:128;width:40;height:40;box-shadow:7px -66px #254241,66px -7px #254241;transform:rotate(45deg)}</style>'
};


var $7b2805f95a5f40fe$export$2e2bcd8739ae039 = {
    id: 112,
    title: 'Target #112 - Chevron',
    url: 'https://cssbattle.dev/play/112',
    colors: [
        '#6592CF',
        '#293D7E'
    ],
    solution: '<a><a a><a b><style>body{background:#6592cf}a{position:fixed;top:50;left:75;width:250;height:100;background:#293d7e;clip-path:polygon(0 0,50% 100%,100% 0,85% 0,50% 70%,15% 0)}[a]{top:100}[b]{top:150}</style>'
};


var $1746c53cbb116cc1$export$2e2bcd8739ae039 = {
    id: 113,
    title: 'Target #113 - Black Light',
    url: 'https://cssbattle.dev/play/113',
    colors: [
        '#5776F6',
        '#191919'
    ],
    solution: '<p><style>body{background:#5776f6;margin:0}p{width:400;height:300;background:#191919;clip-path:polygon(0 125px,100% 100px,100% 200px,0 175px)}</style>'
};


var $938d1602aa229625$export$2e2bcd8739ae039 = {
    id: 114,
    title: 'Target #114 - Negative Box',
    url: 'https://cssbattle.dev/play/114',
    colors: [
        '#172D2C',
        '#E9AF53'
    ],
    solution: '<p><style>body{background:#172d2c;margin:0}p{width:400;height:300;background:#e9af53;clip-path:polygon(200px 20px,380px 85px,200px 150px,20px 85px,20px 215px,200px 280px)}</style>'
};


var $b87cbbd559489f8c$export$2e2bcd8739ae039 = {
    id: 115,
    title: 'Target #115 - Droplet',
    url: 'https://cssbattle.dev/play/115',
    colors: [
        '#C36271',
        '#F2E09F'
    ],
    solution: '<a a><a b><style>a{position:fixed}[a]{top:0;left:20;width:360;height:150;background:#f2e09f;border-radius:100px 0;box-shadow:150px 0 #c36271,-150px 0 #f2e09f,0 150px #c36271,150px 150px #c36271,-150px 150px #f2e09f}[b]{top:100;left:150;width:100;height:100;background:linear-gradient(to bottom,#c36271 50px,#f2e09f 50px);border-radius:9in}</style>'
};


var $b0a70e3131f0d854$export$2e2bcd8739ae039 = {
    id: 116,
    title: 'Target #116 - Headphones',
    url: 'https://cssbattle.dev/play/116',
    colors: [
        '#293D7E',
        '#6E91CA'
    ],
    solution: '<p a><p b><style>[a],[b]{left:115}body{background:#293d7e}p{position:fixed}[a]{top:149;width:60;height:80;border-radius:60px 60px 1in 1in;background:#6e91ca;box-shadow:110px 0 #6e91ca}[b]{top:29;width:130;height:120;border-radius:9in 9in 0 0;border:20px solid #6e91ca;border-bottom:none}</style>'
};


var $28248c39f71b5d50$export$2e2bcd8739ae039 = {
    id: 117,
    title: 'Target #117 - Arineo',
    url: 'https://cssbattle.dev/play/117',
    colors: [
        '#FFFFFF',
        '#0088CA',
        '#2E2926'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><style>[c],[d]{height:51;background:#fff}[c],[e]{left:120;width:80;transform:skewy(45deg)}[d],[f]{left:200;width:120;transform:skewy(-45deg)}[e],[f]{height:28;background:#0088ca}[a],[b]{top:60;width:44;height:180;background:#2e2926}body{background:radial-gradient(circle,#0088ca 11px,#fff 11px)}a{position:fixed}[a]{left:134;transform:skew(-25deg)}[b]{right:134;transform:skew(25deg)}[c]{top:138}[d]{top:118}[e]{top:150}[f]{top:130}</style>'
};


var $db4299f043d8c809$export$2e2bcd8739ae039 = {
    id: 118,
    title: 'Target #118 - Donkey Kong',
    url: 'https://cssbattle.dev/play/118',
    colors: [
        '#000000',
        '#AF067C',
        '#FFFFFF'
    ],
    solution: '<a a><a b><a c><style>[b],[c]{left:50;width:300;height:20;border-radius:9in;background:#af067c}body{background:#000}a{position:fixed}[a]{top:100;left:80;width:20;height:60;background:#fff;color:#fff;box-shadow:220px 0,110px 45px,220px 45px}[b]{top:140;transform:rotate(-4deg)}[c]{top:90;box-shadow:0 100px #af067c}</style>'
};


var $1ab1f19518897e29$export$2e2bcd8739ae039 = {
    id: 119,
    title: 'Target #119 - Pacman',
    url: 'https://cssbattle.dev/play/119',
    colors: [
        '#000000',
        '#E0E246',
        '#C74E4E',
        '#FFFFFF'
    ],
    solution: '<a a><a b><a c><a d><style>[a],[b]{top:120;width:60;height:60}[c],body{background:#000}[a],[d]{border-radius:9in}a{position:fixed}[a]{left:60;background:#e0e246}[b]{right:60;background:#c74e4e;border-radius:9in 9in 0 0}[c]{top:132.5;left:95;width:35;height:35;transform:rotate(45deg);box-shadow:155px -95px,170px -110px,184px -124px}[d]{top:145;left:165;width:10;height:10;background:#fff;color:#fff;box-shadow:30px 0,60px 0}</style>'
};


var $7ebe2f40e1524229$export$2e2bcd8739ae039 = {
    id: 120,
    title: 'Target #120 - Tank',
    url: 'https://cssbattle.dev/play/120',
    colors: [
        '#000000',
        '#54C144',
        '#C74E4E',
        '#FFFFFF'
    ],
    solution: '<a a><a b><a c><a d><style>[a],[c]{left:60}[b],[c]{width:40}[c],[d]{height:10}body{background:#000;border:20px solid #54c144;margin:0}a{position:fixed}[a]{top:60;width:200;height:40;background:linear-gradient(90deg,#c74e4e 80px,#000 80px 120px,#c74e4e 120px);box-shadow:0 80px #c74e4e}[b]{top:60;right:60;height:180;background:#c74e4e}[c]{top:200;background:#54c144;color:#54c144;box-shadow:10px 15px,0 30px}[d]{top:215;left:140;width:10;background:#fff;box-shadow:-20px 0 #fff,-65px 0 0 5px #54c144}</style>'
};


var $18257b2a794e6c0a$export$2e2bcd8739ae039 = {
    id: 121,
    title: 'Target #121 - Duck Hunt',
    url: 'https://cssbattle.dev/play/121',
    colors: [
        '#1E92FF',
        '#6F6100',
        '#69D10A',
        '#441A0A'
    ],
    solution: '<a a><a b><style>body{background:linear-gradient(#1e92ff 180px,#69d10a 180px 220px,#6f6100 220px)}a{position:fixed}[a]{top:100;left:50;width:20;height:80;background:#441a0a}[b]{top:60;left:40;width:40;height:40;background:#69d10a;color:#69d10a;border-radius:9in;box-shadow:-20px 20px,20px 20px,0 20px,270px 70px,270px 90px}</style>'
};


var $f9064627bc0416a1$export$2e2bcd8739ae039 = {
    id: 122,
    title: 'Target #122 - Tetris',
    url: 'https://cssbattle.dev/play/122',
    colors: [
        '#173889',
        '#EE4F63',
        '#2CE1EA',
        '#F8DA37',
        '#B069F7'
    ],
    solution: '<a><style>body{background:#173889}a{position:fixed;top:0;left:50;width:45;height:45;color:#ee4f63;box-shadow:0 255px #f8da37,51px 255px #2ce1ea,102px 255px #2ce1ea,153px 255px #2ce1ea,204px 255px #b069f7,255px 255px #2ce1ea,0 204px,51px 204px,102px 204px,153px 204px #2ce1ea,204px 204px #b069f7,255px 204px #b069f7,0 153px #f8da37,51px 153px #f8da37,102px 153px,204px 153px #b069f7,0 102px #f8da37,51px 102px #f8da37,153px 102px,153px 51px,204px 51px,204px 0}</style>'
};


var $5512cfc93de1cc16$export$2e2bcd8739ae039 = {
    id: 123,
    title: 'Target #123 - Snake',
    url: 'https://cssbattle.dev/play/123',
    colors: [
        '#C74E4E',
        '#E0E246',
        '#FFFFFF'
    ],
    solution: '<a a><a b><style>[a],[b]{top:90;left:90;width:20;height:20}body{background:#c74e4e}a{position:fixed}[a]{background:#fff;border-radius:9in}[b]{color:#e0e246;border-radius:5px;box-shadow:0 100px,25px 100px,50px 100px,75px 100px,100px 100px,125px 100px,150px 100px,175px 100px,200px 100px,200px 75px,200px 50px,200px 25px,200px 0,100px 0,125px 0,150px 0,175px 0}</style>'
};


var $1019d5efdceb0708$export$2e2bcd8739ae039 = {
    id: 124,
    title: 'Target #124 - Space Invaders',
    url: 'https://cssbattle.dev/play/124',
    colors: [
        '#071945',
        '#B069F7',
        '#F8DA37',
        '#2CE1EA'
    ],
    solution: '<a a><a b><a c><style>[a],[b]{height:10;background:#b069f7;color:#b069f7}body{background:#071945}a{position:fixed}[a]{top:40;left:40;width:50;box-shadow:90px 0,180px 0,270px 0,0 50px #f8da37,180px 50px #f8da37,270px 50px #f8da37}[b]{top:50;left:30;width:10;box-shadow:90px 0,180px 0,270px 0,0 50px #f8da37,180px 50px #f8da37,270px 50px #f8da37,60px 0,150px 0,240px 0,330px 0,60px 50px #f8da37,240px 50px #f8da37,330px 50px #f8da37,165px 160px #2ce1ea,165px 190px #2ce1ea,165px 220px #2ce1ea,165px 230px #2ce1ea}[c]{bottom:0;left:179;width:42;height:21;background:#2ce1ea;clip-path:polygon(0 100%,50% 0,100% 100%)}</style>'
};


var $b165cdc09e249213$export$2e2bcd8739ae039 = {
    id: 125,
    title: 'Target #125 - Root Learn',
    url: 'https://cssbattle.dev/play/125',
    colors: [
        '#EFF2F1',
        '#1C1C1C'
    ],
    solution: '<a a><a b><a c><style>[a],body{background:#eff2f1}[b],[c]{background:#1c1c1c}a{position:fixed}[a]{top:75;left:130;width:90;height:60;border-radius:0 9in 9in 0;box-shadow:25px 0 0 15px #1c1c1c}[b]{top:60;left:110;width:80;height:180;clip-path:polygon(0 0,75% 0,75% 88.5%,100% 95%,100% 100%,0 100%,0 95%,25% 88.5%,25% 11.5%,0 5%)}[c]{top:135;left:170;width:120;height:105;clip-path:polygon(1% 0,51% 100%,100% 100%,100% 94%,80% 81%,39% 0)}</style>'
};


var $e2658aab4bb0bea4$export$2e2bcd8739ae039 = {
    id: 126,
    title: 'Target #126 - Letter A',
    url: 'https://cssbattle.dev/play/126',
    colors: [
        '#62306D',
        '#FEF9CA',
        '#C5B732',
        '#E38F66',
        '#AA445F'
    ],
    solution: '<a a><a b><a c><a d><style>[a],[c]{top:80;width:42;height:140}[b],[d]{top:170;width:52;height:50}body{background:#62306d}a{position:fixed}[a]{left:209;transform:skew(20deg);background:#c5b732}[b]{left:198;transform:skew(40deg);background:#aa445f}[c]{left:149;transform:skew(-20deg);background:#fef9ca}[d]{left:150;transform:skew(-40deg);background:#e38f66}</style>'
};


var $e7aa6bb446378cfc$export$2e2bcd8739ae039 = {
    id: 127,
    title: 'Target #127 - Letter I',
    url: 'https://cssbattle.dev/play/127',
    colors: [
        '#E3516E',
        '#FADE8B'
    ],
    solution: '<a a><a b><a c><style>[b],body{background:#e3516e}[b],[c]{width:30}[a],[c]{top:70;background:#fade8b}a{position:fixed}[a]{left:165;width:70;height:160}[b]{top:100;left:155;height:100;border-radius:10px;box-shadow:60px 0 #e3516e}[c]{left:150;height:30;border-radius:9in;box-shadow:70px 0 #fade8b,110px 0 #fade8b,-40px 130px #fade8b,0 130px #fade8b,70px 130px #fade8b}</style>'
};


var $479517ea6e335dec$export$2e2bcd8739ae039 = {
    id: 128,
    title: 'Target #128 - Letter N',
    url: 'https://cssbattle.dev/play/128',
    colors: [
        '#998235',
        '#0B2429',
        '#FCBE5C'
    ],
    solution: '<a a><a b><a c><style>[a],[c]{width:40;height:230;background:#0b2429}body{background:#998235}a{position:fixed}[a]{bottom:70;right:135}[b]{top:70;left:179;width:42;height:160;background:#fcbe5c;transform:skew(20deg)}[c]{top:70;left:135}</style>'
};


var $530fde5599d8df2b$export$2e2bcd8739ae039 = {
    id: 129,
    title: 'Target #129 - Letter B',
    url: 'https://cssbattle.dev/play/129',
    colors: [
        '#6592CF',
        '#515DBD',
        '#2E3B9F',
        '#060F55'
    ],
    solution: '<a><style>body{background:#6592cf}a{position:fixed;top:80;left:110;width:100;height:80;border-radius:0 9in 9in 0;background:#060f55;box-shadow:0 60px #060f55,40px 0 #2e3b9f,40px 60px #2e3b9f,80px 0 #515dbd,80px 60px #515dbd}</style>'
};


var $79d4f5efed9f7b91$export$2e2bcd8739ae039 = {
    id: 130,
    title: 'Target #130 - Letter O',
    url: 'https://cssbattle.dev/play/130',
    colors: [
        '#926927',
        '#FFFFFF',
        '#6D480A'
    ],
    solution: '<p a><p b><style>body{background:#926927}p{width:60;height:120;position:fixed;top:54;border:20px solid #fff;border-radius:30px}[a]{left:140;border-color:#6d480a}[b]{left:160}</style>'
};


var $ee85d93c20918f57$export$2e2bcd8739ae039 = {
    id: 131,
    title: 'Target #131 - Letter W',
    url: 'https://cssbattle.dev/play/131',
    colors: [
        '#E38F66',
        '#62306D',
        '#FFFBDA'
    ],
    solution: '<a a><a b><a c><style>[b],[c]{left:95}body{background:#e38f66}a{position:fixed}[a],[b]{bottom:70;width:60;height:115;border:30px solid;border-top:0;border-radius:0 0 9in 9in}[a]{left:185;border-color:#fffbda}[b]{border-color:#62306d}[c]{top:70;width:30;height:30;border-radius:9in;background:#62306d;box-shadow:90px 0 #62306d,180px 0 #fffbda}</style>'
};


var $dabb2f35d9e476d3$export$2e2bcd8739ae039 = {
    id: 132,
    title: 'Target #132 - Letter S',
    url: 'https://cssbattle.dev/play/132',
    colors: [
        '#4F77FF',
        '#FFFFFF',
        '#1038BF'
    ],
    solution: '<a a><a b><a c><style>[a],[c]{width:240}[b],[c]{left:80;background:#fff;border-radius:9in}body{background:#4f77ff}a{position:fixed}[a]{top:70;left:80;height:50;background:#fff;border-radius:10px;box-shadow:20px -20px #1038bf,0 110px #fff,-20px 130px #1038bf}[b]{top:100;width:20;height:60;box-shadow:220px 40px #fff}[c]{top:140;height:20}</style>'
};


var $4e685de629842055$export$2e2bcd8739ae039 = {
    id: 133,
    title: 'Target #133 - Spiral',
    url: 'https://cssbattle.dev/play/133',
    colors: [
        '#F5D6B4',
        '#D86F45'
    ],
    solution: '<a a><a b><a c><a d><a e><style>[a],[c]{clip-path:inset(50% 0 0 0)}[b],[d]{clip-path:inset(0 0 50% 0)}[a],[e]{left:80}body{background:#f5d6b4}a{position:fixed}[a]{top:50;width:160;height:160;border:20px solid #d86f45;border-radius:9in}[b],[c]{left:120;border:20px solid #d86f45}[b]{top:70;width:120;height:120;border-radius:9in}[c]{top:90;width:80;height:80;border-radius:9in}[d]{top:110;left:160;width:40;height:40;border:20px solid #d86f45;border-radius:9in}[e]{top:140;width:20;height:20;border-radius:9in;background:#d86f45;box-shadow:80px 0 #d86f45}</style>'
};


var $847567ef09f84a44$export$2e2bcd8739ae039 = {
    id: 134,
    title: 'Target #134 - Wig',
    url: 'https://cssbattle.dev/play/134',
    colors: [
        '#62306D',
        '#F7EC7D'
    ],
    solution: '<p a><p b><style>body{background:#62306d}p{position:fixed;top:54;width:80;height:160;background:#f7ec7d;border-radius:80px 0 40px}[a]{left:120}[b]{left:200;transform:scalex(-1)}</style>'
};


var $e22d58ea0f881d0d$export$2e2bcd8739ae039 = {
    id: 135,
    title: 'Target #135 - Spikes',
    url: 'https://cssbattle.dev/play/135',
    colors: [
        '#E3516E',
        '#D9D9D9'
    ],
    solution: '<a a><a b><style>[b],body{background:#e3516e}a{position:fixed}[a]{top:100;left:0;width:190;height:40;background:#d9d9d9;border-radius:9in;box-shadow:0 60px #d9d9d9,210px 0 #d9d9d9,210px 60px #d9d9d9}[b]{top:0;left:19;width:212;height:212;transform-origin:top left;transform:rotate(45deg);box-shadow:256px -256px #e3516e}</style>'
};


var $b3bfdd2524c06d9f$export$2e2bcd8739ae039 = {
    id: 136,
    title: 'Target #136 - Alien Eye',
    url: 'https://cssbattle.dev/play/136',
    colors: [
        '#998235',
        '#FCBE5C',
        '#0B2429'
    ],
    solution: '<a><style>body{background:#998235}a{position:fixed;top:60;left:110;width:180;height:180;border-radius:9in;box-shadow:inset 10px 0 0 20px #fcbe5c,inset 0 0 0 40px #0b2429,inset 10px 0 0 60px #fcbe5c}</style>'
};


var $ec1f527e16b32519$export$2e2bcd8739ae039 = {
    id: 137,
    title: 'Target #137 - Elbow',
    url: 'https://cssbattle.dev/play/137',
    colors: [
        '#6592CF',
        '#060F55'
    ],
    solution: '<a><style>body{background:#6592cf}a{width:250;height:150;position:fixed;border:0 solid #060f55;top:50;left:50;border-width:50px 0 0 50px;border-radius:100px 0 0}</style>'
};


var $85d764d383c097c0$export$2e2bcd8739ae039 = {
    id: 138,
    title: 'Target #138 - Lotus',
    url: 'https://cssbattle.dev/play/138',
    colors: [
        '#926927',
        '#6D480A',
        '#FFFFFF'
    ],
    solution: '<a a><a b><a c><style>[a],[b]{background:#6d480a}body{background:#926927}a{position:fixed;width:100px;height:100px;border-radius:0 9in;top:120;left:100;transform-origin:bottom right}[b]{transform:rotate(90deg)}[c]{top:121;background:#fff;transform:rotate(45deg)}</style>'
};


var $d0e230bc75706715$export$2e2bcd8739ae039 = {
    id: 139,
    title: 'Target #139 - Lamp',
    url: 'https://cssbattle.dev/play/139',
    colors: [
        '#E38F66',
        '#FFFBDA',
        '#62306D'
    ],
    solution: '<a a><a b><style>body{background:#e38f66}a{position:fixed}[a]{top:90;left:137;width:127;height:120;background:#fffbda;clip-path:polygon(32px 0,94px 0,126px 120px,0 120px)}[b]{bottom:0;left:195;width:10;height:90;background:#62306d}</style>'
};


var $5c3155525e3bbc88$export$2e2bcd8739ae039 = {
    id: 140,
    title: 'Target #140 - Eclipse',
    url: 'https://cssbattle.dev/play/140',
    colors: [
        '#4F77FF',
        '#1038BF',
        '#FFFFFF'
    ],
    solution: '<a a><a b><style>body{background:#4f77ff}a{position:fixed}[a]{top:90;left:160;width:80;height:80;border-radius:9in;box-shadow:0 -40px #fff}[b]{top:190;left:75;width:250;height:250;background:#1038bf;transform:rotate(45deg)}</style>'
};


var $4fbe083367d697e4$export$2e2bcd8739ae039 = {
    id: 141,
    title: 'Target #141 - Third Eye',
    url: 'https://cssbattle.dev/play/141',
    colors: [
        '#E3516E',
        '#D9D9D9'
    ],
    solution: '<a a><a b><style>body{background:#e3516e}a{position:fixed;background:#d9d9d9}[a]{top:-75;left:-75;width:150;height:150;border-radius:9in;box-shadow:400px 300px #d9d9d9}[b]{top:100;left:150;width:100;height:100;border-radius:9in 0;transform:rotate(45deg)}</style>'
};


var $fd13d16c4560b70b$export$2e2bcd8739ae039 = {
    id: 142,
    title: 'Target #142 - Curtains',
    url: 'https://cssbattle.dev/play/142',
    colors: [
        '#4F77FF',
        '#1038BF',
        '#FFFFFF'
    ],
    solution: '<p a><p b><style>body{background:#4f77ff}p{width:100;height:200;position:fixed;top:34}[a]{width:60;left:50;background:#1038bf;box-shadow:120px 0 #1038bf,240px 0 #1038bf}[b]{width:20;left:130;background:#fff;box-shadow:120px 0 #fff}</style>'
};


var $ae3ef18b875a9ab7$export$2e2bcd8739ae039 = {
    id: 143,
    title: 'Target #143 - Simply Circle',
    url: 'https://cssbattle.dev/play/143',
    colors: [
        '#F5D6B4',
        '#D86F45'
    ],
    solution: '<p><style>body{background:#f5d6b4;margin:0}p{width:200;height:200;background:#d86f45;border-radius:50%}</style>'
};


var $52ad3bb9b3605bbf$export$2e2bcd8739ae039 = {
    id: 144,
    title: 'Target #144 - Long Heart',
    url: 'https://cssbattle.dev/play/144',
    colors: [
        '#62306D',
        '#F7EC7D'
    ],
    solution: '<a a><a b><a c><style>[a],[b]{left:0;background:#f7ec7d}[c],body{background:#62306d}a{position:fixed}[a]{bottom:0;width:165;height:165}[b]{top:100;width:75;height:75;border-radius:9in;box-shadow:125px 125px #f7ec7d}[c]{top:125;left:75;width:100;height:100;border-radius:0 25px}</style>'
};


var $3e7ade0b3c8aec71$export$2e2bcd8739ae039 = {
    id: 145,
    title: 'Target #145 - Spotlight',
    url: 'https://cssbattle.dev/play/145',
    colors: [
        '#E3516E',
        '#D9D9D9'
    ],
    solution: '<a a><a b><style>[a],[b]{width:150}body{background:#e3516e}a{position:fixed;background:#d9d9d9}[a]{height:150;right:0;top:0}[b]{height:200;transform:rotate(45deg);border-radius:9in;right:32;top:7}</style>'
};


var $299d91496150c62a$export$2e2bcd8739ae039 = {
    id: 146,
    title: 'Target #146 - Streaks',
    url: 'https://cssbattle.dev/play/146',
    colors: [
        '#998235',
        '#FCBE5C',
        '#0B2429'
    ],
    solution: '<a><style>body{background:#998235}a{position:fixed;top:253;left:0;width:5in;height:25;background:#fcbe5c;transform:rotate(-45deg);box-shadow:0 25px #0b2429,0 50px #998235,0 75px #fcbe5c,0 100px #0b2429}</style>'
};


var $a082e653b7154ec0$export$2e2bcd8739ae039 = {
    id: 147,
    title: 'Target #147 - Splash',
    url: 'https://cssbattle.dev/play/147',
    colors: [
        '#6592CF',
        '#060F55'
    ],
    solution: '<a><style>body{background:#6592cf}a{position:fixed;top:225;left:325;width:200;height:30;background:#060f55;transform:rotate(45deg);border-radius:9in;box-shadow:0 120px #060f55,-65px 60px 0 10px #060f55}</style>'
};


var $5dc330f7ef69f4e0$export$2e2bcd8739ae039 = {
    id: 148,
    title: 'Target #148 - Eight',
    url: 'https://cssbattle.dev/play/148',
    colors: [
        '#926927',
        '#6D480A'
    ],
    solution: '<a a><a b><style>a,body{background:#926927}a{position:fixed;width:100;height:100;border:40px solid #6d480a;border-radius:9in}[a]{top:-90;left:210;box-shadow:10px 0 #6d480a}[b]{top:10;left:310}</style>'
};


var $d79c8210db88431f$export$2e2bcd8739ae039 = {
    id: 149,
    title: 'Target #149 - Earthworm',
    url: 'https://cssbattle.dev/play/149',
    colors: [
        '#E38F66',
        '#FFFBDA'
    ],
    solution: '<p a><p b><p c><style>[a],[b]{width:100;height:100}[b],body{background:#e38f66}[a],[c]{background:#fffbda;left:0}p{position:fixed}[a]{border-radius:0 20px;top:104;box-shadow:20px 60px #fffbda,80px 80px #fffbda}[b]{border-radius:0 10px;top:204;left:-20;box-shadow:60px -140px #e38f66,140px -60px #e38f66}[c]{border-radius:9in;width:40;height:40;top:84;box-shadow:160px 160px #fffbda}</style>'
};


var $f0851f93e8d3cd58$export$2e2bcd8739ae039 = {
    id: 150,
    title: 'Target #150 - Finger Heart',
    url: 'https://cssbattle.dev/play/150',
    colors: [
        '#4F77FF',
        '#1038BF'
    ],
    solution: '<a a><a b><a c><style>[b],[c]{width:50;height:50;background:#1038bf}[a],[b],[c]{background:#1038bf}body{background:#4f77ff}a{position:fixed}[a]{top:0;left:0;width:150;height:150}[b]{top:150;left:100;border-radius:0 0 9in 9in}[c]{top:100;left:150;border-radius:0 9in 9in 0}</style>'
};


var $6429775ebbeafed2$export$2e2bcd8739ae039 = {
    id: 151,
    title: 'Target #151 - Pawn',
    url: 'https://cssbattle.dev/play/151',
    colors: [
        '#F5D6B4',
        '#D86F45'
    ],
    solution: '<a a><a b><a c><a d><style>body{background:#f5d6b4}a{position:fixed;background:#d86f45}[a]{top:135;left:150;width:100;height:65}[b]{top:55;left:175;width:50;height:50;border-radius:9in;box-shadow:90px 64px 0 45px #f5d6b4,-90px 64px 0 45px #f5d6b4}[c]{top:110;left:160;width:80;height:20;border-radius:10px 10px 20px 20px}[d]{top:205;left:130;width:140;height:40;border-radius:20px 20px 10px 10px}</style>'
};


var $9e7b2380e9b540e6$export$2e2bcd8739ae039 = {
    id: 152,
    title: 'Target #152 - Rook',
    url: 'https://cssbattle.dev/play/152',
    colors: [
        '#62306D',
        '#F7EC7D'
    ],
    solution: '<a a><a b><a c><a d><a e><a f><a g><style>[b],body{background:#62306d}[a],[e]{left:155;width:90}[c],[d],[f]{height:10;border-radius:9in}a{position:fixed;background:#f7ec7d;color:#f7ec7d}[a]{top:60;height:55;border-radius:0 0 10px 10px}[b]{top:50;left:165;width:30;height:50;box-shadow:40px 0 #62306d;border-radius:0 0 5px 5px}[c]{top:55;left:155;width:10;box-shadow:40px 0,80px 0}[d]{top:120;left:170;width:60}[e]{top:135;height:65;background-image:radial-gradient(circle at -56% 15%,#62306d 49.9%,transparent 50.1%),radial-gradient(circle at 156% 15%,#62306d 49.9%,transparent 50.1%)}[f]{top:205;left:145;width:110}[g]{top:220;left:130;width:140;height:25;border-radius:20px 20px 10px 10px}</style>'
};


var $3c6b9dc835c21b10$export$2e2bcd8739ae039 = {
    id: 153,
    title: 'Target #153 - Checkers',
    url: 'https://cssbattle.dev/play/153',
    colors: [
        '#E3516E',
        '#FADE8B'
    ],
    solution: '<a a><a b><style>body{background:#e3516e}a{position:fixed;background:#fade8b;color:#fade8b}[a]{top:50;left:100;width:40;height:40;box-shadow:80px 0,160px 0,40px 40px,120px 40px,0 80px,80px 80px,160px 80px,40px 120px,120px 120px,0 160px,80px 160px,160px 160px}[b]{top:60;left:150;width:20;height:20;border-radius:9in;box-shadow:80px 0,-40px 40px,40px 40px,120px 40px,-40px 120px,40px 120px,120px 120px,0 160px,80px 160px}</style>'
};


var $7c2d1c76233802c8$export$2e2bcd8739ae039 = {
    id: 154,
    title: 'Target #154 - Poker Chip',
    url: 'https://cssbattle.dev/play/154',
    colors: [
        '#998235',
        '#FCBE5C',
        '#0B2429'
    ],
    solution: '<a a><a b><a c><a d><a e><style>[a],[b],[c],[d]{left:185;width:30;background:#0b2429}[a],[b],[c],[d],[e]{top:0;height:300}body{background:#fcbe5c}a{position:fixed}[b]{transform:rotate(45deg)}[c]{transform:rotate(90deg)}[d]{transform:rotate(135deg)}[e]{left:0;width:400;background:radial-gradient(circle,#0b2429 60px,#fcbe5c 60px 70px,#0b2429 70px 80px,transparent 80px 95px,#0b2429 95px 105px,#998235 105px)}</style>'
};


var $eb4079e3dbc4e09c$export$2e2bcd8739ae039 = {
    id: 155,
    title: 'Target #155 - Snakes & Ladders',
    url: 'https://cssbattle.dev/play/155',
    colors: [
        '#6592CF',
        '#060F55'
    ],
    solution: '<p a><p b><style>[a],[b]{left:120}body{background:#6592cf}p{width:100;height:100;background:#060f55;position:fixed}[a]{top:44;width:30;height:300;border-radius:1in;box-shadow:130px 0 #060f55}[b]{top:104;width:160;height:30;box-shadow:0 60px #060f55,0 120px #060f55}</style>'
};


var $c1972aa5ccc774a2$export$2e2bcd8739ae039 = {
    id: 156,
    title: 'Target #156 - Chinese Checkers',
    url: 'https://cssbattle.dev/play/156',
    colors: [
        '#926927',
        '#F8B140'
    ],
    solution: '<a><style>body{background:#926927}a{position:fixed;top:40;left:190;width:20;height:20;border-radius:9in;background:#f8b140;color:#f8b140;box-shadow:-15px 25px,15px 25px,-90px 50px,-60px 50px,-30px 50px,0 50px,30px 50px,60px 50px,90px 50px,-75px 75px,-45px 75px,-15px 75px,15px 75px,45px 75px,75px 75px,-60px 100px,-30px 100px,0 100px,30px 100px,60px 100px,-75px 125px,-45px 125px,-15px 125px,15px 125px,45px 125px,75px 125px,-90px 150px,-60px 150px,-30px 150px,0 150px,30px 150px,60px 150px,90px 150px,-15px 175px,15px 175px,0 200px}</style>'
};


var $1e596b517914fe00$export$2e2bcd8739ae039 = {
    id: 157,
    title: 'Target #157 - Monopoly',
    url: 'https://cssbattle.dev/play/157',
    colors: [
        '#E38F66',
        '#FFFBDA'
    ],
    solution: '<a a><a b><a c><a d><a e><style>[b],[c]{height:20;border-radius:9in}[d],[e]{top:220;width:40;height:40;background:#fffbda;transform:rotate(45deg)}body{background:#e38f66}a{position:fixed}[a]{top:40;left:140;width:120;height:100;background:#fffbda;border-radius:9in 9in 0 0}[b]{top:130;left:110;width:180;background:#fffbda}[c]{top:172;left:160;width:20;background:#fffbda;box-shadow:60px 0 #e38f66,60px 0 0 10px #fffbda}[d]{left:155;border-radius:9in 9in 9in 0}[e]{right:155;border-radius:9in 0 9in 9in}</style>'
};


var $f72973b79deb5eb6$export$2e2bcd8739ae039 = {
    id: 158,
    title: 'Target #158 - Clubs',
    url: 'https://cssbattle.dev/play/158',
    colors: [
        '#4F77FF',
        '#1038BF'
    ],
    solution: '<a a><a b><style>[a],[b]{left:150;width:100;height:100;background:#1038bf}body{background:#4f77ff}a{position:fixed}[a]{top:150}[b]{top:50;border-radius:9in;box-shadow:45px 70px #1038bf,-45px 70px #1038bf,55px 110px #4f77ff,-55px 110px #4f77ff}</style>'
};


var $ce85e919b74a0064$export$2e2bcd8739ae039 = {
    id: 159,
    title: 'Target #159 - Portal',
    url: 'https://cssbattle.dev/play/159',
    colors: [
        '#F5D6B4',
        '#D86F45'
    ],
    solution: '<p a><p b><p c><p d><p e><style>body{background:#f5d6b4}p{position:fixed;top:9;background:#d86f45;width:50;height:250}[a]{left:75}[b]{left:125}[c]{left:175}[d]{left:225}[e]{left:275}[a],[e]{transform:rotatex(78.5deg)}[b],[d]{transform:rotatex(53deg)}</style>'
};


var $18edf20df1a39225$export$2e2bcd8739ae039 = {
    id: 160,
    title: 'Target #160 - Donut',
    url: 'https://cssbattle.dev/play/160',
    colors: [
        '#62306D',
        '#F7EC7D',
        '#E38F66'
    ],
    solution: '<a><style>body{background:#62306d}a{box-sizing:border-box;display:block;position:fixed;top:50;left:100;width:200;height:200;border:40px solid;border-color:#f7ec7d #f7ec7d #f7ec7d #e38f66;border-radius:9in;transform:rotate(45deg)}</style>'
};


var $aaaec5d58e4c9980$export$2e2bcd8739ae039 = {
    id: 161,
    title: 'Target #161 - Converge',
    url: 'https://cssbattle.dev/play/161',
    colors: [
        '#E3516E',
        '#FADE8B'
    ],
    solution: '<a a><a b><a c><style>[b],[c],body{background:#e3516e}a{position:fixed}[a]{top:58;left:108;width:184;height:184;background:#fade8b}[b],[c]{top:0;left:185;width:30;height:300}[b]{transform:rotate(45deg)}[c]{transform:rotate(-45deg)}</style>'
};


var $b2cd7e9d53073707$export$2e2bcd8739ae039 = {
    id: 162,
    title: 'Target #162 - Upwards',
    url: 'https://cssbattle.dev/play/162',
    colors: [
        '#998235',
        '#0B2429',
        '#FCBE5C'
    ],
    solution: '<a></a><style>body{background:#998235}a{position:fixed;top:140;left:115;width:70;height:70;background:#0b2429;transform:rotate(-45deg);box-shadow:70px 0 #0b2429,70px 70px #fcbe5c}</style>'
};


var $c4901678d3ca6d5e$export$2e2bcd8739ae039 = {
    id: 163,
    title: 'Target #163 - Missing Piece',
    url: 'https://cssbattle.dev/play/163',
    colors: [
        '#D669EC',
        '#FDFBF8'
    ],
    solution: '<a a><a b><style>[a],[b]{width:100;height:100}[b],body{background:#d669ec}a{position:fixed}[a]{top:40;left:90;background:#fdfbf8;box-shadow:120px 0 #fdfbf8,0 120px #fdfbf8}[b]{top:100;left:26;transform:rotate(-45deg);box-shadow:175px 0 #d669ec,0 175px #d669ec,175px 175px #d669ec}</style>'
};


var $164e4a3bd875e843$export$2e2bcd8739ae039 = {
    id: 164,
    title: 'Target #164 - Rangoli',
    url: 'https://cssbattle.dev/play/164',
    colors: [
        '#66284A',
        '#D86F45',
        '#F0CD48',
        '#D669EC',
        '#FDFBF8'
    ],
    solution: '<a a><a b><a c><a d><style>[b],[c]{left:150}[a],[d]{top:100}body{background:#66284a}a{position:fixed;width:60;height:60;border:20px solid;transform:rotate(135deg);border-radius:9in}[a]{left:90;border-color:transparent #d86f45 #d86f45}[b]{top:40;border-color:#f0cd48 transparent #f0cd48 #f0cd48}[c]{top:160;border-color:#fdfbf8 #fdfbf8 #fdfbf8 transparent}[d]{left:210;border-color:#d669ec #d669ec transparent}</style>'
};


var $2fdc809d65a34b31$export$2e2bcd8739ae039 = {
    id: 165,
    title: 'Target #165 - Pyramid',
    url: 'https://cssbattle.dev/play/165',
    colors: [
        '#F0CD48',
        '#66284A'
    ],
    solution: '<a a><a b><a c><style>[b],body{background:#f0cd48}[a],[c]{height:100;background:#66284a}[b],[c]{clip-path:polygon(0 100%,50% 0,100% 100%)}a{position:fixed}[a]{top:30;left:150;width:100;border-radius:9in;color:#66284a;box-shadow:-100px 140px,100px 140px}[b]{top:80;left:100;width:200;height:140}[c]{top:105;left:130;width:140}</style>'
};


var $ca8d6b0556e0566f$export$2e2bcd8739ae039 = {
    id: 166,
    title: 'Target #166 - Flow',
    url: 'https://cssbattle.dev/play/166',
    colors: [
        '#D86F45',
        '#FDFBF8'
    ],
    solution: '<a a><a b><a c><a d><style>[a],[b]{left:100}[b],[c]{top:0}[a],[c]{height:100;border-radius:0 0 9in 9in}[a],[b],[c]{border-radius:0 0 9in 9in}[c],[d]{left:160;width:80}body{background:#d86f45}a{position:fixed;background:#fdfbf8;color:#fdfbf8}[a]{top:170;width:200}[b]{width:30;height:125;box-shadow:170px 0}[d]{top:130;height:80;border-radius:9in;box-shadow:-85px 0 0 -25px,-55px 0 0 -25px #d86f45,55px 0 0 -25px #d86f45,85px 0 0 -25px}</style>'
};


var $fbbb326daf1f80e6$export$2e2bcd8739ae039 = {
    id: 167,
    title: 'Target #167 - React India',
    url: 'https://cssbattle.dev/play/167',
    colors: [
        '#0D1335',
        '#FBFAE2',
        '#4FA07B',
        '#DC6638',
        '#73C6EA'
    ],
    solution: '<p a><p b><p c><p d><style>body{background:#0d1335}p{position:fixed}[a],[b],[c]{top:79;left:75;width:230;height:90;border:10px solid;border-radius:100%}[a]{border-color:#fbfae2}[b]{border-color:#4fa07b;transform:rotate(120deg)}[c]{border-color:#dc6638;transform:rotate(60deg)}[d]{background:#73c6ea;top:114;left:180;width:40;height:40;border-radius:9in}</style>'
};


var $846f0ae480e45a21$export$2e2bcd8739ae039 = {
    id: 168,
    title: 'Target #168 - Carpet',
    url: 'https://cssbattle.dev/play/168',
    colors: [
        '#0D1335',
        '#DC6638'
    ],
    solution: '<a a><a b><a c><a d><style>[a],[b]{top:0}[a],[c]{left:0}[c],[d]{bottom:0}[b],[d]{right:0}body{margin:0;background:#0d1335}a{position:fixed;width:70;height:20;background:#dc6638;box-shadow:0 0 0 20px #0d1335,0 0 0 40px #dc6638,0 0 0 60px #0d1335,0 0 0 80px #dc6638,0 0 0 100px #0d1335,0 0 0 120px #dc6638}</style>'
};


var $6068d8ceda78a082$export$2e2bcd8739ae039 = {
    id: 169,
    title: 'Target #169 - Abstract Plate',
    url: 'https://cssbattle.dev/play/169',
    colors: [
        '#0D1335',
        '#FBFAE2',
        '#4FA07B'
    ],
    solution: '<a a><a b><a c><style>body{background:#4fa07b}a{position:fixed}[a]{top:25;left:75;width:250;height:250;border-radius:9in;box-shadow:inset 0 0 0 10px #0d1335,inset 0 0 0 30px #4fa07b,inset 0 0 0 40px #0d1335,inset 0 0 0 60px #4fa07b,inset 0 0 0 70px #0d1335,inset 0 0 0 110px #4fa07b,inset 0 0 0 125px #fbfae2}[b],[c]{top:55.5;width:215;height:169;border:10px solid transparent;border-bottom-color:#fbfae2;background:linear-gradient(to bottom left,transparent 49.5%,#fbfae2 50% calc(50% + 10px),transparent calc(50% + 11px)) right,linear-gradient(to bottom right,transparent 49.5%,#fbfae2 50% calc(50% + 10px),transparent calc(50% + 11px)) left;background-size:50% 100%;background-origin:border-box;background-repeat:no-repeat}[b]{left:22;transform:rotate(90deg)}[c]{right:22;transform:rotate(-90deg)}</style>'
};


var $c131d8c413a34ecf$export$2e2bcd8739ae039 = {
    id: 170,
    title: 'Target #170 - Party Hat',
    url: 'https://cssbattle.dev/play/170',
    colors: [
        '#0D1335',
        '#FBFAE2',
        '#DC6638',
        '#73C6EA'
    ],
    solution: '<a a><a b><a c><style>body{background:#73c6ea}a{position:fixed;bottom:60;left:75;width:250;clip-path:polygon(50% 0,0 100%,100% 100%)}[a]{height:180;background:#0d1335}[b]{height:140;background:#dc6638}[c]{height:100;background:#fbfae2}</style>'
};


var $b65594bfd8dc0928$export$2e2bcd8739ae039 = {
    id: 171,
    title: 'Target #171 - Pumpkin',
    url: 'https://cssbattle.dev/play/171',
    colors: [
        '#784972',
        '#F7FFCF'
    ],
    solution: '<a a><a b><style>body{background:#784972}a{position:fixed;background:#f7ffcf}a[a]{width:100;height:150;border-radius:100%;top:100;left:150;box-shadow:0 0 0 10px #784972,-40px 0 #f7ffcf,-40px 0 0 10px #784972,-80px 0 #f7ffcf,-80px 0 0 10px #784972,40px 0 #f7ffcf,40px 0 0 10px #784972,80px 0 #f7ffcf,80px 0 0 10px #784972}a[b]{width:22;height:100;border-radius:9rem;top:50;left:189}</style>'
};


var $433047f43b444a8f$export$2e2bcd8739ae039 = {
    id: 172,
    title: 'Target #172 - Crossbones',
    url: 'https://cssbattle.dev/play/172',
    colors: [
        '#EFEB99',
        '#8647E6'
    ],
    solution: '<a a><a b><a c><style>a[a],a[b]{height:190;top:55;left:185;width:30}a[a],a[b],a[c]{width:30}body{background:#efeb99}a{position:fixed;background:#8647e6}a[a]{rotate:45deg}a[b]{rotate:-45deg}a[c]{height:30;border-radius:50%;top:57;left:128.5;box-shadow:113px 0 #8647e6,-21px 21.5px #8647e6,134px 21.5px #8647e6,-21px 134.5px #8647e6,134px 134.5px #8647e6,0 155.5px #8647e6,113px 155.5px #8647e6}</style>'
};


var $99086f1cbfdfc972$export$2e2bcd8739ae039 = {
    id: 173,
    title: 'Target #173 - Hockey Mask',
    url: 'https://cssbattle.dev/play/173',
    colors: [
        '#A5B5B4',
        '#FFFFFF',
        '#000000'
    ],
    solution: '<a a><a b><a c><a d><a e><style>a[c],a[d],a[e]{width:10;height:10}body{background:#a5b5b4}a{position:fixed;background:#000;border-radius:100%}a[a]{background:#fff;width:150;height:180;top:60;left:125}a[b]{width:30;height:30;top:110;left:150;box-shadow:70px 0}a[c],a[d]{top:80;left:180;box-shadow:0 80px,0 100px,0 120px}a[d]{left:210}a[e]{top:100;left:195}</style>'
};


var $fb57ba791655987c$export$2e2bcd8739ae039 = {
    id: 174,
    title: "Target #174 - Witch's Hat",
    url: 'https://cssbattle.dev/play/174',
    colors: [
        '#F4DCBF',
        '#30383F',
        '#556D7F',
        '#FBD038'
    ],
    solution: '<a a><a b><a c><style>body{background:#f4dcbf}a{position:fixed}a[a]{top:50;left:155;width:90;height:153;clip-path:polygon(0 100%,50% 0,100% 100%);background:#30383f}a[b]{top:190;left:125;width:150;height:60;border-radius:100%;background:radial-gradient(ellipse 150px 60px at top,#30383f 43%,#556d7f 43% 57%,#30383f 57%)}a[c]{top:210;left:185;width:30;height:20;border-radius:5px;background:#fbd038}</style>'
};


var $8b1a6e14ba9ad959$export$2e2bcd8739ae039 = {
    id: 175,
    title: 'Target #175 - Evil Cat',
    url: 'https://cssbattle.dev/play/175',
    colors: [
        '#ED6A9D',
        '#050044',
        '#FFC100'
    ],
    solution: '<p e><p f><p a><p b><p c><p d><style>body{background:#ED6A9D}p[a],p[c]{background:#050044;border-radius:50%}p[e],p[f]{top:48;border-width:50px;border-style:solid}p[d],p[e],p[f]{border-style:solid}p{position:fixed}p[a]{top:74;left:110;width:180;height:150}p[b]{top:114;left:145;width:40;height:40;background:#ffc100;border-radius:0 50%;transform:rotate(-45deg);box-shadow:49.5px 49.5px #ffc100}p[c]{top:119;left:160;width:10;height:30;box-shadow:70px 0 #050044}p[d]{top:169;left:185;border-width:15px;border-color:#ed6a9d #050044 #050044}p[e]{left:120;border-color:#ed6a9d #ed6a9d #ed6a9d #050044;transform-origin:top left;transform:rotate(-3deg) scaleY(.75)}p[f]{right:120;border-color:#ed6a9d #050044 #ed6a9d #ed6a9d;transform-origin:top right;transform:rotate(3deg) scaleY(.75)}</style>'
};


var $269c11942d3cc119$export$2e2bcd8739ae039 = {
    id: 176,
    title: 'Target #176 - Castlevania',
    url: 'https://cssbattle.dev/play/176',
    colors: [
        '#A6D6AE',
        '#3A0F09',
        '#BB9213'
    ],
    solution: '<p d><p c><p a><p b><p e><p f><style>body{background:#a6d6ae}p{position:fixed}p[a],p[b],p[c]{top:4;left:85;border:40px solid #a6d6ae;border-bottom-color:#3a0f09;transform:scaleY(1.5)}p[e],p[f]{border-radius:1in 1in 0 0;background:#bb9213}p[b]{left:235}p[c]{top:54;left:150;border-width:50;transform:scaleY(.7)}p[d]{top:104;left:100;width:200;height:120;background:#3a0f09}p[e]{top:114;left:115;width:20;height:25;box-shadow:150px 0 #bb9213}p[f]{top:174;left:170;width:60;height:50}</style>'
};


var $4bacbb525af51794$export$2e2bcd8739ae039 = {
    id: 177,
    title: 'Target #177 - Frankenstein',
    url: 'https://cssbattle.dev/play/177',
    colors: [
        '#3C8D3F',
        '#14F078',
        '#1A1D2F',
        '#FFFFFF'
    ],
    solution: '<p a><p b><p c><p d><p e><p f><p g><p h><p i><p j><p k><style>p[b],p[i]{top:129;height:30;background:#1a1d2f}p[a],p[j]{top:139;height:10}p[a],p[b],p[i],p[k]{background:#1a1d2f}body{background:#3c8d3f}p{position:fixed}p[a]{left:100;width:200}p[b]{left:100;width:10;border-radius:1in;box-shadow:190px 0 #1a1d2f}p[c]{top:59;left:125;width:150;height:150;border-radius:13px 13px 1in 1in;background:linear-gradient(#1a1d2f 30px,#14f078 30px)}p[d],p[e],p[f],p[g],p[h]{top:89;left:125;border:15px solid #14f078;border-top-color:#1a1d2f}p[e],p[i]{left:155}p[i],p[j]{border-radius:50%}p[f]{left:185}p[g]{left:215}p[h]{left:245}p[i]{width:30;box-shadow:60px 0 #1a1d2f}p[j]{left:165;width:10;background:#fff;box-shadow:60px 0 #fff}p[k]{top:169;left:180;width:40;height:20;border-radius:0 0 1in 1in}</style>'
};


var $3e68f336fd9436cf$export$2e2bcd8739ae039 = {
    id: 178,
    title: 'Target #178 - Candy',
    url: 'https://cssbattle.dev/play/178',
    colors: [
        '#CBE8DD',
        '#007192'
    ],
    solution: '<p a><p b><p c><style>body,p[c]{background:#cbe8dd}p{position:fixed}p[a]{top:94;left:70;width:200;height:20;border:30px solid;border-color:#cbe8dd #007192}p[b]{top:84;left:110;width:180;height:100;background:#007192;border-radius:10px}p[c]{top:0;left:155;width:10;height:270;transform:rotate(20deg);box-shadow:18px 0 #cbe8dd,37px 0 #cbe8dd,56px 0 #cbe8dd,75px 0 #cbe8dd}</style>'
};


var $413ed4d3ff102644$export$2e2bcd8739ae039 = {
    id: 179,
    title: 'Target #179 - Tanzania',
    url: 'https://cssbattle.dev/play/179',
    colors: [
        '#14A84A',
        '#F8CD1E',
        '#000000',
        '#3B66B0'
    ],
    solution: '<style>body{background:linear-gradient(-30deg,#3b66b0 160px,#f8cd1e 160px 180px,#000 180px 280px,#f8cd1e 280px 300px,#14a84a 300px)}</style>'
};


var $4a3ab2516cc23c16$export$2e2bcd8739ae039 = {
    id: 180,
    title: 'Target #180 - Kuwait',
    url: 'https://cssbattle.dev/play/180',
    colors: [
        '#000000',
        '#13AA4B',
        '#FFFFFF',
        '#EC1E25'
    ],
    solution: '<style>body{margin:0;border-style:solid;border-width:100px 0 100px 120px;border-color:#13AA4B #000 #EC1E25'
};


var $23fc49ed1be6850a$export$2e2bcd8739ae039 = {
    id: 181,
    title: 'Target #181 - Iceland',
    url: 'https://cssbattle.dev/play/181',
    colors: [
        '#33499F',
        '#DE3832',
        '#FFFFFF'
    ],
    solution: '<style>body{background:linear-gradient(90deg,transparent 125px,#DE3832 125px 175px,transparent 175px 190px),linear-gradient(transparent 110px,#fff 110px 125px,#DE3832 125px 175px,#fff 175px 190px,transparent 190px),linear-gradient(90deg,transparent 110px,#fff 110px 125px,#DE3832 125px 175px,#fff 175px 190px,transparent 190px)#33499F'
};


var $698d227aa95d1651$export$2e2bcd8739ae039 = {
    id: 182,
    title: 'Target #182 - Bahrain',
    url: 'https://cssbattle.dev/play/182',
    colors: [
        '#DA291C',
        '#FFFFFF'
    ],
    solution: '<style>body{background:linear-gradient(-22.5deg,#DA291C 115px,transparent 115px),linear-gradient(22.5deg,#fff 84px,transparent 84px),linear-gradient(-22.5deg,#DA291C 161px,transparent 161px),linear-gradient(22.5deg,#fff 131px,transparent 131px),linear-gradient(-22.5deg,#DA291C 207px,transparent 207px),linear-gradient(22.5deg,#fff 177px,transparent 177px),linear-gradient(-22.5deg,#DA291C 253px,transparent 253px),linear-gradient(22.5deg,#fff 223px,transparent 223px),linear-gradient(-22.5deg,#DA291C 300px,transparent 300px),linear-gradient(22.5deg,#fff 269px,transparent 269px),linear-gradient(-22.5deg,#DA291C 346px,transparent 346px),linear-gradient(22.5deg,#fff 315px,transparent 315px),linear-gradient(-22.5deg,#DA291C 400px,transparent 400px)'
};


var $eccbd8a84cb1c276$export$2e2bcd8739ae039 = {
    id: 183,
    title: 'Target #183 - Brazil',
    url: 'https://cssbattle.dev/play/183',
    colors: [
        '#009B3A',
        '#FEDF00',
        '#FFFFFF',
        '#002776'
    ],
    solution: '<p><style>body{background:linear-gradient(33.7deg,#009b3a 153px,transparent 153px),linear-gradient(-33.7deg,#009b3a 153px,transparent 153px),linear-gradient(213.7deg,#009b3a 153px,transparent 153px),linear-gradient(-213.7deg,#009b3a 153px,transparent 153px) #fedf00}p{width:120;height:120;top:74;left:140;border-radius:50%;position:fixed;background:radial-gradient(circle at 30px 140px,#002776 100px,#fff 100px 110px,#002776 110px)}</style>'
};


var $0d8a6a1750fec6c6$export$2e2bcd8739ae039 = {
    id: 184,
    title: 'Target #184 - India',
    url: 'https://cssbattle.dev/play/184',
    colors: [
        '#00007B',
        '#3F8627',
        '#F19E4B',
        '#FFFFFF'
    ],
    solution: '<style>body{background:linear-gradient(#f19e4b 100px,transparent 100px 200px,#3f8627 200px),radial-gradient(circle,#00007b 10px,transparent 10px 30px,#00007b 30px 40px,#fff 40px),linear-gradient(90deg,transparent 198px,#00007b 198px 202px,transparent 202px),linear-gradient(30deg,transparent 228px,#00007b 228px 232px,transparent 232px),linear-gradient(-30deg,transparent 228px,#00007b 228px 232px,transparent 232px)}</style>'
};


var $c80f50ab103fdba2$export$2e2bcd8739ae039 = {
    id: 185,
    title: 'Target #185 - South Korea',
    url: 'https://cssbattle.dev/play/185',
    colors: [
        '#CD2E3A',
        '#0047A0',
        '#FFFFFF',
        '#000000'
    ],
    solution: '<p b><p c><p a><style>p{position:fixed}p[a]{width:120;height:120;top:74;left:140;border-radius:50%;background:radial-gradient(circle at 25% 50%,#cd2e3a 30px,transparent 30px),radial-gradient(circle at 75% 50%,#0047a0 30px,transparent 30px),linear-gradient(#cd2e3a 50%,#0047a0 50%)}p[b],p[c]{width:260;height:60;top:43}p[b]{left:102.5;transform-origin:top left;transform:rotate(30deg);background:linear-gradient(90deg,#000 10px,transparent 10px 16px,#000 16px 26px,transparent 26px 32px,#000 32px 42px,transparent 42px),linear-gradient(transparent 27px,#fff 27px 33px,transparent 33px),linear-gradient(-90deg,#000 10px,transparent 10px 16px,#000 16px 26px,transparent 26px 32px,#000 32px 42px,transparent 42px)}p[c]{right:102.5;transform-origin:top right;transform:rotate(-30deg);background:linear-gradient(90deg,#000 10px,transparent 10px 32px,#000 32px 42px,transparent 42px),linear-gradient(-90deg,transparent 16px,#000 16px 26px,transparent 26px),linear-gradient(transparent 27px,#fff 27px 33px,transparent 33px),linear-gradient(90deg,transparent 16px,#000 16px 26px,transparent 26px),linear-gradient(-90deg,#000 10px,transparent 10px 32px,#000 32px 42px,transparent 42px)}</style>'
};


var $06d3adebd5d5da31$export$2e2bcd8739ae039 = {
    id: 186,
    title: 'Target #186 - Guernsey',
    url: 'https://cssbattle.dev/play/186',
    colors: [
        '#F9DD16',
        '#E8112D',
        '#FFFFFF'
    ],
    solution: '<p c><p d><p a><p b><style>body{background:linear-gradient(transparent 110px,#e8112d 110px 190px,transparent 190px),linear-gradient(90deg,transparent 160px,#e8112d 160px 240px,transparent 240px)}p{position:fixed}p[a],p[b],p[c],p[d]{width:200;height:20}p[a],p[b]{top:114;left:85;border-width:10 15;border-style:solid;border-color:transparent #f9dd16}p[c],p[d]{top:124;left:100;background:#f9dd16}p[b],p[d]{transform-origin:center;transform:rotate(90deg)}</style>'
};


var $fca830256d53d5b6$export$2e2bcd8739ae039 = {
    id: 187,
    title: 'Target #187 - Striped Triangle',
    url: 'https://cssbattle.dev/play/187',
    colors: [
        '#40234B',
        '#A94EA4'
    ],
    solution: '<p a><p b><style>body,p[b]{background:#40234b}p{position:fixed}p[a]{top:34;left:85;border-style:solid;border-width:200 115;border-color:#a94ea4 #40234b #40234b}p[b]{top:-100;left:93;width:10;height:300;rotate:30deg;box-shadow:26px 0 #40234b,52px 0 #40234b,78px 0 #40234b,104px 0 #40234b,130px 0 #40234b,156px 0 #40234b'
};


var $7e5d707a3740ca27$export$2e2bcd8739ae039 = {
    id: 188,
    title: 'Target #188 - Icecream Sticks',
    url: 'https://cssbattle.dev/play/188',
    colors: [
        '#FFFD9B',
        '#969610',
        '#646521'
    ],
    solution: '<p a><p b><p c><p d><p e><p f><style>body{background:#fffd9b;margin:0}p{position:fixed;border-radius:1in}p[a],p[b],p[c],p[d]{background:#969610}p[e],p[f]{background:#646521}p[a],p[b],p[e]{width:20;height:240;top:14}p[a]{left:110}p[b]{right:110}p[e]{left:190}p[c],p[d],p[f]{width:340;height:20;left:30}p[c]{top:44}p[d]{bottom:44}p[f]{top:124'
};


var $5bb3c35c43b2cf29$export$2e2bcd8739ae039 = {
    id: 189,
    title: 'Target #189 - Triangle Hook',
    url: 'https://cssbattle.dev/play/189',
    colors: [
        '#D669EC',
        '#FDFBF8'
    ],
    solution: '<style>body{background:linear-gradient(-153.4deg,#d669ec 159px,transparent 159px),linear-gradient(-26.6deg,#d669ec 159px,transparent 159px),linear-gradient(-90deg,#fdfbf8 105px,#d669ec 105px 125px,#fdfbf8 125px 235px,#d669ec 235px,transparent 235px),linear-gradient(153.4deg,#d669ec 159px,transparent 159px),linear-gradient(26.6deg,#d669ec 159px,transparent 159px),linear-gradient(transparent 140px,#fdfbf8 140px 160px,transparent 160px),linear-gradient(90deg,transparent 135px,#d669ec 135px),linear-gradient(153.4deg,#fdfbf8 172px,transparent 172px),linear-gradient(26.6deg,#fdfbf8 172px,#d669ec 172px)}</style>'
};


var $9c969fd01ee39b8c$export$2e2bcd8739ae039 = {
    id: 190,
    title: 'Target #190 - Power Chip',
    url: 'https://cssbattle.dev/play/190',
    colors: [
        '#E3516E',
        '#FADE8B'
    ],
    solution: '<p a><p b><p c><p d><p e><style>p[b],p[c]{width:20;background:#e3516e}body,p[b],p[c]{background:#e3516e}p[d],p[e]{top:119;border-width:0 25 40}p[b],p[d],p[e]{border-style:solid;border-color:#e3516e #fade8b}body{margin:0}p{position:fixed}p[a]{top:59;left:60;width:280;height:150;background:#fade8b}p[b]{top:59;left:146.5;height:81;border-width:69 43.5 0}p[c]{top:159;left:115;height:80;box-shadow:150px 0 #e3516e}p[d]{left:100}p[e]{right:100}</style>'
};


var $f870d37d4c454247$export$2e2bcd8739ae039 = {
    id: 191,
    title: 'Target #191 - Modern Fence',
    url: 'https://cssbattle.dev/play/191',
    colors: [
        '#2F2E59',
        '#EEECF6'
    ],
    solution: '<p a><p b><p c><style>p[b],p[c]{width:240;height:20;rotate:30deg}body{background:#2f2e59;margin:0}p{position:fixed;background:#eeecf6;border-radius:1in}p[a]{top:59;left:77;width:20;height:150;box-shadow:226px 0 #eeecf6}p[b]{top:64.5;left:91;box-shadow:0 57px #eeecf6}p[c]{bottom:64.5;right:91;box-shadow:0 -57px #eeecf6'
};


var $86c2e00fe3af24e1$export$2e2bcd8739ae039 = {
    id: 192,
    title: 'Target #192 - Abstract Firefly',
    url: 'https://cssbattle.dev/play/192',
    colors: [
        '#1D471D',
        '#CCE58E'
    ],
    solution: '<p a><p b><p c><p d><p e><style>p[a],p[b]{top:59;left:60}p[d],p[e]{top:111;border-width:36 25 0}p[c],p[d],p[e]{border-width:36 25 0}p[b],p[c],p[d],p[e]{border-style:solid;border-color:#1d471d transparent}body{background:#1d471d;margin:0}p{position:fixed}p[a]{border-style:solid;border-width:150 140 0;border-color:#cce58e #1d471d}p[b]{border-width:20 139 0}p[c]{top:73;left:175}p[d]{left:235;rotate:135deg}p[e]{right:235;rotate:-135deg'
};


var $f383086fc7048d0f$export$2e2bcd8739ae039 = {
    id: 193,
    title: 'Target #193 - Galver',
    url: 'https://cssbattle.dev/play/193',
    colors: [
        '#FCDDEB',
        '#8B0051',
        '#F180B6'
    ],
    solution: '<style>body{background:radial-gradient(circle,#8b0051 20px,#f180b6 20px 35px,#8b0051 35px 50px,transparent 50px 65px,#8b0051 65px 80px,transparent 80px),radial-gradient(circle at 200px 50px,#8b0051 15px,transparent 15px),radial-gradient(circle at 200px 250px,#8b0051 15px,transparent 15px),radial-gradient(circle at 100px 150px,#8b0051 15px,transparent 15px),radial-gradient(circle at 300px 150px,#8b0051 15px,transparent 15px),linear-gradient(#fcddeb 50px,transparent 50px 250px,#fcddeb 250px),linear-gradient(90deg,#fcddeb 100px,transparent 100px 300px,#fcddeb 300px),conic-gradient(from -8.5deg,#8b0051 17deg,#fcddeb 17deg 90deg,#8b0051 90deg 107deg,#fcddeb 107deg 180deg,#8b0051 180deg 197deg,#fcddeb 197deg 270deg,#8b0051 270deg 287deg,#fcddeb 287deg)'
};


var $ddebf578efbf3211$export$2e2bcd8739ae039 = {
    id: 194,
    title: 'Target #194 - Fountain',
    url: 'https://cssbattle.dev/play/194',
    colors: [
        '#4FA07B',
        '#0D1335'
    ],
    solution: '<p a><p d><p b><p c><p h><p e><p f><p g><style>p[d],p[f]{height:70}p[d],p[e],p[f],p[g]{width:20;background:#0d1335}p[e],p[f],p[g],p[h]{top:174}body{background:#4fa07b;margin:0}p{position:fixed}p[a],p[b],p[c]{top:4;left:130;width:140;height:140;border-radius:50%;box-shadow:inset 0 0 0 20px #0d1335,inset 0 0 0 40px #4fa07b,inset 0 0 0 60px #0d1335}p[b],p[c]{top:104}p[b],p[e],p[h]{left:70}p[c]{left:190}p[d]{top:74;left:130;box-shadow:20px 0 #4fa07b,40px 0 #0d1335,60px 0 #4fa07b,80px 0 #0d1335,100px 0 #4fa07b,120px 0 #0d1335}p[e]{height:47;box-shadow:240px 0 #0d1335}p[f]{left:110;box-shadow:160px 0 #0d1335}p[g]{left:150;height:90;box-shadow:80px 0 #0d1335}p[h]{width:260;height:110;background:linear-gradient(90deg,#4fa07b 120px,#0d1335 120px 140px,#4fa07b 140px)'
};


var $2f84f0960f052c79$export$2e2bcd8739ae039 = {
    id: 195,
    title: 'Target #195 - LookAway',
    url: 'https://cssbattle.dev/play/195',
    colors: [
        '#F459E3',
        '#E89A52',
        '#F9C96C',
        '#131313'
    ],
    solution: '<p a><p b><p c><p d><style>p[b],p[c]{top:104;width:50;height:50;rotate:-45deg}body,p[d]{background:#131313}p{position:fixed}p[a]{top:39;left:80;width:240;height:190;border-radius:65px 65px 120px 120px;rotate:-15deg;background:radial-gradient(circle at 23px 105px,#f459e3 147px,transparent 147px),radial-gradient(circle at 63px 113px,#e89a52 147px,#f9c96c 147px)}p[b]{left:100;border:15px solid;border-color:transparent transparent #131313 #131313;border-radius:1in}p[c]{left:195;border:15px solid;border-color:transparent transparent #131313 #131313;border-radius:1in}p[d]{top:136;left:100;width:15;height:15;border-radius:1in;box-shadow:65px 0 #131313,95px 0 #131313,160px 0 #131313'
};


var $671e86e7e5665971$export$2e2bcd8739ae039 = {
    id: 196,
    title: 'Target #196 - Tree',
    url: 'https://cssbattle.dev/play/196',
    colors: [
        '#90D3A6',
        '#024817'
    ],
    solution: '<p a><p b><p c><p d><style>p[c],p[d]{top:91.5;width:70;height:20}p[a],p[c],p[d]{height:20}p[a],p[b],p[c],p[d]{border-radius:1in;background:#024817}body{background:#90d3a6}p{position:fixed}p[a]{top:204;left:100;width:200}p[b]{top:44;left:190;width:20;height:180}p[c]{left:186.5;rotate:-30deg;box-shadow:-25px 43.5px #024817}p[d]{right:186.5;rotate:30deg;box-shadow:25px 43.5px #024817'
};


var $703ee68348d3be4c$export$2e2bcd8739ae039 = {
    id: 197,
    title: 'Target #197 - Crystal',
    url: 'https://cssbattle.dev/play/197',
    colors: [
        '#5F133F',
        '#F075B0',
        '#F7BED9'
    ],
    solution: '<p a><p b><p c><style>p[a]::after,p[a]::before,p[b]::after,p[b]::before,p[c]::after,p[c]::before{content:"";position:absolute;border-style:solid;border-color:#f7bed9 #5f133f}body{background:#5f133f}p{position:fixed}p[a],p[b],p[c]{top:54;left:175;width:50;height:160;background:#f075b0}p[a]{transform:rotate3d(0,0,1,60deg)}p[b]{transform:rotate3d(0,0,1,-60deg)}p[c]{background:radial-gradient(circle,#f7bed9 25px,#f075b0 25px)}p[a]::before,p[b]::before,p[c]::before{top:-30;border-width:0 25px 30px}p[a]::after,p[b]::after,p[c]::after{bottom:-30;border-width:30px 25px 0'
};


var $6e81a4df968d73fb$export$2e2bcd8739ae039 = {
    id: 198,
    title: 'Target #198 - Walls',
    url: 'https://cssbattle.dev/play/198',
    colors: [
        '#6867D4',
        '#7BAFDE',
        '#000039'
    ],
    solution: '<p a><p b><p c><style>p[a],p[b]{height:100}p[a],p[c]{width:100}p[b],p[c]{background:#7bafde;transform:skewY(26.5deg);box-shadow:350px -200px #7bafde}body{background:#6867d4}p{position:fixed}p[a]{top:84;left:50;background:#000039;transform:skewY(-26.5deg);box-shadow:200px 100px #000039}p[b]{top:96;left:0;width:50}p[c]{top:34;left:150;height:200'
};


var $eb639480f012b360$export$2e2bcd8739ae039 = {
    id: 199,
    title: 'Target #199 - Antenna',
    url: 'https://cssbattle.dev/play/199',
    colors: [
        '#F48B26',
        '#FEFF58'
    ],
    solution: '<p a><p b><p c><p d><style>p[c],p[d]{bottom:-70;width:230;height:190;background:#feff58;border-radius:60px;box-shadow:inset 0 0 0 20px #feff58,inset 0 0 0 50px #f48b26}body{background:#f48b26}p{position:fixed;margin:0}p[a]{top:0;left:190;width:20;height:300;background:#feff58}p[b]{top:30;left:120;width:160;height:20;background:#feff58;border-radius:1in;box-shadow:-40px 50px #feff58,40px 50px #feff58,-80px 100px #feff58,80px 100px #feff58}p[c]{left:-70}p[d]{right:-70'
};


var $e5da7e205df371c7$export$2e2bcd8739ae039 = {
    id: 200,
    title: 'Target #200 - Lantern',
    url: 'https://cssbattle.dev/play/200',
    colors: [
        '#FAD3E5',
        '#8B0051'
    ],
    solution: '<p><style>body{background:linear-gradient(90deg,#fad3e5 175px,#8b0051 175px 225px,#fad3e5 225px)}p{position:fixed;background:#8b0051;top:4;left:144;width:112;height:140;rotate:63.5deg;transform:skewY(-37deg);box-shadow:107.5px 134.5px #8b0051'
};


var $42b9e63f305d9f3b$export$2e2bcd8739ae039 = {
    id: 201,
    title: 'Target #201 - Triple Zero',
    url: 'https://cssbattle.dev/play/201',
    colors: [
        '#998235',
        '#FCBE5C',
        '#0B2429'
    ],
    solution: '<p a><p b><p c><style>body,p[b]{background:#998235}p[a],p[c]{background:#fcbe5c}p{position:fixed}p[a]{top:29;left:45;width:90;height:210;border-radius:25px;box-shadow:110px 0 #0b2429,220px 0 #fcbe5c}p[b]{top:59;left:75;width:30;height:150;box-shadow:110px 0 #998235,220px 0 #998235}p[c]{top:119;left:0;width:45;height:30;box-shadow:355px 0 #fcbe5c'
};


var $99ef2155665875a8$export$2e2bcd8739ae039 = {
    id: 202,
    title: 'Target #202 - Steering Wheel',
    url: 'https://cssbattle.dev/play/202',
    colors: [
        '#4F77FF',
        '#1038BF'
    ],
    solution: '<p a><p b><style>body,p[b]{background:#4f77ff}p{position:fixed}p[a]{top:34;left:100;width:140;height:140;background:radial-gradient(circle,#4f77ff 10px,transparent 10px),conic-gradient(from -90deg at 45px 82px,transparent 270deg,#4f77ff 270deg),conic-gradient(from -90deg at 56px 92px,transparent 270deg,#4f77ff 270deg),radial-gradient(circle at 46px 92px,#4f77ff 10px,transparent 10px),conic-gradient(from 180deg at 95px 82px,transparent 270deg,#4f77ff 270deg),conic-gradient(from 180deg at 86px 92px,transparent 270deg,#4f77ff 270deg),radial-gradient(circle at 96px 92px,#4f77ff 10px,transparent 10px),linear-gradient(#4f77ff 52px,#1038bf 52px);border-radius:9in;border:30px solid #1038bf}p[b]{top:30;left:185;width:30;height:40'
};


var $ad993ca8056cc135$export$2e2bcd8739ae039 = {
    id: 203,
    title: 'Target #203 - Wolverine',
    url: 'https://cssbattle.dev/play/203',
    colors: [
        '#F3AC3C',
        '#373794',
        '#FFFFFF',
        '#0E0E39'
    ],
    solution: '<p a><p b><p c><p d><p e><p f><p g><p h><style>p[a],p[c]{background:#f3ac3c}p[b],p[c]{border-radius:0 0 1in 1in}p[a],p[d]{border-radius:1in}p[e],p[f]{top:107;width:100;height:70;background:#0e0e39}p[b],p[e],p[f]{background:#0e0e39}p[g],p[h]{top:146;width:30}p[d],p[g],p[h]{height:20;background:#fff}body{background:#373794}p{position:fixed;margin:0}p[a]{top:87;left:155;width:90;height:90}p[b]{top:166;left:160;width:80;height:50}p[c]{top:177;left:173;width:54;height:51}p[d]{top:190;left:180;width:40}p[e]{left:100;border-radius:0 50px 0 70px}p[f]{right:100;border-radius:50px 0 70px}p[g]{left:165;border-radius:0 20px}p[h]{right:165;border-radius:20px 0'
};


var $504762108b07115c$export$2e2bcd8739ae039 = {
    id: 204,
    title: 'Target #204 - Deadpool',
    url: 'https://cssbattle.dev/play/204',
    colors: [
        '#F3AC3C',
        '#000000',
        '#FFFFFF',
        '#9F3333'
    ],
    solution: '<p a><p b><style>p[a],p[b]{background:#fff;top:126;width:30;height:15;border-radius:0 0 1in 1in}body{background:radial-gradient(circle at 50% 154px,transparent 83px,#9f3333 83px 100px,#f3ac3c 100px),linear-gradient(90deg,#000 182px,#9f3333 182px 218px,#000 218px)}p{position:fixed}p[a]{left:134.5;rotate:29deg}p[b]{right:135.5;rotate:-29deg'
};


var $aabda9a625943d7b$export$2e2bcd8739ae039 = {
    id: 205,
    title: "Target #205 - Magneto's helmet",
    url: 'https://cssbattle.dev/play/205',
    colors: [
        '#232323',
        '#AF3A3A'
    ],
    solution: '<p a><p b><p c><p d><p e><p f><style>p[b],p[c]{border-radius:50%}p[d],p[e]{top:220;width:44;height:44;background:#af3a3a}p[a],p[c],p[d],p[e]{background:#af3a3a}body,p[b],p[f]{background:#232323}p{position:fixed;margin:0}p[a]{top:34;left:120;width:160;height:214;border-radius:1in 1in 0 0}p[b]{top:87;left:140;width:120;height:70}p[c]{top:52;left:160;width:80;height:50}p[d]{left:129;rotate:32deg}p[e]{right:129;rotate:-32deg}p[f]{top:140;left:165;width:70;height:108'
};


var $9cd723941f608a26$export$2e2bcd8739ae039 = {
    id: 206,
    title: 'Target #206 - Punisher',
    url: 'https://cssbattle.dev/play/206',
    colors: [
        '#000000',
        '#CAE5DC'
    ],
    solution: '<p a><p b><p c><p d><p e><p f><style>p[a],p[b],p[c]{background:#000}p[d],p[e]{top:119;width:46;height:23;background:#cae5dc;border-radius:0 0 1in 1in}body{background:#cae5dc}p{position:fixed;margin:0}p[a]{top:40;left:130;width:140;height:140;border-radius:1in}p[b]{top:150;left:150;width:100;height:30}p[c]{top:180;left:162;width:16;height:93;box-shadow:20px 0,40px 0,60px 0}p[d]{left:139;rotate:28deg}p[e]{right:139;rotate:-28deg}p[f]{top:136;left:189.5;border-style:solid;border-color:#cae5dc #000;border-width:0 10px 30px'
};


var $5b0af3636d0bfa15$export$2e2bcd8739ae039 = {
    id: 207,
    title: 'Target #207 - Green Lantern logo',
    url: 'https://cssbattle.dev/play/207',
    colors: [
        '#0E532F',
        '#70CEAF'
    ],
    solution: '<p a><p b><style>body{background:#70ceaf}p{position:fixed;margin:0}p[a]{top:10;left:60;width:280;height:280;border-radius:9in;box-shadow:inset 0 0 0 25px #0e532f,inset 0 0 0 70px #70ceaf,inset 0 0 0 95px #0e532f}p[b]{top:70;left:130;width:140;height:25;background:#0e532f;box-shadow:0 135px #0e532f'
};


var $753f76661fe7c4a6$export$2e2bcd8739ae039 = {
    id: 208,
    title: 'Target #208 - Hulk fist',
    url: 'https://cssbattle.dev/play/208',
    colors: [
        '#107640',
        '#161D1A'
    ],
    solution: '<p a><p b><p c><p d><p e><p f><p g><style>p[b],p[c],p[d],p[e]{width:22;background:#107640}p[a],p[b],p[c],p[d],p[e],p[f]{background:#107640}body{background:radial-gradient(circle,#161d1a 115px,#107640 115px)}p{position:fixed;margin:0}p[a]{top:161;left:132;width:130;height:110}p[b]{top:123;left:132;height:31}p[c]{top:103;left:168;height:51}p[d]{top:98;left:204;height:46}p[e]{top:103;left:240;height:41}p[f]{top:144;left:179;width:100;height:56;box-shadow:inset 0 0 0 7px #161d1a'
};


var $380826846cf48741$export$2e2bcd8739ae039 = {
    id: 209,
    title: 'Target #209 - Iron man',
    url: 'https://cssbattle.dev/play/209',
    colors: [
        '#F3AC3C',
        '#FFFFFF',
        '#BB2726'
    ],
    solution: '<p a><p b><p c><p d><style>p[a],p[d]{top:0;background:#bb2726}body,p[a],p[d]{background:#bb2726}p{position:fixed;margin:0}p[a]{left:160;width:80;height:65;box-shadow:0 24px 0 33px #f3ac3c,0 24px 0 43px #bb2726,0 68px 0 68px #f3ac3c,0 105px 0 68px #f3ac3c,0 115px 0 68px #bb2726,0 152px 0 68px #f3ac3c}p[b]{top:132;left:127;width:45;height:10;background:#fff;box-shadow:0 0 0 10px #bb2726,101px 0 #fff,101px 0 0 10px #bb2726}p[c]{top:165;right:258;width:180;height:120;background:#f3ac3c;box-shadow:0 0 0 10px #bb2726,296px 0 #f3ac3c,296px 0 0 10px #bb2726;border-radius:95px 95px 0 0}p[d]{left:0;width:92;height:300;box-shadow:308px 0 #bb2726'
};


var $84e9982175dd587e$export$2e2bcd8739ae039 = {
    id: 210,
    title: 'Target #210 - Black widow logo',
    url: 'https://cssbattle.dev/play/210',
    colors: [
        '#151917',
        '#D83A34'
    ],
    solution: '<style>body{background:radial-gradient(circle,transparent 105px,#d83a34 105px 125px,#151917 125px),conic-gradient(at 216px 150px,transparent 34deg,#151917 34deg 146deg,transparent 146deg),conic-gradient(from 180deg at 183px 150px,transparent 34deg,#151917 34deg 146deg,transparent 146deg),linear-gradient(#151917 81px,#d83a34 81px 219px,#151917 219px)'
};


var $26591b71ce6a5b5f$export$2e2bcd8739ae039 = {
    id: 211,
    title: 'Target #211 - CSS Weekly',
    url: 'https://cssbattle.dev/play/211',
    colors: [
        '#9B8170',
        '#FFFFFF'
    ],
    solution: '<p a><p b><p c><p d><p e><p f><style>p[a],p[b]{top:90.5;width:80;height:80;border-radius:1in 1in 0;rotate:45deg}p[c],p[d]{width:140;height:100;border-radius:1in 1in 0 0;box-shadow:inset 0 0 0 20px #fff;bottom:40}p[a],p[b],p[c],p[d]{box-shadow:inset 0 0 0 20px #fff}p[c],p[d],p[e]{bottom:40}p[e],p[f]{width:20;background:#9b8170}body,p[c],p[d],p[e],p[f]{background:#9b8170}p[a],p[b],p[f]{rotate:45deg}p{position:fixed;margin:0}p[a]{left:110}p[b]{left:210}p[c]{right:80}p[d]{left:80}p[e]{left:180;height:20}p[f]{top:156.5;left:265;height:40'
};


var $b2df373578174661$export$2e2bcd8739ae039 = {
    id: 212,
    title: 'Target #212 - Fibonacci peacock',
    url: 'https://cssbattle.dev/play/212',
    colors: [
        '#FFED99',
        '#000000',
        '#9F3333',
        '#3F8627',
        '#F48B26'
    ],
    solution: '<p a><p b><p c><p d><p e><style>p[c],p[d]{top:61;background:#f48b26}p[a],p[e]{border-radius:0 0 9in}body{background:#ffed99}p{position:fixed;margin:0}p[a]{top:61;left:166;width:178;height:178;background:#3f8627}p[b]{top:129;left:56;width:110;height:110;background:#9f3333;border-radius:0 0 0 9in}p[c]{left:56;width:68;height:68;border-radius:9in 0 0}p[d]{left:120;width:46;height:42;border-radius:0 9in 0 0}p[e]{top:103;left:140;width:26;height:26;background:#000'
};


var $3efa1846a95eed0e$export$2e2bcd8739ae039 = {
    id: 213,
    title: 'Target #213 - Boat',
    url: 'https://cssbattle.dev/play/213',
    colors: [
        '#EEF8FF',
        '#4A7D7B',
        '#8AB8B6'
    ],
    solution: '<p a><p b><p c><style>p[b],p[c]{border-style:solid}body{background:linear-gradient(#eef8ff 200px,#8ab8b6 200px)}p{position:fixed;margin:0}p[a]{bottom:75;left:0;width:100;height:50;background:#eef8ff;border-radius:100%;box-shadow:100px 0 #eef8ff,200px 0 #eef8ff,300px 0 #eef8ff}p[b]{top:32;left:200;border-width:70px 0 70px 100px;border-color:transparent #4a7d7b}p[c]{top:172;left:100;width:130;border-width:60px 35px 0;border-color:#4a7d7b transparent'
};


var $9e90884f9cece9e6$export$2e2bcd8739ae039 = {
    id: 214,
    title: 'Target #214 - Newspaper',
    url: 'https://cssbattle.dev/play/214',
    colors: [
        '#F8F8F8',
        '#787885'
    ],
    solution: '<p a><p b><p c><style>p[a],p[b]{left:30;background:#787885}p[a],p[b],p[c]{background:#787885}body{background:#f8f8f8}p{position:fixed;margin:0}p[a]{top:20;width:40;height:50;box-shadow:60px 0 #787885,120px 0 #787885,180px 0 #787885,240px 0 #787885,300px 0 #787885}p[b]{top:80;width:340;height:10;box-shadow:0 30px #787885,0 50px #787885,0 70px #787885,0 90px #787885,0 110px #787885,0 130px #787885,0 150px #787885,0 170px #787885,0 190px #787885}p[c]{top:120;left:104;width:172;height:150;border:10px solid #f8f8f8'
};


var $cabf4c242754e61b$export$2e2bcd8739ae039 = {
    id: 215,
    title: 'Target #215 - Staggered checks',
    url: 'https://cssbattle.dev/play/215',
    colors: [
        '#6867D4',
        '#000039'
    ],
    solution: '<style>body{background:conic-gradient(from 135deg at 200px 9px,transparent 90deg,#6867d4 90deg),conic-gradient(from -45deg at 200px 280px,transparent 90deg,#6867d4 90deg),linear-gradient(45deg,transparent 204px,#6867d4 204px 212px,transparent 212px 252px,#6867d4 252px 260px,transparent 260px 291px,#6867d4 291px 299px,transparent 299px 323px,#6867d4 323px 331px,transparent 331px),linear-gradient(-45deg,#000039 204px,#6867d4 204px 212px,#000039 212px 252px,#6867d4 252px 260px,#000039 260px 291px,#6867d4 291px 299px,#000039 299px 323px,#6867d4 323px 331px,#000039 331px)'
};


var $565a48653b472fff$export$2e2bcd8739ae039 = {
    id: 216,
    title: 'Target #216 - Pies',
    url: 'https://cssbattle.dev/play/216',
    colors: [
        '#37212D',
        '#EE9B99',
        '#BCE6E9',
        '#76608A'
    ],
    solution: '<p a><p b><p c><p d><style>p[a],p[b]{width:240}p[b],p[c]{left:80;border-radius:9in 9in 0 0}p[a],p[b],p[d]{top:90;height:120}body{background:#37212d}p{position:fixed;margin:0}p[a]{left:80;background:linear-gradient(90deg,#76608a 120px,#ee9b99 120px)}p[b]{background:linear-gradient(90deg,#ee9b99 120px,#bce6e9 120px)}p[c]{top:150;width:120;height:60;background:#bce6e9}p[d]{left:200;width:60;background:#76608a;border-radius:0 9in 9in 0'
};


var $ce4bf4280fb9addc$export$2e2bcd8739ae039 = {
    id: 217,
    title: 'Target #217 - Maze',
    url: 'https://cssbattle.dev/play/217',
    colors: [
        '#202939',
        '#556787',
        '#FFFFFF'
    ],
    solution: '<p a><p b><style>p[a],p[b]{position:fixed;margin:0;width:50;height:50;transform:skewy(30deg)}body{background:#202939}p[a]{top:70;left:120;background:#556787;box-shadow:110px 48px #556787}p[b]{top:145;left:155;background:#fff;box-shadow:20px -31px #fff,40px -63px #fff'
};


var $cb0fc7a6eac0c819$export$2e2bcd8739ae039 = {
    id: 218,
    title: 'Target #218 - 3D',
    url: 'https://cssbattle.dev/play/218',
    colors: [
        '#4C455B',
        '#8AB8B6'
    ],
    solution: '<p a><p b><p c><style>p[a],p[b]{top:110;width:60;height:80;background:#8ab8b6}body,p[c]{background:#4c455b}p{position:fixed;margin:0}p[a]{left:62;border-radius:12px;box-shadow:72px 0 #8ab8b6,144px 0 #8ab8b6}p[b]{right:62;border-radius:0 12px 12px 0}p[c]{top:122;left:80;width:24;height:56;box-shadow:72px 0 #4c455b,144px 0 #4c455b,186px 0 #4c455b,222px 0 #4c455b'
};


var $de4f504d6e62318a$export$2e2bcd8739ae039 = {
    id: 219,
    title: 'Target #219 - CodePen',
    url: 'https://cssbattle.dev/play/219',
    colors: [
        '#101724',
        '#FFFFFF'
    ],
    solution: '<p a><p b><p c><style>p[a],p[b]{left:135.5;width:95;height:95;transform:skew(10deg,10deg);rotate:-45deg;border:17px solid #fff}body{background:#101724}p{position:fixed;margin:0}p[a]{top:51}p[b]{top:121}p[c]{top:115;left:92.5;width:20;height:70;background:#fff;box-shadow:97.5px -60px #fff,97.5px 60px #fff,195px 0 #fff'
};


var $157b344b05187943$export$2e2bcd8739ae039 = {
    id: 220,
    title: 'Target #220 - Building',
    url: 'https://cssbattle.dev/play/220',
    colors: [
        '#67AED4',
        '#0F2836',
        '#FFFFFF'
    ],
    solution: '<p a><p b><p c><p d><p e><style>p[a],p[b],p[c]{height:60;background:#fff}p[a],p[b],p[c],p[d]{background:#fff}body,p[e]{background:#67aed4}p{position:fixed;margin:0}p[a]{top:20;left:194;width:12}p[b]{top:80;left:170;width:60}p[c]{top:140;left:150;width:100}p[d]{top:200;left:0;width:400;height:100}p[e]{top:220;left:-10;width:40;height:80;box-shadow:60px 0 #67aed4,120px 0 #67aed4,260px 0 #67aed4,320px 0 #67aed4,380px 0 #67aed4,180px 0 #0f2836,200px 0 #0f2836'
};


var $4a665702ddb755f9$export$2e2bcd8739ae039 = {
    id: 221,
    title: 'Target #221 - Entangled',
    url: 'https://cssbattle.dev/play/221',
    colors: [
        '#3F4869',
        '#E25C57',
        '#F4DA64'
    ],
    solution: '<p a><p b><style>p[a],p[b]{top:60;width:180}body{background:#3f4869}p{position:fixed;margin:0}p[a]{left:60;height:180;background:#f4da64;border-radius:1in;box-shadow:100px 0 #e25c57}p[b]{left:160;height:90;background:#e25c57;border-radius:1in 1in 0 0'
};


var $b7404b667bb17956$export$2e2bcd8739ae039 = {
    id: 222,
    title: 'Target #222 - Rocket',
    url: 'https://cssbattle.dev/play/222',
    colors: [
        '#B0E1FB',
        '#C15965',
        '#4B4D88'
    ],
    solution: '<p a><p b><p c><style>p[a],p[b]{left:135;border-style:solid;border-width:0 65px 60px}body{background:#b0e1fb}p{position:fixed;margin:0}p[a]{bottom:130;border-color:#4b4d88 #b0e1fb}p[b]{bottom:40;border-color:#c15965 #b0e1fb}p[c]{top:40;left:165;width:50;height:180;background:#4b4d88;border:10px solid #b0e1fb;border-radius:1in'
};


var $2f24063fe5a12e9a$export$2e2bcd8739ae039 = {
    id: 223,
    title: 'Target #223 - UFO',
    url: 'https://cssbattle.dev/play/223',
    colors: [
        '#2F434E',
        '#E25C57',
        '#F3AC3C'
    ],
    solution: '<p a><p b><p c><style>p[a],p[b]{width:160}p[a],p[c]{background:#e25c57}body{background:#2f434e}p{position:fixed;margin:0}p[a]{top:87;left:120;height:80;border-radius:1in 1in 0 0}p[b]{top:167;left:70;border-style:solid;border-width:0 50px 46px;border-color:#f3ac3c #2f434e}p[c]{top:183;left:110;width:20;height:20;border-radius:1in;box-shadow:80px 0 #e25c57,160px 0 #e25c57'
};


var $ed1ad0de500e40c4$export$2e2bcd8739ae039 = {
    id: 224,
    title: 'Target #224 - Levelled',
    url: 'https://cssbattle.dev/play/224',
    colors: [
        '#F8B140',
        '#000000',
        '#FFFFFF',
        '#67AED4'
    ],
    solution: '<p a><p b><style>p[a],p[b]{left:125;border-radius:1in}body{background:#f8b140}p{position:fixed;margin:0}p[a]{bottom:75;width:150;height:150;background:linear-gradient(#fff 75px,#67aed4 75px);box-shadow:0 0 0 15px #fff,0 0 0 45px #000}p[b]{top:125;width:50;height:50;background:#67aed4;box-shadow:50px 0 #fff,100px 0 #67aed4}'
};


var $ec3e394e4e92ada8$export$2e2bcd8739ae039 = {
    id: 225,
    title: 'Target #225 - Spark',
    url: 'https://cssbattle.dev/play/225',
    colors: [
        '#343848',
        '#E25C57',
        '#F4DA64'
    ],
    solution: '<p a><p b><p c><style>p[a],p[b]{background:#e25c57}p[b],p[c]{left:180;width:40}p[a],p[c]{top:50;height:40}body{background:#343848}p{position:fixed;margin:0}p[a]{left:0;width:140;box-shadow:260px 0 #e25c57}p[b]{top:210;height:90}p[c]{rotate:45deg;background:#f4da64;box-shadow:28px 85px #f4da64,85px 28px #f4da64'
};


var $a95f11ea06ec3048$export$2e2bcd8739ae039 = {
    id: 226,
    title: 'Target #226 - Bond',
    url: 'https://cssbattle.dev/play/226',
    colors: [
        '#558C90',
        '#FFFFFF',
        '#325853'
    ],
    solution: '<p a><p b><style>p[a],p[b]{top:125;height:50}body{background:#558c90}p{position:fixed;margin:0}p[a]{left:0;width:400;background:#fff}p[b]{left:113;width:50;background:#325853;border-radius:1in;box-shadow:0 0 0 37px #fff,124px 0 #325853,124px 0 0 37px #fff'
};


var $6239fa311e6cbbbe$export$2e2bcd8739ae039 = {
    id: 227,
    title: 'Target #227 - Balanced',
    url: 'https://cssbattle.dev/play/227',
    colors: [
        '#CF6939',
        '#F9D081',
        '#123747',
        '#6D8971'
    ],
    solution: '<p a><p b><style>body,p[b]{background:#cf6939}p{position:fixed;margin:0}p[a]{top:55;left:170;width:60;height:190;border-radius:1in;background:linear-gradient(#cf6939 80px,#123747 80px 160px,#6d8971 160px);box-shadow:0 0 0 40px #f9d081}p[b]{top:135;left:130;width:40;height:80;box-shadow:100px 0 #cf6939'
};


var $31d298f5011f8f70$export$2e2bcd8739ae039 = {
    id: 228,
    title: 'Target #228 - Another Tree',
    url: 'https://cssbattle.dev/play/228',
    colors: [
        '#D2F8FF',
        '#072949',
        '#3F8090'
    ],
    solution: '<p a><p b><p c><p d><p e><style>p[a],p[c]{left:140;width:120;height:120}p[b],p[c]{background:#072949}p[d],p[e]{top:148;width:140;height:190;background:#d2f8ff}body,p[d],p[e]{background:#d2f8ff}p{position:fixed;margin:0}p[a]{top:30;border-radius:1in;background:#3f8090}p[b]{top:90;left:180;width:40;height:60}p[c]{top:150}p[d]{left:220;border-radius:0 0 0 100%}p[e]{right:220;border-radius:0 0 100%'
};


var $d547ed23806cc09a$export$2e2bcd8739ae039 = {
    id: 229,
    title: 'Target #229 - Flower',
    url: 'https://cssbattle.dev/play/229',
    colors: [
        '#F4DCBF',
        '#D95362'
    ],
    solution: '<p a><p b><p c><style>p[a],p[b]{left:125;width:60;height:120;background:#d95362}p[a],p[b],p[c]{background:#d95362}body{background:#f4dcbf}p{position:fixed;margin:0}p[a]{top:15;border-radius:0 1in;box-shadow:90px 150px #d95362}p[b]{bottom:15;border-radius:1in 0;box-shadow:90px -150px #d95362}p[c]{top:135;left:185;width:30;height:30'
};


var $e84399b4283d7d48$export$2e2bcd8739ae039 = {
    id: 230,
    title: 'Target #230 - Connection',
    url: 'https://cssbattle.dev/play/230',
    colors: [
        '#3F4869',
        '#F4DA64'
    ],
    solution: '<p a><p b><p c><p d><style>p[b],p[c]{border-radius:1in}p[c],p[d]{width:80;height:80}p[a],p[d]{background:#f4da64}body{background:#3f4869}p{position:fixed;margin:0}p[a]{top:140;left:100;width:200;height:20}p[b]{top:70;left:120;width:120;height:120;border:20px solid #f4da64;border-left-color:transparent}p[c]{top:90;left:140;border:20px solid #3f4869;border-left-color:transparent}p[d]{top:110;left:160;border-radius:1in'
};


var $7fa632d3b5214ce5$export$2e2bcd8739ae039 = {
    id: 231,
    title: 'Target #231 - Crosshair',
    url: 'https://cssbattle.dev/play/231',
    colors: [
        '#2F434E',
        '#CF6939',
        '#F8B140'
    ],
    solution: '<p a><p b><style>body{background:#2f434e}p{position:fixed;margin:0}p[a]{top:35;left:160;width:80;height:80;background:#f8b140;border-radius:1in;box-shadow:-75px 75px #f8b140,75px 75px #f8b140,0 150px #f8b140}p[b]{top:95;left:145;width:110;height:110;background:radial-gradient(circle,#cf6939 40px,#2f434e 40px);box-shadow:-85px -85px #2f434e,85px -85px #2f434e,85px 85px #2f434e,-85px 85px #2f434e'
};


var $39df9f288d011004$export$2e2bcd8739ae039 = {
    id: 232,
    title: 'Target #232 - GAAD',
    url: 'https://cssbattle.dev/play/232',
    colors: [
        '#FDFFE9',
        '#01385E',
        '#81CAFE'
    ],
    solution: '<p a><p b><p c><style>p[a],p[c]{background:#01385e}body{background:#fdffe9}p{position:fixed;margin:0}p[a]{top:90;left:180;width:40;height:70;box-shadow:-10px 20px #fdffe9,-30px 20px #01385e}p[b]{top:150;left:190;width:40;height:40;border:20px solid #01385e;border-radius:0 40px 0 0}p[c]{top:150;left:130;width:100;height:100;border-radius:1in;box-shadow:20px -130px 0 -30px #01385e,inset 0 0 0 20px #01385e,inset 0 0 0 40px #81cafe'
};


var $bbf53a091326e47b$export$2e2bcd8739ae039 = {
    id: 233,
    title: 'Target #233 - Pendulum',
    url: 'https://cssbattle.dev/play/233',
    colors: [
        '#F4DA64',
        '#469DBA'
    ],
    solution: '<p a><p b><p c><p d><style>p[b],p[c]{width:100;height:50}p[c],p[d]{background:#469dba}body{background:#f4da64}p{position:fixed;margin:0}p[a]{top:125;left:100;width:150;height:75;border-radius:9in 9in 0 0;border:25px solid #469dba;border-bottom-width:0}p[b]{top:225;left:125;border-radius:0 0 9in 9in;border:25px solid #469dba;border-top-width:0}p[c]{top:175;left:150}p[d]{top:0;left:187;width:26;height:290'
};


var $5783c2242e5eac50$export$2e2bcd8739ae039 = {
    id: 234,
    title: 'Target #234 - Pieces',
    url: 'https://cssbattle.dev/play/234',
    colors: [
        '#1FBCB5',
        '#F9F8F4',
        '#074760',
        '#FFB43D'
    ],
    solution: '<p a><p b><p c><p d><style>p[b],p[c]{border-radius:9in}p[b],p[c],p[d]{width:40;height:40;rotate:45deg}body{background:#1fbcb5}p{position:fixed;margin:0}p[a]{top:150;left:120;width:80;height:80;background:#074760;box-shadow:80px 0 #f9f8f4}p[b]{top:70;left:120;border:60px solid #f9f8f4;border-right-color:#1fbcb5}p[c]{top:90;left:140;border:40px solid #ffb43d;border-right-color:#1fbcb5}p[d]{top:110;left:160;background:linear-gradient(-45deg,#f9f8f4 28px,#1fbcb5 28px);border-radius:9in;border:20px solid #074760;border-right-color:#1fbcb5'
};


var $b4abd0f070c73bad$export$2e2bcd8739ae039 = {
    id: 235,
    title: 'Target #235 - Website',
    url: 'https://cssbattle.dev/play/235',
    colors: [
        '#FDFFE9',
        '#ADB274',
        '#555A2A'
    ],
    solution: '<p a><p b><p c><p d><p e><style>p[b],p[c]{left:110;width:270}p[a],p[d]{left:20;background:#adb274}p[a],p[b],p[c],p[d]{background:#adb274}body{background:#fdffe9}p{position:fixed;margin:0}p[a]{top:20;width:360;height:30;box-shadow:0 230px #adb274}p[b]{top:110;height:60;box-shadow:0 70px #adb274}p[c]{top:60;height:40}p[d]{top:60;width:80;height:180}p[e]{top:25;left:25;width:20;height:20;background:#555a2a;box-shadow:330px 0 #555a2a,135px 230px #555a2a,165px 230px #555a2a,195px 230px #555a2a'
};


var $a09c243810cf5642$export$2e2bcd8739ae039 = {
    id: 236,
    title: 'Target #236 - Concentrate',
    url: 'https://cssbattle.dev/play/236',
    colors: [
        '#F8B140',
        '#2F434E',
        '#CF6939'
    ],
    solution: '<p a><p b><p c><style>body{background:#f8b140}p{position:fixed;margin:0;top:0;width:80;height:300;background:radial-gradient(circle,#cf6939 15px,#f8b140 15px 45px,#2f434e 45px 75px,#cf6939 75px 105px,#f8b140 105px)}p[a]{left:60}p[b]{left:160}p[c]{left:260'
};


var $56843b95b64b1059$export$2e2bcd8739ae039 = {
    id: 237,
    title: 'Target #237 - Round castle',
    url: 'https://cssbattle.dev/play/237',
    colors: [
        '#3F4869',
        '#F4DA64',
        '#E25C57'
    ],
    solution: '<p><style>body{background:#3f4869}p{position:fixed;margin:0;top:43;left:90;width:220;height:214;background:conic-gradient(from 270deg at 55px 110px ,transparent 270deg,#f4da64 270deg),conic-gradient(from 180deg at 165px 110px ,transparent 270deg,#e25c57 270deg),linear-gradient(90deg ,#e25c57 90px,transparent 90px 130px,#f4da64 130px),linear-gradient(transparent 174px,#3f4869 174px),linear-gradient(90deg ,#e25c57 110px,#f4da64 110px);border-radius:9in 9in 0 0'
};


var $78c6758b9fefdf2b$export$2e2bcd8739ae039 = {
    id: 238,
    title: 'Target #238 - Rising sun',
    url: 'https://cssbattle.dev/play/238',
    colors: [
        '#FEFF58',
        '#D2F8FF',
        '#CF6939',
        '#000000'
    ],
    solution: '<style>body{background:conic-gradient(from 90deg at 50px 40px,transparent 90deg,#feff58 90deg),conic-gradient(from 270deg at 350px 260px,transparent 90deg,#feff58 90deg),linear-gradient(#000 40px 50px,transparent 50px 145px,#000 145px 155px,transparent 155px 250px,#000 250px),linear-gradient(90deg,#000 60px,transparent 60px 195px,#000 195px 205px,transparent 205px 340px,#000 340px),radial-gradient(circle at 200px 250px,#cf6939 140px,transparent 140px) #d2f8ff'
};


var $38babaa061e9a146$export$2e2bcd8739ae039 = {
    id: 239,
    title: 'Target #239 - Waves',
    url: 'https://cssbattle.dev/play/239',
    colors: [
        '#CEEDFF',
        '#48BF7D'
    ],
    solution: '<p a><p b><p c><p d><style>p[a],p[d]{left:5}body{background:#ceedff}p{position:fixed;margin:0}p[a],p[b],p[c]{top:170;width:250;height:100;border-style:solid;border-width:0 0 30px 30px;border-color:#48bf7d;border-radius:0 0 0 9in}p[b]{left:135}p[c]{left:265}p[d]{top:155;width:30;height:30;background:#48bf7d;border-radius:1in;box-shadow:130px 0 #48bf7d,260px 0 #48bf7d'
};


var $d39f99611d992d5c$export$2e2bcd8739ae039 = {
    id: 240,
    title: 'Target #240 - Snapshot',
    url: 'https://cssbattle.dev/play/240',
    colors: [
        '#558C90',
        '#325853',
        '#F4DA64'
    ],
    solution: '<p a><p b><p c><p d><p e><style>p[a],p[c]{background:#325853}p[d],p[e]{width:20;background:#558c90}body,p[b],p[d],p[e]{background:#558c90}p{position:fixed;margin:0}p[a]{top:50;left:110;width:180;height:200;border-radius:40px}p[b]{top:130;left:110;width:40;height:40;box-shadow:140px 0 #558c90}p[c]{top:110;left:150;width:60;height:60;border-style:solid;border-color:#f4da64;border-width:10px 20px}p[d]{top:50;left:190;height:90;box-shadow:0 110px #558c90}p[e]{top:140;left:170;height:20;box-shadow:40px 0 #558c90'
};


var $db0062d9e0d8767d$export$2e2bcd8739ae039 = {
    id: 241,
    title: 'Target #241 - Mint Typewriter',
    url: 'https://cssbattle.dev/play/241',
    colors: [
        '#3D3824',
        '#86C78D',
        '#F7FFCF'
    ],
    solution: '<i a><i b><i c><style>i[a],i[b]{height:110;border-radius:10px}i[a],i[b],i[c]{border-radius:10px}*{background:#3d3824}i{position:fixed}i[a]{top:125;left:60;width:280;background:#f7ffcf}i[b]{top:85;left:80;width:240;background:linear-gradient(#f7ffcf 40px,#86c78d 40px)}i[c]{top:65;left:100;width:200;height:40;background:linear-gradient(#86c78d 20px,#3d3824 20px)'
};


var $5b56f642c39bd6d4$export$2e2bcd8739ae039 = {
    id: 242,
    title: 'Target #242 - Orbital Tiles',
    url: 'https://cssbattle.dev/play/242',
    colors: [
        '#FDFFE9',
        '#D95362',
        '#2D3464'
    ],
    solution: '<i a><i b><i c><style>i[a],i[b]{width:150;height:150;background:#d95362}body{background:#fdffe9}i{position:fixed}i[a]{top:75;left:125}i[b]{top:-75;left:-25;border-radius:1in;box-shadow:0 150px #2d3464,0 300px #d95362,150px 0 #2d3464,150px 300px #2d3464,300px 0 #d95362,300px 150px #2d3464,300px 300px #d95362}i[c]{top:0;left:50;width:260;height:260;border:20px solid #fdffe9'
};


var $4ab14c23ccf4a8f3$export$2e2bcd8739ae039 = {
    id: 243,
    title: 'Target #243 - Corn',
    url: 'https://cssbattle.dev/play/243',
    colors: [
        '#2F2F2F',
        '#727272',
        '#C1C1C1'
    ],
    solution: '<p a><p b><p c><p d><style>p[b],p[c],p[d]{background:#727272}body{background:#2f2f2f}p{position:fixed}p[a]{background:linear-gradient(90deg,transparent 20px,#2f2f2f 20px 30px,transparent 30px 50px,#2f2f2f 50px 60px,transparent 60px 80px,#2f2f2f 80px 90px,transparent 90px 110px,#2f2f2f 110px 120px,#c1c1c1 120px),linear-gradient(transparent 20px,#2f2f2f 20px 30px,transparent 30px 50px,#2f2f2f 50px 60px,transparent 60px 80px) #c1c1c1;top:94;left:50;width:260;height:80;border-radius:1in}p[b],p[c]{width:130;height:50}p[b]{top:89;left:180;border-radius:0 68px 0 1in}p[c]{top:129;left:180;border-radius:1in 0 68px}p[d]{top:124;left:310;width:40;height:20'
};


var $0b1abd89e6a0e6d8$export$2e2bcd8739ae039 = {
    id: 244,
    title: 'Target #244 - Medusa',
    url: 'https://cssbattle.dev/play/244',
    colors: [
        '#D9D9D9',
        '#222222'
    ],
    solution: '<p a><p b><p c><p d><p e><style>p[a],p[b]{top:44;background:#222}p[a],p[b],p[c]{background:#222}p[d],p[e]{background:#d9d9d9;width:30;height:10;top:134}body{background:#d9d9d9}p{position:fixed}p[a]{width:20;height:60;left:70;box-shadow:40px 0 #222,80px 0 #222,160px 0 #222,200px 0 #222,240px 0 #222}p[b]{width:40;height:20;left:50;box-shadow:60px 0 #222,180px 0 #222,260px 0 #222,40px 40px #222,220px 40px #222}p[c]{width:100;height:120;top:104;left:150;border-radius:0 0 1in 1in}p[d]{left:160;transform:rotate(15deg)}p[e]{left:210;transform:rotate(-15deg)'
};


var $dec53c49a769d318$export$2e2bcd8739ae039 = {
    id: 245,
    title: 'Target #245 - Knot',
    url: 'https://cssbattle.dev/play/245',
    colors: [
        '#FFFFFF',
        '#000000'
    ],
    solution: '<p a><p b><p c><style>p[b],p[c]{background:#000}p{position:fixed}p[a]{width:68;height:68;top:38;left:87;border:30px solid;border-radius:50%}p[b]{width:30;height:132;top:98;left:151;border:30px solid #fff;border-width:0 34px}p[c]{width:64;height:30;top:133;left:249'
};


var $debd2de40b5edd7d$export$2e2bcd8739ae039 = {
    id: 246,
    title: 'Target #246 - Limbs',
    url: 'https://cssbattle.dev/play/246',
    colors: [
        '#333333',
        '#EEEEEE'
    ],
    solution: '<p a><p b><p c><p d><style>p[a],p[b]{width:292;height:128;left:43}p[c],p[d]{width:64;height:99;left:107;border-style:solid;border-color:#333}body{background:#333}p{position:fixed;background:#eee}p[a]{top:19;border-radius:0 0 64px 64px}p[b]{top:127;border-radius:64px 64px 0 0}p[c]{top:-16;border-width:0 50px 44px}p[d]{top:147;border-width:44px 50px 0'
};


var $b5feda156c1f50e0$export$2e2bcd8739ae039 = {
    id: 247,
    title: 'Target #247 - LEDs',
    url: 'https://cssbattle.dev/play/247',
    colors: [
        '#606060',
        '#FFFFFF'
    ],
    solution: '<p><style>p{position:fixed;margin:0;top:10;left:10;width:40;height:40;background:#606060;border-radius:1in;box-shadow:85px 0 #606060,170px 0 #606060,0 60px #606060,0 120px #606060,0 180px #606060,0 240px #606060,85px 240px #606060,255px 0 #fff,340px 0 #fff,340px 60px #fff,340px 120px #fff,340px 180px #fff,170px 240px #fff,255px 240px #fff,340px 240px #fff}body{background:linear-gradient(90deg,#fff 200px,#606060 200px)'
};


var $7eb8e77c19ee61aa$export$2e2bcd8739ae039 = {
    id: 248,
    title: 'Target #248 - Bolt',
    url: 'https://cssbattle.dev/play/248',
    colors: [
        '#FFFFFF',
        '#444444'
    ],
    solution: '<p a><p b><p c><style>body,p[a],p[c]{background:#fff}p{position:fixed;margin:0}p[a]{top:25;left:75;width:210;height:210;border:20px solid #444;border-radius:9in}p[b]{top:65;left:130;width:140;height:170;background:conic-gradient(from 35deg at 70px 170px,transparent 290deg,#444 290deg);border-radius:9in 9in 0 0}p[c]{top:135;left:130;width:50;height:20;box-shadow:0 30px #fff,0 60px #fff,90px 0 #fff,90px 30px #fff,90px 60px #fff'
};


var $f66fcfe05d781e46$export$2e2bcd8739ae039 = {
    id: 249,
    title: 'Target #249 - Letter R',
    url: 'https://cssbattle.dev/play/249',
    colors: [
        '#2F2F2F',
        '#D9D9D9'
    ],
    solution: '<p a><p b><p c><style>body,p[a],p[b]{background:#2f2f2f}p[a],p[c]{bottom:20}p{position:fixed;margin:0}p[a]{right:2;width:258;height:150;border:60px solid #d9d9d9;border-radius:100px 0 0 100px;border-width:0 0 60px 60px}p[b]{top:20;left:20;width:160;height:40;border:60px solid #d9d9d9;border-radius:0 1in 1in 0;border-left-width:0}p[c]{left:20;width:60;height:100;background:#d9d9d9'
};


var $a1a79770c99be72a$export$2e2bcd8739ae039 = {
    id: 250,
    title: 'Target #250 - Recursion',
    url: 'https://cssbattle.dev/play/250',
    colors: [
        '#FFFFFF',
        '#000000'
    ],
    solution: '<p a><p b><p c><p d><p e><p f><p g><style>p[c],p[d]{left:160;width:80}p[b],p[d]{top:110;height:80}body,p[b],p[c],p[e],p[f]{background:#fff}p[f],p[g]{left:185;width:30}p[e],p[g]{top:135;height:30}p[a],p[d],p[g]{background:#000;border-radius:9in}p[a],p[b],p[c],p[d],p[e],p[f],p[g]{border-radius:9in}p{position:fixed;margin:0}p[a]{top:10;left:60;width:280;height:280}p[b]{left:70;width:260}p[c]{top:20;height:260}p[e]{left:165;width:70}p[f]{top:115;height:70'
};




const $2c529803354b598e$export$dbdde5c9dead09cb = $536c647c8b2ccf6a$exports;



var $44a44312232fffaa$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($44a44312232fffaa$exports) {
        classNames.default = classNames;
        $44a44312232fffaa$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $6eea037a8fdd80c5$exports = {};
$6eea037a8fdd80c5$exports = $parcel$resolve("EaZhy");


var $481c736bc9301749$export$9c30223ca0a664fb;
var $481c736bc9301749$export$db3c28d99448dcff;
$481c736bc9301749$export$9c30223ca0a664fb = `z9pn2q_link`;
$481c736bc9301749$export$db3c28d99448dcff = `z9pn2q_logo`;


function $1f5ddacaeec2229e$export$949fc9fafec6dbc5() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))('GitHubButton', $481c736bc9301749$export$9c30223ca0a664fb),
        href: "https://github.com/felipeog/cssbattle",
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
            className: $481c736bc9301749$export$db3c28d99448dcff,
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6eea037a8fdd80c5$exports))),
            alt: "GitHub logo",
            title: "felipeog/cssbattle"
        })
    });
}




var $bh6RR = parcelRequire("bh6RR");

const $e5f23bb6cf61d89e$export$4cbc7e4f2b68de3d = {
    WIDTH: 400,
    HEIGHT: 300
};





function $f8abbfb257bcffd0$export$b32b5f1ee4493319({ solution: solution, ...props }) {
    const html = `<style>body{overflow:hidden}</style>${solution}`;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("iframe", {
        src: 'data:text/html,' + encodeURIComponent(html),
        ...props
    });
}


var $5ffb9bb064d4bd64$export$8cde213409fd6377;
$5ffb9bb064d4bd64$export$8cde213409fd6377 = `_7qCLpG_iframe`;


function $873b468a7e9f74b3$export$60332b2344f7fe41({ target: target }) {
    const { id: id, solution: solution, title: title } = target;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        id: String(id),
        className: "Card",
        title: title,
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $f8abbfb257bcffd0$export$b32b5f1ee4493319), {
            className: $5ffb9bb064d4bd64$export$8cde213409fd6377,
            width: (0, $e5f23bb6cf61d89e$export$4cbc7e4f2b68de3d).WIDTH,
            height: (0, $e5f23bb6cf61d89e$export$4cbc7e4f2b68de3d).HEIGHT,
            solution: solution,
            title: title
        })
    });
}




var $05385bba8a0d60c0$export$34e0f9847d4c02dd;
$05385bba8a0d60c0$export$34e0f9847d4c02dd = `CO9FmW_container`;


function $9f3fc6f311b8f407$export$174fdf2bc79a4e74({ target: target, isInLastColumn: isInLastColumn, isInLastRow: isInLastRow }) {
    const { id: id, title: title } = target;
    function getBorderStyle() {
        return {
            ...isInLastColumn ? {
                borderRight: 'none'
            } : {},
            ...isInLastRow ? {
                borderBottom: 'none'
            } : {}
        };
    }
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
        id: String(id),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))('EmptyCard', $05385bba8a0d60c0$export$34e0f9847d4c02dd),
        style: getBorderStyle(),
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("p", {
            children: title
        })
    });
}


var $fbb068b6e3d3893c$export$8837f4fc672e936d;
$fbb068b6e3d3893c$export$8837f4fc672e936d = `_6BkHuG_list`;


function $5f50a61cc105a40c$export$54c2e3dc7acea9f5({ targets: targets }) {
    const debounceRef = (0, $bh6RR.useRef)();
    const [availableWidth, setAvailableWidth] = (0, $bh6RR.useState)(window.innerWidth);
    const columnsNumber = Math.floor(availableWidth / (0, $e5f23bb6cf61d89e$export$4cbc7e4f2b68de3d).WIDTH);
    function handleResize() {
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(()=>{
            setAvailableWidth(window.innerWidth);
        }, 100);
    }
    function getScalingStyle() {
        if (availableWidth < (0, $e5f23bb6cf61d89e$export$4cbc7e4f2b68de3d).WIDTH) {
            const scale = availableWidth / (0, $e5f23bb6cf61d89e$export$4cbc7e4f2b68de3d).WIDTH;
            return {
                height: targets.length * ((0, $e5f23bb6cf61d89e$export$4cbc7e4f2b68de3d).HEIGHT * scale),
                transform: `scale(${scale})`,
                transformOrigin: 'top left'
            };
        }
        const width = columnsNumber * (0, $e5f23bb6cf61d89e$export$4cbc7e4f2b68de3d).WIDTH;
        const scale = availableWidth / width;
        return {
            width: width,
            transform: `scale(${scale})`,
            transformOrigin: 'top left'
        };
    }
    function isInLastColumn(columnNumber) {
        if (columnsNumber <= 1) return true;
        return columnNumber % columnsNumber === 0;
    }
    function isInLastRow(rowNumber) {
        if (columnsNumber <= 1) return rowNumber === targets.length;
        const paddedRows = Math.ceil(targets.length / columnsNumber) * columnsNumber;
        return rowNumber > paddedRows - columnsNumber;
    }
    (0, $bh6RR.useEffect)(()=>{
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($44a44312232fffaa$exports)))('List', $fbb068b6e3d3893c$export$8837f4fc672e936d),
        style: getScalingStyle(),
        children: targets.map((target, index)=>{
            if (!target.solution) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9f3fc6f311b8f407$export$174fdf2bc79a4e74), {
                    isInLastColumn: isInLastColumn(index + 1),
                    isInLastRow: isInLastRow(index + 1),
                    target: target
                })
            }, target.id);
            return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $873b468a7e9f74b3$export$60332b2344f7fe41), {
                    target: target
                })
            }, target.id);
        })
    });
}


function $16e924f086a574be$export$86fbec116b87613f() {
    const targets = Object.values((0, $2c529803354b598e$export$dbdde5c9dead09cb));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("main", {
        className: "App",
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1f5ddacaeec2229e$export$949fc9fafec6dbc5), {}),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5f50a61cc105a40c$export$54c2e3dc7acea9f5), {
                targets: targets
            })
        ]
    });
}


$47cfd4084854a574$exports.render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $16e924f086a574be$export$86fbec116b87613f), {}), document.getElementById('root'));


//# sourceMappingURL=repo.86264a62.js.map
